export class Question {
    constructor(id, category, answerType, text, userText, emoji, options = () => []) {
      this.id = id;
      this.category = category;
      this.answerType = answerType;
      this.text = text;
      this.userText = userText;
      this.emoji = emoji;
      this.options = options;

    }
}

// BASIC
const basicQuestions = [
    new Question("b00", "basic", "text", lang => {
      switch (lang) {
        case "de": return "Wann ist mein Geburtstag?";
        case "fr": return "C'est quand mon anniversaire ?";
        case "es": return "¿Cuándo es mi cumpleaños?";
        case "pt": return "Quando é o meu aniversário?";
        case "ar": return "متى عيد ميلادي؟";
        case "ja": return "私の誕生日はいつですか？";
        case "ko": return "내 생일이 언제예요?";
        case "tr": return "Doğum günüm ne zaman?";
        case "it": return "Quando è il mio compleanno?";
        case "id": return "Kapan ulang tahunku?";
        case "ru": return "Когда у меня день рождения?";
        default: return "What's my birthday?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wann hat ${name} Geburtstag?`;
        case "fr": return `C'est quand l'anniversaire de ${name} ?`;
        case "es": return `¿Cuándo es el cumpleaños de ${name}?`;
        case "pt": return `Quando é o aniversário de ${name}?`;
        case "ar": return `متى عيد ميلاد ${name}؟`;
        case "ja": return `${name}の誕生日はいつですか？`;
        case "ko": return `${name}의 생일이 언제예요?`;
        case "tr": return `${name}’nin doğum günü ne zaman?`;
        case "it": return `Quando è il compleanno di ${name}?`;
        case "id": return `Kapan ulang tahun ${name}?`;
        case "ru": return `Когда день рождения у ${name}?`;
        default: return `What's ${name}'s birthday?`;
      }
    }, "🎈"),
    new Question("b01", "basic", "text", lang => {
      switch (lang) {
        case "de": return "Was ist meine Augenfarbe?";
        case "fr": return "Quelle est la couleur de mes yeux ?";
        case "es": return "¿De qué color son mis ojos?";
        case "pt": return "Qual é a cor dos meus olhos?";
        case "ar": return "ما هو لون عيني؟"
        case "ja": return "私の目の色は何ですか？"
        case "ko": return "내 눈 색깔은 뭐예요?"
        case "tr": return "Göz rengim ne?"
        case "it": return "Qual è il colore dei miei occhi?"
        case "id": return "Warna mataku apa?"
        case "ru": return "Какой у меня цвет глаз?"
        default: return "What's my eye color?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Augenfarbe?`;
        case "fr": return `Quelle est la couleur des yeux de ${name} ?`;
        case "es": return `¿De qué color son los ojos de ${name}?`;
        case "pt": return `Qual é a cor dos olhos de ${name}?`;
        case "ar": return `ما هو لون عيني ${name}؟`
        case "ja": return `${name}の目の色は何ですか？`
        case "ko": return `${name}의 눈 색깔은 무엇인가요?`
        case "tr": return `${name}’nin göz rengi ne?`
        case "it": return `Qual è il colore degli occhi di ${name}?`
        case "id": return `Warna mata ${name} apa?`
        case "ru": return `Какой цвет глаз у ${name}?`
        default: return `What's ${name}'s eye color?`;
      }
    }, "👀", lang => {
      switch (lang) {
        case "ar": return ["أزرق؟", "بني؟"];
        case "de": return ["Blau?", "Braun?"];
        case "fr": return ["Bleu ?", "Marron ?"];
        case "id": return ["Biru?", "Cokelat?"];
        case "it": return ["Blu?", "Marrone?"];
        case "ja": return ["青？", "茶色？"];
        case "ko": return ["파란색?", "갈색?"];
        case "pt": return ["Azul?", "Marrom?"];
        case "ru": return ["Синий?", "Коричневый?"];
        case "es": return ["¿Azul?", "¿Marrón?"];
        case "tr": return ["Mavi?", "Kahverengi?"];
        default: return ["Blue?", "Brown?"];
      }
    }),
    new Question("b02", "basic", "text", lang => {
      switch (lang) {
        case "de": return "Wie groß bin ich?";
        case "fr": return "Quelle est ma taille ?";
        case "es": return "¿Cuánto mido?";
        case "pt": return "Qual é a minha altura?";
        case "ar": return "كم طولي؟"
        case "ja": return "私の身長はどれくらいですか？"
        case "ko": return "내 키가 얼마나 되나요?"
        case "tr": return "Ben ne kadar uzunlukta?"
        case "it": return "Quanto sono alto?"
        case "id": return "Berapa tinggi saya?"
        case "ru": return "Какой у меня рост?"
        default: return "How tall am I?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wie groß ist ${name}?`;
        case "fr": return `Quelle est la taille de ${name} ?`
        case "es": return `¿Cuánto mide ${name}?`
        case "pt": return `Qual é a altura de ${name}?`
        case "ar": return `كم طول ${name}؟`
        case "ja": return `${name}の身長はどれくらいですか？`
        case "ko": return `${name}의 키가 얼마나 되나요?`
        case "tr": return `${name} ne kadar uzun?`
        case "it": return `Quanto è alto ${name}?`
        case "id": return `Berapa tinggi ${name}?`
        case "ru": return `Какой рост у ${name}?`
        default: return `How tall is ${name}?`;
      }
    }, "📏"),
    new Question("b03", "basic", "text", lang => {
      switch (lang) {
        case "de": return "Was ist meine Schuhgröße?";
        case "fr": return "Quelle est ma pointure ?";
        case "es": return "¿Cuál es mi número de zapato?";
        case "pt": return "Qual é o meu número de sapato?";
        case "ar": return "ما هو مقاس حذائي؟"
        case "ja": return "私の靴のサイズは何ですか？"
        case "ko": return "내 신발 사이즈는 뭐예요?"
        case "tr": return "Ayakkabı numaram ne?"
        case "it": return "Qual è la mia misura di scarpe?"
        case "id": return "Berapa ukuran sepatu saya?"
        case "ru": return "Какой у меня размер обуви?"
        default: return "What's my shoe size?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Schuhgröße?`;
        case "fr": return `Quelle est la pointure de ${name} ?`;
        case "es": return `¿Cuál es el número de zapato de ${name}?`;
        case "pt": return `Qual é o número de sapato de ${name}?`;
        case "ar": return `ما هو مقاس حذاء ${name}؟`
        case "ja": return `${name}の靴のサイズは何ですか？`
        case "ko": return `${name}의 신발 사이즈는 뭐예요?`
        case "tr": return `${name}‘nin ayakkabı numarası nedir?`
        case "it": return `Qual è la misura delle scarpe di ${name}?`
        case "id": return `Berapa ukuran sepatu ${name}?`
        case "ru": return `Какой размер обуви у ${name}?`
        default: return `What's ${name}'s shoe size?`;
      }
    }, "👟"),
    new Question("b04", "basic", "text", lang => {
      switch (lang) {
        case "de": return "Was ist mein Zweitname?";
        case "fr": return "Quel est mon deuxième prénom ?";
        case "es": return "¿Cuál es mi segundo nombre?";
        case "pt": return "Qual é o meu segundo nome?";
        case "ar": return "ما هو اسمي الأوسط؟"
        case "ja": return "私のミドルネームは何ですか？"
        case "ko": return "내 두 번째 이름은 무엇인가요?"
        case "tr": return "İkinci adım nedir?"
        case "it": return "Qual è il mio secondo nome?"
        case "id": return "Apa nama tengah saya?"
        case "ru": return "Какое у меня второе имя?"
        default: return "What's my middle name?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Zweitname?`;
        case "fr": return `Quel est le deuxième prénom de ${name} ?`;
        case "es": return `¿Cuál es el segundo nombre de ${name}?`;
        case "pt": return `Qual é o segundo nome de ${name}?`;
        case "ar": return `ما هو الاسم الأوسط لـ ${name}؟`
        case "ja": return `${name}のミドルネームは何ですか？`
        case "ko": return `${name}의 두 번째 이름은 무엇인가요?`
        case "tr": return `${name}‘nin ikinci adı nedir?`
        case "it": return `Qual è il secondo nome di ${name}?`
        case "id": return `Apa nama tengah ${name}?`
        case "ru": return `Какое второе имя у ${name}?`
        default: return `What's ${name}'s middle name?`;
      }
    }, "👤"),
    new Question("b05", "basic", "text", lang => {
      switch (lang) {
        case "de": return "Wie viele Geschwister habe ich?";
        case "fr": return "Combien de frères et sœurs ai-je ?";
        case "es": return "¿Cuántos hermanos tengo?";
        case "pt": return "Quantos irmãos eu tenho?";
        case "ar": return "كم عدد الأشقاء لدي؟"
        case "ja": return "兄弟姉妹は何人いますか？"
        case "ko": return "형제자매가 몇 명 있나요?"
        case "tr": return "Kaç kardeşim var?"
        case "it": return "Quanti fratelli e sorelle ho?"
        case "id": return "Berapa saudara yang saya miliki?"
        case "ru": return "Сколько у меня братьев и сестер?"
        default: return "How many siblings do I have?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wie viele Geschwister hat ${name}?`;
        case "fr": return `Combien de frères et sœurs a \(name) ?`;
        case "es": return `¿Cuántos hermanos tiene \(name)?`;
        case "pt": return `Quantos irmãos \(name) tem?`;
        case "ar": return `كم عدد الأشقاء لدى ${name}؟`
        case "ja": return `${name}には兄弟姉妹が何人いますか？`
        case "ko": return `${name}에게 형제자매가 몇 명 있나요?`
        case "tr": return `${name}’nin kaç kardeşi var?`
        case "it": return `Quanti fratelli e sorelle ha ${name}?`
        case "id": return `Berapa saudara yang dimiliki ${name}?`
        case "ru": return `Сколько братьев и сестер у ${name}?`
        default: return `How many siblings does ${name} have?`;
      }
    }, "🧑‍🧑‍🧒‍🧒", lang => {
      return ["1?", "2?"]
    }),
    new Question("b06", "basic", "text", lang => {
      switch (lang) {
        case "de": return "Wie heißt mein Haustier?";
        case "fr": return "Comment s'appelle mon animal de compagnie ?";
        case "es": return "¿Cómo se llama mi mascota?";
        case "pt": return "Qual é o nome do meu animal de estimação?";
        case "ar": return "ما اسم حيواني الأليف؟"
        case "ja": return "私のペットの名前は何ですか？"
        case "ko": return "내 반려동물 이름이 뭐예요?"
        case "tr": return "Evcil hayvanımın adı ne?"
        case "it": return "Come si chiama il mio animale domestico?"
        case "id": return "Siapa nama hewan peliharaanku?"
        case "ru": return "Как зовут моего питомца?"
        default: return "What's my pets name?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wie heißt ${name}s Haustier?`;
        case "fr": return `Comment s'appelle l'animal de compagnie de ${name} ?`;
        case "es": return `¿Cómo se llama la mascota de ${name}?`;
        case "pt": return `Qual é o nome do animal de estimação de ${name}?`;
        case "ar": return `ما اسم حيوان ${name} الأليف؟`
        case "ja": return `${name}のペットの名前は何ですか？`
        case "ko": return `${name}의 반려동물 이름은 뭐예요?`
        case "tr": return `${name}‘nin evcil hayvanının adı ne?`
        case "it": return `Come si chiama l'animale domestico di ${name}?`
        case "id": return `Siapa nama hewan peliharaan ${name}?`
        case "ru": return `Как зовут питомца ${name}?`
        default: return `What's ${name}'s pets name?`;
      }
    }, "🐶"),
    new Question("b07", "basic", "text", lang => {
      switch (lang) {
        case "de": return "Was ist meine Lieblingsfarbe?";
        case "fr": return "Quelle est ma couleur préférée ?";
        case "es": return "¿Cuál es mi color favorito?";
        case "pt": return "Qual é a minha cor favorita?";
        case "ar": return "ما هو لوني المفضل؟"
        case "ja": return "私の好きな色は何ですか？"
        case "ko": return "내가 좋아하는 색깔은 무엇인가요?"
        case "tr": return "Favori rengim nedir?"
        case "it": return "Qual è il mio colore preferito?"
        case "id": return "Apa warna favorit saya?"
        case "ru": return "Какой мой любимый цвет?"
        default: return "What's my favorite color?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Lieblingsfarbe?`;
        case "fr": return `Quelle est la couleur préférée de ${name} ?`;
        case "es": return `¿Cuál es el color favorito de ${name}?`;
        case "pt": return `Qual é a cor favorita de ${name}?`;
        case "ar": return `ما هو اللون المفضل لدى ${name}؟`
        case "ja": return `${name}の好きな色は何ですか？`
        case "ko": return `${name}의 좋아하는 색깔은 무엇인가요?`
        case "tr": return `${name}’nin favori rengi nedir?`
        case "it": return `Qual è il colore preferito di ${name}?`
        case "id": return `Apa warna favorit ${name}?`
        case "ru": return `Какой любимый цвет у ${name}?`
        default: return `What's ${name}'s favorite color?`;
      }
    }, "🎨", lang => {
      switch (lang) {
        case "ar": return ["أزرق؟", "أحمر؟"];
        case "de": return ["Blau?", "Rot?"];
        case "fr": return ["Bleu ?", "Rouge ?"];
        case "id": return ["Biru?", "Merah?"];
        case "it": return ["Blu?", "Rosso?"];
        case "ja": return ["青？", "赤？"];
        case "ko": return ["파란색?", "빨간색?"];
        case "pt": return ["Azul?", "Vermelho?"];
        case "ru": return ["Синий?", "Красный?"];
        case "es": return ["¿Azul?", "¿Rojo?"];
        case "tr": return ["Mavi?", "Kırmızı?"];
        default: return ["Blue?", "Red?"];
      }
    }),
    new Question("b08", "basic", "text", lang => {
      switch (lang) {
        case "de": return "Wie viele Sprachen spreche ich?";
        case "fr": return "Combien de langues je parle ?";
        case "es": return "¿Cuántos idiomas hablo?";
        case "pt": return "Quantos idiomas eu falo?";
        case "ar": return "كم عدد اللغات التي أتحدثها؟"
        case "ja": return "私は何カ国語話せますか？"
        case "ko": return "내가 할 수 있는 언어는 몇 개인가요?"
        case "tr": return "Kaç dil konuşuyorum?"
        case "it": return "Quante lingue parlo?"
        case "id": return "Berapa bahasa yang saya bisa?"
        case "ru": return "На скольких языках я говорю?"
        default: return "How many languages do I speak?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wie viele Sprachen spricht ${name}?`;
        case "fr": return `Combien de langues parle ${name} ?`;
        case "es": return `¿Cuántos idiomas habla ${name}?`;
        case "pt": return `Quantos idiomas ${name} fala?`;
        case "ar": return `كم عدد اللغات التي يتحدثها ${name}؟`
        case "ja": return `${name}は何カ国語話しますか？`
        case "ko": return `${name}은/는 몇 개의 언어를 말하나요?`
        case "tr": return `${name} kaç dil konuşuyor?`
        case "it": return `Quante lingue parla ${name}?`
        case "id": return `Berapa bahasa yang bisa dituturkan ${name}?`
        case "ru": return `На скольких языках говорит ${name}?`
        default: return `How many languages does ${name} speak?`;
      }
    }, "🌎", lang => {
      return ["2?", "3?"]
    }),
    new Question("b09", "basic", "text", lang => {
      switch (lang) {
        case "de": return "Wie oft bin ich umgezogen?";
        case "fr": return "Combien de fois ai-je déménagé ?";
        case "es": return "¿Cuántas veces me he mudado?";
        case "pt": return "Quantas vezes eu me mudei?";
        case "ar": return "كم مرة انتقلت من منزل إلى آخر؟"
        case "ja": return "何回引っ越しましたか？"
        case "ko": return "몇 번 이사했나요?"
        case "tr": return "Kaç kere taşındım?"
        case "it": return "Quante volte mi sono trasferito?"
        case "id": return "Berapa kali saya pindah rumah?"
        case "ru": return "Сколько раз я переезжал?"
        default: return "How many times did I move houses?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wie oft ist ${name} umgezogen?`;
        case "fr": return `Combien de fois ${name} a déménagé ?`;
        case "es": return `¿Cuántas veces se ha mudado ${name}?`;
        case "pt": return `Quantas vezes ${name} se mudou?`;
        case "ar": return `كم مرة انتقل ${name} من منزل إلى آخر؟`
        case "ja": return `${name}は何回引っ越しましたか？`
        case "ko": return `${name}은/는 몇 번 이사했나요?`
        case "tr": return `${name} kaç kere taşındı?`
        case "it": return `Quante volte si è trasferito ${name}?`
        case "id": return `Berapa kali ${name} pindah rumah?`
        case "ru": return `Сколько раз ${name} переезжал?`
        default: return `How many times did ${name} move houses?`;
      }
    }, "🏡", lang => {
      return ["1?", "2?"]
    }),
  ];
  
  // FAVORITES
  const favoriteQuestions = [
    new Question("f00", "favorites", "text", lang => {
      switch (lang) {
        case "de": return "Was ist mein Lieblingsessen?";
        case "fr": return "Quel est mon plat préféré ?";
        case "es": return "¿Cuál es mi comida favorita?";
        case "pt": return "Qual é a minha comida favorita?";
        case "ar": return "ما هو طعامي المفضل؟";
        case "ja": return "私の好きな食べ物は何ですか？";
        case "ko": return "내가 좋아하는 음식은 무엇인가요?";
        case "tr": return "En sevdiğim yemek nedir?";
        case "it": return "Qual è il mio cibo preferito?";
        case "id": return "Apa makanan favorit saya?";
        case "ru": return "Какая моя любимая еда?";
        default: return "What's my favorite food?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Lieblingsessen?`;
        case "fr": return `Quel est le plat préféré de ${name} ?`;
        case "es": return `¿Cuál es la comida favorita de ${name}?`;
        case "pt": return `Qual é a comida favorita de ${name}?`;
        case "ar": return `ما هو الطعام المفضل لدى ${name}؟`;
        case "ja": return `${name}の好きな食べ物は何ですか？`;
        case "ko": return `${name}이/가 좋아하는 음식은 무엇인가요?`;
        case "tr": return `${name}’nin en sevdiği yemek nedir?`;
        case "it": return `Qual è il cibo preferito di ${name}?`;
        case "id": return `Apa makanan favorit ${name}?`;
        case "ru": return `Какая любимая еда у ${name}?`;
        default: return `What's ${name}'s favorite food?`;
      }
    }, "🍔", lang => {
      return ["Pizza?", "Burger?"]
    }),
    
    new Question("f01", "favorites", "text", lang => {
      switch (lang) {
        case "de": return "Was ist mein Lieblingsgetränk?";
        case "fr": return "Quelle est ma boisson préférée ?";
        case "es": return "¿Cuál es mi bebida favorita?";
        case "pt": return "Qual é a minha bebida favorita?";
        case "ar": return "ما هو مشروبي المفضل؟";
        case "ja": return "私の好きな飲み物は何ですか？";
        case "ko": return "내가 좋아하는 음료는 무엇인가요?";
        case "tr": return "En sevdiğim içecek nedir?";
        case "it": return "Qual è la mia bevanda preferita?";
        case "id": return "Apa minuman favorit saya?";
        case "ru": return "Какой мой любимый напиток?";
        default: return "What's my favorite drink?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Lieblingsgetränk?`;
        case "fr": return `Quelle est la boisson préférée de ${name} ?`;
        case "es": return `¿Cuál es la bebida favorita de ${name}?`;
        case "pt": return `Qual é a bebida favorita de ${name}?`;
        case "ar": return `ما هو المشروب المفضل لدى ${name}؟`;
        case "ja": return `${name}の好きな飲み物は何ですか？`;
        case "ko": return `${name}이/가 좋아하는 음료는 무엇인가요?`;
        case "tr": return `${name}’nin en sevdiği içecek nedir?`;
        case "it": return `Qual è la bevanda preferita di ${name}?`;
        case "id": return `Apa minuman favorit ${name}?`;
        case "ru": return `Какой любимый напиток у ${name}?`;
        default: return `What's ${name}'s favorite drink?`;
      }
    }, "🥤"),
    
    new Question("f02", "favorites", "text", lang => {
      switch (lang) {
        case "de": return "Wer ist mein Lieblingskünstler?";
        case "fr": return "Quel est mon artiste préféré ?";
        case "es": return "¿Quién es mi artista favorito?";
        case "pt": return "Quem é o meu artista favorito?";
        case "ar": return "من هو فني المفضل؟";
        case "ja": return "私の好きなアーティストは誰ですか？";
        case "ko": return "내가 좋아하는 아티스트는 누구인가요?";
        case "tr": return "En sevdiğim sanatçı kim?";
        case "it": return "Chi è il mio artista preferito?";
        case "id": return "Siapa artis favorit saya?";
        case "ru": return "Кто мой любимый артист?";
        default: return "Who's my favorite artist?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wer ist ${name}s Lieblingskünstler?`;
        case "fr": return `Quel est l'artiste préféré de ${name} ?`;
        case "es": return `¿Quién es el artista favorito de ${name}?`;
        case "pt": return `Quem é o artista favorito de ${name}?`;
        case "ar": return `من هو الفنان المفضل لدى ${name}؟`;
        case "ja": return `${name}の好きなアーティストは誰ですか？`;
        case "ko": return `${name}이/가 좋아하는 아티스트는 누구인가요?`;
        case "tr": return `${name}’nin en sevdiği sanatçı kim?`;
        case "it": return `Chi è l'artista preferito di ${name}?`;
        case "id": return `Siapa artis favorit ${name}?`;
        case "ru": return `Кто любимый артист у ${name}?`;
        default: return `Who's ${name}'s favorite artist?`;
      }
    }, "🎤"),
    
    new Question("f03", "favorites", "text", lang => {
      switch (lang) {
        case "de": return "Was ist mein Lieblingsfilm?";
        case "fr": return "Quel est mon film préféré ?";
        case "es": return "¿Cuál es mi película favorita?";
        case "pt": return "Qual é o meu filme favorito?";
        case "ar": return "ما هو فيلمي المفضل؟";
        case "ja": return "私の好きな映画は何ですか？";
        case "ko": return "내가 좋아하는 영화는 무엇인가요?";
        case "tr": return "En sevdiğim film nedir?";
        case "it": return "Qual è il mio film preferito?";
        case "id": return "Apa film favorit saya?";
        case "ru": return "Какой мой любимый фильм?";
        default: return "What's my favorite movie?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Lieblingsfilm?`;
        case "fr": return `Quel est le film préféré de ${name} ?`;
        case "es": return `¿Cuál es la película favorita de ${name}?`;
        case "pt": return `Qual é o filme favorito de ${name}?`;
        case "ar": return `ما هو الفيلم المفضل لدى ${name}؟`;
        case "ja": return `${name}の好きな映画は何ですか？`;
        case "ko": return `${name}이/가 좋아하는 영화는 무엇인가요?`;
        case "tr": return `${name}’nin en sevdiği film nedir?`;
        case "it": return `Qual è il film preferito di ${name}?`;
        case "id": return `Apa film favorit ${name}?`;
        case "ru": return `Какой любимый фильм у ${name}?`;
        default: return `What's ${name}'s favorite movie?`;
      }
    }, "🎬"),
    
    new Question("f04", "favorites", "text", lang => {
      switch (lang) {
        case "de": return "Was ist meine Lieblingsserie?";
        case "fr": return "Quelle est ma série préférée ?";
        case "es": return "¿Cuál es mi serie favorita?";
        case "pt": return "Qual é a minha série favorita?";
        case "ar": return "ما هي سلسلتي المفضلة؟";
        case "ja": return "私の好きなドラマは何ですか？";
        case "ko": return "내가 좋아하는 TV 시리즈는 무엇인가요?";
        case "tr": return "En sevdiğim dizi nedir?";
        case "it": return "Qual è la mia serie preferita?";
        case "id": return "Apa serial favorit saya?";
        case "ru": return "Какой мой любимый сериал?";
        default: return "What's my favorite TV show?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Lieblingsserie?`;
        case "fr": return `Quelle est la série préférée de ${name} ?`;
        case "es": return `¿Cuál es la serie favorita de ${name}?`;
        case "pt": return `Qual é a série favorita de ${name}?`;
        case "ar": return `ما هي السلسلة المفضلة لدى ${name}؟`;
        case "ja": return `${name}の好きなドラマは何ですか？`;
        case "ko": return `${name}이/가 좋아하는 TV 시리즈는 무엇인가요?`;
        case "tr": return `${name}’nin en sevdiği dizi nedir?`;
        case "it": return `Qual è la serie preferita di ${name}?`;
        case "id": return `Apa serial favorit ${name}?`;
        case "ru": return `Какой любимый сериал у ${name}?`;
        default: return `What's ${name}'s favorite TV show?`;
      }
    }, "📺"),
    
    new Question("f05", "favorites", "text", lang => {
      switch (lang) {
        case "de": return "Wer ist mein Lieblingssportler?";
        case "fr": return "Quel est mon athlète préféré ?";
        case "es": return "¿Quién es mi deportista favorito?";
        case "pt": return "Quem é o meu atleta favorito?";
        case "ar": return "من هو الرياضي المفضل لدي؟";
        case "ja": return "私の好きなスポーツ選手は誰ですか？";
        case "ko": return "내가 좋아하는 운동선수는 누구인가요?";
        case "tr": return "En sevdiğim sporcu kim?";
        case "it": return "Chi è il mio atleta preferito?";
        case "id": return "Siapa atlet favorit saya?";
        case "ru": return "Кто мой любимый спортсмен?";
        default: return "Who's my favorite athlete?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wer ist ${name}s Lieblingssportler?`;
        case "fr": return `Quel est l'athlète préféré de ${name} ?`;
        case "es": return `¿Quién es el deportista favorito de ${name}?`;
        case "pt": return `Quem é o atleta favorito de ${name}?`;
        case "ar": return `من هو الرياضي المفضل لدى ${name}؟`;
        case "ja": return `${name}の好きなスポーツ選手は誰ですか？`;
        case "ko": return `${name}이/가 좋아하는 운동선수는 누구인가요?`;
        case "tr": return `${name}’nin en sevdiği sporcu kim?`;
        case "it": return `Chi è l'atleta preferito di ${name}?`;
        case "id": return `Siapa atlet favorit ${name}?`;
        case "ru": return `Кто любимый спортсмен у ${name}?`;
        default: return `Who's ${name}'s favorite athlete?`;
      }
    }, "🐐"),
    
    new Question("f06", "favorites", "text", lang => {
      switch (lang) {
        case "de": return "Was ist mein Lieblingsteam?";
        case "fr": return "Quelle est mon équipe préférée ?";
        case "es": return "¿Cuál es mi equipo favorito?";
        case "pt": return "Qual é o meu time favorito?";
        case "ar": return "ما هو فريقي المفضل؟";
        case "ja": return "私の好きなチームは何ですか？";
        case "ko": return "내가 좋아하는 팀은 무엇인가요?";
        case "tr": return "En sevdiğim takım nedir?";
        case "it": return "Qual è la mia squadra preferita?";
        case "id": return "Apa tim favorit saya?";
        case "ru": return "Какая моя любимая команда?";
        default: return "What's my favorite sports team?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Lieblingsteam?`;
        case "fr": return `Quelle est l'équipe préférée de ${name} ?`;
        case "es": return `¿Cuál es el equipo favorito de ${name}?`;
        case "pt": return `Qual é o time favorito de ${name}?`;
        case "ar": return `ما هو الفريق المفضل لدى ${name}؟`;
        case "ja": return `${name}の好きなチームは何ですか？`;
        case "ko": return `${name}이/가 좋아하는 팀은 무엇인가요?`;
        case "tr": return `${name}’nin en sevdiği takım nedir?`;
        case "it": return `Qual è la squadra preferita di ${name}?`;
        case "id": return `Apa tim favorit ${name}?`;
        case "ru": return `Какая любимая команда у ${name}?`;
        default: return `What's ${name}'s sports team?`;
      }
    }, "⚽️"),
    
    new Question("f07", "favorites", "text", lang => {
      switch (lang) {
        case "de": return "Was ist mein Lieblingsschulfach?";
        case "fr": return "Quelle est ma matière préférée ?";
        case "es": return "¿Cuál es mi asignatura favorita?";
        case "pt": return "Qual é a minha matéria favorita?";
        case "ar": return "ما هو مادتي الدراسية المفضلة؟";
        case "ja": return "私の好きな教科は何ですか？";
        case "ko": return "내가 좋아하는 과목은 무엇인가요?";
        case "tr": return "En sevdiğim okul dersi nedir?";
        case "it": return "Qual è la mia materia preferita?";
        case "id": return "Apa mata pelajaran favorit saya?";
        case "ru": return "Какой мой любимый школьный предмет?";
        default: return "What's my favorite school subject?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Lieblingsschulfach?`;
        case "fr": return `Quelle est la matière préférée de ${name} ?`;
        case "es": return `¿Cuál es la asignatura favorita de ${name}?`;
        case "pt": return `Qual é a matéria favorita de ${name}?`;
        case "ar": return `ما هي المادة الدراسية المفضلة لدى ${name}؟`;
        case "ja": return `${name}の好きな教科は何ですか？`;
        case "ko": return `${name}이/가 좋아하는 과목은 무엇인가요?`;
        case "tr": return `${name}’nin en sevdiği okul dersi nedir?`;
        case "it": return `Qual è la materia preferita di ${name}?`;
        case "id": return `Apa mata pelajaran favorit ${name}?`;
        case "ru": return `Какой любимый школьный предмет у ${name}?`;
        default: return `What's ${name}'s favorite school subject?`;
      }
    }, "📚"),
    
    new Question("f08", "favorites", "text", lang => {
      switch (lang) {
        case "de": return "Was ist meine Lieblingsmodemarke?";
        case "fr": return "Quelle est ma marque de vêtements préférée ?";
        case "es": return "¿Cuál es mi marca de ropa favorita?";
        case "pt": return "Qual é a minha marca de roupa favorita?";
        case "ar": return "ما هي ماركة الملابس المفضلة لدي؟";
        case "ja": return "私の好きなファッションブランドは何ですか？";
        case "ko": return "내가 좋아하는 의류 브랜드는 무엇인가요?";
        case "tr": return "En sevdiğim giyim markası nedir?";
        case "it": return "Qual è il mio marchio di moda preferito?";
        case "id": return "Apa merek pakaian favorit saya?";
        case "ru": return "Какая моя любимая марка одежды?";
        default: return "What's my favorite clothing brand?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Lieblingsmarke?`;
        case "fr": return `Quelle est la marque de vêtements préférée de ${name} ?`;
        case "es": return `¿Cuál es la marca de ropa favorita de ${name}?`;
        case "pt": return `Qual é a marca de roupa favorita de ${name}?`;
        case "ar": return `ما هي ماركة الملابس المفضلة لدى ${name}؟`;
        case "ja": return `${name}の好きなファッションブランドは何ですか？`;
        case "ko": return `${name}이/가 좋아하는 의류 브랜드는 무엇인가요?`;
        case "tr": return `${name}’nin en sevdiği giyim markası nedir?`;
        case "it": return `Qual è il marchio di moda preferito di ${name}?`;
        case "id": return `Apa merek pakaian favorit ${name}?`;
        case "ru": return `Какая любимая марка одежды у ${name}?`;
        default: return `What's ${name}'s favorite clothing brand?`;
      }
    }, "👕"),
    
    new Question("f09", "favorites", "text", lang => {
      switch (lang) {
        case "de": return "Was ist mein Lieblingsurlaubsziel?";
        case "fr": return "Quelle est ma destination de vacances préférée ?";
        case "es": return "¿Cuál es mi destino de vacaciones favorito?";
        case "pt": return "Qual é o meu destino de férias favorito?";
        case "ar": return "ما هي وجهة عطلتي المفضلة؟";
        case "ja": return "私の好きな旅行先はどこですか？";
        case "ko": return "내가 좋아하는 여행지는 어디인가요?";
        case "tr": return "En sevdiğim tatil yeri neresi?";
        case "it": return "Qual è la mia destinazione di vacanza preferita?";
        case "id": return "Apa tujuan liburan favorit saya?";
        case "ru": return "Какое мое любимое место для отдыха?";
        default: return "What's my favorite vacation destination?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Lieblingsurlaubsziel?`;
        case "fr": return `Quelle est la destination de vacances préférée de ${name} ?`;
        case "es": return `¿Cuál es el destino de vacaciones favorito de ${name}?`;
        case "pt": return `Qual é o destino de férias favorito de ${name}?`;
        case "ar": return `ما هي وجهة العطلة المفضلة لدى ${name}؟`;
        case "ja": return `${name}の好きな旅行先はどこですか？`;
        case "ko": return `${name}이/가 좋아하는 여행지는 어디인가요?`;
        case "tr": return `${name}’nin en sevdiği tatil yeri neresi?`;
        case "it": return `Qual è la destinazione di vacanza preferita di ${name}?`;
        case "id": return `Apa tujuan liburan favorit ${name}?`;
        case "ru": return `Какое любимое место для отдыха у ${name}?`;
        default: return `What's ${name}'s favorite vacation destination?`;
      }
    }, "🏝️"),
  ];
  
  // DIGITAL
  const digitalQuestions = [
    new Question("d00", "digital", "text", lang => {
      switch (lang) {
        case "de": return "Wie heiße ich auf Instagram?";
        case "fr": return "Quel est mon pseudo Instagram ?";
        case "es": return "¿Cuál es mi nombre en Instagram?";
        case "pt": return "Qual é o meu nome no Instagram?";
        case "ar": return "ما هو اسمي على إنستغرام؟";
        case "ja": return "私のインスタグラムの名前は？";
        case "ko": return "내 인스타그램 아이디는 무엇인가요?";
        case "tr": return "Instagram kullanıcı adım nedir?";
        case "it": return "Qual è il mio nome su Instagram?";
        case "id": return "Siapa nama saya di Instagram?";
        case "ru": return "Какое у меня имя в Инстаграме?";
        default: return "What's my Instagram handle?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wie heißt ${name} auf Instagram?`;
        case "fr": return `Quel est le pseudo Instagram de ${name} ?`;
        case "es": return `¿Cuál es el nombre de Instagram de ${name}?`;
        case "pt": return `Qual é o nome de Instagram de ${name}?`;
        case "ar": return `ما هو اسم ${name} على إنستغرام؟`;
        case "ja": return `${name}のインスタグラムの名前は？`;
        case "ko": return `${name}의 인스타그램 아이디는 무엇인가요?`;
        case "tr": return `${name}ʼnin Instagram kullanıcı adı nedir?`;
        case "it": return "Qual è il nome Instagram di " + name + "?";
        case "id": return `Siapa nama Instagram ${name}?`;
        case "ru": return `Какое имя у ${name} в Инстаграме?`;
        default: return `What's ${name}'s Instagram handle?`;
      }
    }, "🔗"),
    
    new Question("d01", "digital", "text", lang => {
      switch (lang) {
        case "de": return "Was für ein Handy habe ich?";
        case "fr": return "Quel téléphone j'ai ?";
        case "es": return "¿Qué teléfono tengo?";
        case "pt": return "Qual celular eu tenho?";
        case "ar": return "ما نوع هاتفي؟";
        case "ja": return "私の携帯電話は何ですか？";
        case "ko": return "내 휴대폰은 무엇인가요?";
        case "tr": return "Hangi telefonu kullanıyorum?";
        case "it": return "Che telefono ho?";
        case "id": return "Saya punya ponsel apa?";
        case "ru": return "Какой у меня телефон?";
        default: return "What phone do I have?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was für ein Handy hat ${name}?`;
        case "fr": return `Quel téléphone a ${name} ?`;
        case "es": return `¿Qué teléfono tiene ${name}?`;
        case "pt": return `Qual celular ${name} tem?`;
        case "ar": return `ما نوع هاتف ${name}؟`;
        case "ja": return `${name}の携帯電話は何ですか？`;
        case "ko": return `${name}의 휴대폰은 무엇인가요?`;
        case "tr": return `${name} hangi telefonu kullanıyor?`;
        case "it": return `Che telefono ha ${name}?`;
        case "id": return `Ponsel apa yang dimiliki ${name}?`;
        case "ru": return `Какой телефон у ${name}?`;
        default: return `What phone does ${name} have?`;
      }
    }, "📱"),
    
    new Question("d02", "digital", "text", lang => {
      switch (lang) {
        case "de": return "Was ist meine meistgenutzte App?";
        case "fr": return "Quelle est mon application la plus utilisée ?";
        case "es": return "¿Cuál es mi aplicación más usada?";
        case "pt": return "Qual é o meu aplicativo mais usado?";
        case "ar": return "ما هو تطبيقي الأكثر استخدامًا؟";
        case "ja": return "私が最も使うアプリは何ですか？";
        case "ko": return "내가 가장 많이 사용하는 앱은 무엇인가요?";
        case "tr": return "En çok kullandığım uygulama nedir?";
        case "it": return "Qual è la mia app più usata?";
        case "id": return "Apa aplikasi yang paling sering saya gunakan?";
        case "ru": return "Какое мое самое используемое приложение?";
        default: return "What's my most used app?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s meistgenutzte App?`;
        case "fr": return `Quelle est l'application la plus utilisée de ${name} ?`;
        case "es": return `¿Cuál es la aplicación más usada de ${name}?`;
        case "pt": return `Qual é o aplicativo mais usado de ${name}?`;
        case "ar": return `ما هو التطبيق الأكثر استخدامًا لدى ${name}؟`;
        case "ja": return `${name}が最も使うアプリは何ですか？`;
        case "ko": return `${name}이/가 가장 많이 사용하는 앱은 무엇인가요?`;
        case "tr": return `${name}ʼnin en çok kullandığı uygulama nedir?`;
        case "it": return `Qual è l'app più usata di ${name}?`;
        case "id": return `Apa aplikasi yang paling sering digunakan ${name}?`;
        case "ru": return `Какое приложение чаще всего использует ${name}?`;
        default: return `What's ${name}'s most used app?`;
      }
    }, "📲"),
    
    new Question("d03", "digital", "text", lang => {
      switch (lang) {
        case "de": return "Was ist mein Handy-Hintergrundbild?";
        case "fr": return "Quelle est mon image de fond d'écran ?";
        case "es": return "¿Cuál es mi fondo de pantalla?";
        case "pt": return "Qual é o meu papel de parede?";
        case "ar": return "ما هي خلفية هاتفي؟";
        case "ja": return "私の携帯の壁紙は何ですか？";
        case "ko": return "내 휴대폰 배경화면은 무엇인가요?";
        case "tr": return "Telefonumun duvar kağıdı nedir?";
        case "it": return "Qual è il mio sfondo del telefono?";
        case "id": return "Apa wallpaper ponsel saya?";
        case "ru": return "Какой у меня обои на телефоне?";
        default: return "What's on my phone wallpaper?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Handy-Hintergrundbild?`;
        case "fr": return `Quelle est l'image de fond d'écran de ${name} ?`;
        case "es": return `¿Cuál es el fondo de pantalla de ${name}?`;
        case "pt": return `Qual é o papel de parede de ${name}?`;
        case "ar": return `ما هي خلفية هاتف ${name}؟`;
        case "ja": return `${name}の携帯の壁紙は何ですか？`;
        case "ko": return `${name}의 휴대폰 배경화면은 무엇인가요?`;
        case "tr": return `${name}ʼnin telefon duvar kağıdı nedir?`;
        case "it": return `Qual è lo sfondo del telefono di ${name}?`;
        case "id": return `Apa wallpaper ponsel ${name}?`;
        case "ru": return `Какие обои на телефоне у ${name}?`;
        default: return `What's on ${name}'s phone wallpaper?`;
      }
    }, "📸"),
    
    new Question("d04", "digital", "text", lang => {
      switch (lang) {
        case "de": return "Wie hoch ist meine Bildschirmzeit?";
        case "fr": return "Combien de temps d'écran ai-je par jour ?";
        case "es": return "¿Cuánto es mi tiempo de pantalla diario?";
        case "pt": return "Qual é o meu tempo diário de tela?";
        case "ar": return "كم مدة استخدامي للشاشة يوميًا؟";
        case "ja": return "私の1日のスクリーンタイムは？";
        case "ko": return "내 하루 화면 사용 시간은?";
        case "tr": return "Günlük ekran sürem ne kadar?";
        case "it": return "Quanto è il mio tempo di utilizzo dello schermo?";
        case "id": return "Berapa lama waktu layar harian saya?";
        case "ru": return "Сколько у меня времени использования экрана в день?";
        default: return "What's my daily screen time?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wie hoch ist ${name}s Bildschirmzeit?`;
        case "fr": return `Quel est le temps d'écran quotidien de ${name} ?`;
        case "es": return `¿Cuál es el tiempo de pantalla diario de ${name}?`;
        case "pt": return `Qual é o tempo diário de tela de ${name}?`;
        case "ar": return `كم مدة استخدام الشاشة اليومية لدى ${name}؟`;
        case "ja": return `${name}の1日のスクリーンタイムは？`;
        case "ko": return `${name}의 하루 화면 사용 시간은?`;
        case "tr": return `${name}ʼnin günlük ekran süresi ne kadar?`;
        case "it": return `Quanto è il tempo di utilizzo dello schermo di ${name}?`;
        case "id": return `Berapa lama waktu layar harian ${name}?`;
        case "ru": return `Какое ежедневное время использования экрана у ${name}?`;
        default: return `What's ${name}'s daily screen time?`;
      }
    }, "⏱️"),
    
    new Question("d05", "digital", "text", lang => {
      switch (lang) {
        case "de": return "Was ist mein meistgenutzter Emoji?";
        case "fr": return "Quel est mon emoji le plus utilisé ?";
        case "es": return "¿Cuál es mi emoji más usado?";
        case "pt": return "Qual é o meu emoji mais usado?";
        case "ar": return "ما هو الإيموجي الذي أستخدمه أكثر؟";
        case "ja": return "私が最も使う絵文字は？";
        case "ko": return "내가 가장 많이 쓰는 이모지는?";
        case "tr": return "En çok kullandığım emoji nedir?";
        case "it": return "Qual è la mia emoji più usata?";
        case "id": return "Apa emoji yang paling sering saya gunakan?";
        case "ru": return "Какой мой самый часто используемый эмодзи?";
        default: return "What's my most used emoji?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s meistgenutzter Emoji?`;
        case "fr": return `Quel est l'emoji le plus utilisé de ${name} ?`;
        case "es": return `¿Cuál es el emoji más usado de ${name}?`;
        case "pt": return `Qual é o emoji mais usado de ${name}?`;
        case "ar": return `ما هو أكثر إيموجي يستخدمه ${name}؟`;
        case "ja": return `${name}が最も使う絵文字は？`;
        case "ko": return `${name}이/가 가장 많이 쓰는 이모지는?`;
        case "tr": return `${name}ʼnin en çok kullandığı emoji nedir?`;
        case "it": return `Qual è l'emoji più usata di ${name}?`;
        case "id": return `Apa emoji yang paling sering digunakan ${name}?`;
        case "ru": return `Какой эмодзи чаще всего использует ${name}?`;
        default: return `What's ${name}'s most used emoji?`;
      }
    }, "🙃"),
    
    new Question("d06", "digital", "text", lang => {
      switch (lang) {
        case "de": return "Benutze ich Light oder Dark Mode?";
        case "fr": return "Est-ce que j'utilise le mode clair ou sombre ?";
        case "es": return "¿Uso modo claro o modo oscuro?";
        case "pt": return "Uso modo claro ou modo escuro?";
        case "ar": return "هل أستخدم الوضع الفاتح أم الداكن؟";
        case "ja": return "ライトモードとダークモードのどちらを使っていますか？";
        case "ko": return "라이트 모드와 다크 모드 중 어떤 걸 쓰나요?";
        case "tr": return "Açık mod mu koyu mod mu kullanıyorum?";
        case "it": return "Uso la modalità chiara o scura?";
        case "id": return "Apakah saya menggunakan mode terang atau gelap?";
        case "ru": return "Я использую светлый или темный режим?";
        default: return "Do I use light or dark mode?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Benutzt ${name} Light oder Dark Mode?`;
        case "fr": return `Est-ce que ${name} utilise le mode clair ou sombre ?`;
        case "es": return `¿${name} usa modo claro o modo oscuro?`;
        case "pt": return `${name} usa modo claro ou modo escuro?`;
        case "ar": return `هل يستخدم ${name} الوضع الفاتح أم الداكن؟`;
        case "ja": return `${name}はライトモードとダークモードのどちらを使っていますか？`;
        case "ko": return `${name}이/가 라이트 모드와 다크 모드 중 어떤 걸 쓰나요?`;
        case "tr": return `${name} açık mod mu koyu mod mu kullanıyor?`;
        case "it": return `${name} usa la modalità chiara o scura?`;
        case "id": return `${name} menggunakan mode terang atau gelap?`;
        case "ru": return `${name} использует светлый или темный режим?`;
        default: return `Does ${name} use light or dark mode?`;
      }
    }, "🌙"),
    
    new Question("d07", "digital", "text", lang => {
      switch (lang) {
        case "de": return "Was ist meine Lieblingsstreamingplatform?";
        case "fr": return "Quelle est ma plateforme de streaming préférée ?";
        case "es": return "¿Cuál es mi plataforma de streaming favorita?";
        case "pt": return "Qual é a minha plataforma de streaming favorita?";
        case "ar": return "ما هي منصة البث المفضلة لدي؟";
        case "ja": return "私の好きなストリーミングプラットフォームは？";
        case "ko": return "내가 가장 좋아하는 스트리밍 플랫폼은?";
        case "tr": return "En sevdiğim yayın platformu nedir?";
        case "it": return "Qual è la mia piattaforma di streaming preferita?";
        case "id": return "Apa platform streaming favorit saya?";
        case "ru": return "Какая моя любимая платформа для стриминга?";
        default: return "What's my favorite streaming platform?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Lieblingsstreamingplatform?`;
        case "fr": return `Quelle est la plateforme de streaming préférée de ${name} ?`;
        case "es": return `¿Cuál es la plataforma de streaming favorita de ${name}?`;
        case "pt": return `Qual é a plataforma de streaming favorita de ${name}?`;
        case "ar": return `ما هي منصة البث المفضلة لدى ${name}؟`;
        case "ja": return `${name}の好きなストリーミングプラットフォームは？`;
        case "ko": return `${name}이/가 가장 좋아하는 스트리밍 플랫폼은?`;
        case "tr": return `${name}ʼnin en sevdiği yayın platformu nedir?`;
        case "it": return `Qual è la piattaforma di streaming preferita di ${name}?`;
        case "id": return `Apa platform streaming favorit ${name}?`;
        case "ru": return `Какая любимая платформа для стриминга у ${name}?`;
        default: return `What's ${name}'s favorite streaming platform?`;
      }
    }, "🍿"),
    
  ];
  
  // HOBBIES
  const hobbyQuestions = [
    new Question("s00", "hobbies", "text", lang => {
      switch (lang) {
        case "de": return "Was für einen Sport mache ich?";
        case "fr": return "Quel sport je pratique ?";
        case "es": return "¿Qué deporte practico?";
        case "pt": return "Que esporte eu pratico?";
        case "ar": return "ما هي الرياضة التي ألعبها؟";
        case "ja": return "私はどんなスポーツをするの？";
        case "ko": return "나는 어떤 스포츠를 해?";
        case "tr": return "Hangi sporu yapıyorum?";
        case "it": return "Che sport pratico?";
        case "id": return "Olahraga apa yang aku mainkan?";
        case "ru": return "Каким спортом я занимаюсь?";
        default: return "What sport do I play?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was für einen Sport macht ${name}?`;
        case "fr": return `Quel sport pratique ${name} ?`;
        case "es": return `¿Qué deporte practica ${name}?`;
        case "pt": return `Que esporte ${name} pratica?`;
        case "ar": return `ما هي الرياضة التي يلعبها ${name}؟`;
        case "ja": return `${name}はどんなスポーツをするの？`;
        case "ko": return `${name}은/는 어떤 스포츠를 해?`;
        case "tr": return `${name} hangi sporu yapıyor?`;
        case "it": return `Che sport pratica ${name}?`;
        case "id": return `Olahraga apa yang ${name} mainkan?`;
        case "ru": return `Каким спортом занимается ${name}?`;
        default: return `What sport does ${name} play?`;
      }
    }, "💪"),
    
    new Question("s01", "hobbies", "text", lang => {
      switch (lang) {
        case "de": return "Was ist mein Lieblingsvideospiel?";
        case "fr": return "Quel est mon jeu vidéo préféré ?";
        case "es": return "¿Cuál es mi videojuego favorito?";
        case "pt": return "Qual é o meu videogame favorito?";
        case "ar": return "ما هي لعبة الفيديو المفضلة لدي؟";
        case "ja": return "私の好きなビデオゲームは何？";
        case "ko": return "내가 가장 좋아하는 비디오 게임은 뭐야?";
        case "tr": return "En sevdiğim video oyunu hangisi?";
        case "it": return "Qual è il mio videogioco preferito?";
        case "id": return "Apa video game favoritku?";
        case "ru": return "Какая моя любимая видеоигра?";
        default: return "What's my favorite video game?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Lieblingsvideospiel?`;
        case "fr": return `Quel est le jeu vidéo préféré de ${name} ?`;
        case "es": return `¿Cuál es el videojuego favorito de ${name}?`;
        case "pt": return `Qual é o videogame favorito de ${name}?`;
        case "ar": return `ما هي لعبة الفيديو المفضلة لدى ${name}؟`;
        case "ja": return `${name}の好きなビデオゲームは何？`;
        case "ko": return `${name}이/가 가장 좋아하는 비디오 게임은 뭐야?`;
        case "tr": return `${name}'in en sevdiği video oyunu hangisi?`;
        case "it": return `Qual è il videogioco preferito di ${name}?`;
        case "id": return `Apa video game favorit ${name}?`;
        case "ru": return `Какая любимая видеоигра у ${name}?`;
        default: return `What's ${name}'s favorite video game?`;
      }
    }, "🎮"),
    
    new Question("s02", "hobbies", "text", lang => {
      switch (lang) {
        case "de": return "Welches Instrument spiele ich?";
        case "fr": return "Quel instrument je joue ?";
        case "es": return "¿Qué instrumento toco?";
        case "pt": return "Que instrumento eu toco?";
        case "ar": return "ما هي الآلة الموسيقية التي أعزف عليها؟";
        case "ja": return "私はどんな楽器を演奏するの？";
        case "ko": return "나는 어떤 악기를 연주해?";
        case "tr": return "Hangi enstrümanı çalıyorum?";
        case "it": return "Che strumento suono?";
        case "id": return "Aku memainkan alat musik apa?";
        case "ru": return "На каком инструменте я играю?";
        default: return "What instrument do I play?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Welches Instrument spielt ${name}?`;
        case "fr": return `Quel instrument joue ${name} ?`;
        case "es": return `¿Qué instrumento toca ${name}?`;
        case "pt": return `Que instrumento ${name} toca?`;
        case "ar": return `ما هي الآلة الموسيقية التي يعزف عليها ${name}؟`;
        case "ja": return `${name}はどんな楽器を演奏するの？`;
        case "ko": return `${name}은/는 어떤 악기를 연주해?`;
        case "tr": return `${name} hangi enstrümanı çalıyor?`;
        case "it": return `Che strumento suona ${name}?`;
        case "id": return `${name} memainkan alat musik apa?`;
        case "ru": return `На каком инструменте играет ${name}?`;
        default: return `What instrument does ${name} play?`;
      }
    }, "🎹"),
    
    new Question("s03", "hobbies", "text", lang => {
      switch (lang) {
        case "de": return "Was ist mein Traumjob?";
        case "fr": return "Quel est mon métier de rêve ?";
        case "es": return "¿Cuál es mi trabajo soñado?";
        case "pt": return "Qual é o meu trabalho dos sonhos?";
        case "ar": return "ما هي وظيفة أحلامي؟";
        case "ja": return "私の夢の仕事は何？";
        case "ko": return "내 꿈의 직업은 뭐야?";
        case "tr": return "Hayalimdeki iş ne?";
        case "it": return "Qual è il lavoro dei miei sogni?";
        case "id": return "Apa pekerjaan impianku?";
        case "ru": return "Какая работа моей мечты?";
        default: return "What's my dream job?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Traumgob?`;
        case "fr": return `Quel est le métier de rêve de ${name} ?`;
        case "es": return `¿Cuál es el trabajo soñado de ${name}?`;
        case "pt": return `Qual é o trabalho dos sonhos de ${name}?`;
        case "ar": return `ما هي وظيفة أحلام ${name}؟`;
        case "ja": return `${name}の夢の仕事は何？`;
        case "ko": return `${name}의 꿈의 직업은 뭐야?`;
        case "tr": return `${name}'in hayalindeki iş ne?`;
        case "it": return `Qual è il lavoro dei sogni di ${name}?`;
        case "id": return `Apa pekerjaan impian ${name}?`;
        case "ru": return `Какая работа мечты у ${name}?`;
        default: return `What's ${name}'s dream job?`;
      }
    }, "💼"),
    
    new Question("s04", "hobbies", "text", lang => {
      switch (lang) {
        case "de": return "Was ist mein Lieblings-Gesellschaftsspiel?";
        case "fr": return "Quel est mon jeu de société préféré ?";
        case "es": return "¿Cuál es mi juego de mesa favorito?";
        case "pt": return "Qual é o meu jogo de tabuleiro favorito?";
        case "ar": return "ما هي لعبة الطاولة المفضلة لدي؟";
        case "ja": return "私の好きなボードゲームは何？";
        case "ko": return "내가 가장 좋아하는 보드게임은 뭐야?";
        case "tr": return "En sevdiğim kutu oyunu hangisi?";
        case "it": return "Qual è il mio gioco da tavolo preferito?";
        case "id": return "Apa permainan papan favoritku?";
        case "ru": return "Какая моя любимая настольная игра?";
        default: return "What's my favorite board game?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Lieblings-Gesellschaftsspiel?`;
        case "fr": return `Quel est le jeu de société préféré de ${name} ?`;
        case "es": return `¿Cuál es el juego de mesa favorito de ${name}?`;
        case "pt": return `Qual é o jogo de tabuleiro favorito de ${name}?`;
        case "ar": return `ما هي لعبة الطاولة المفضلة لدى ${name}؟`;
        case "ja": return `${name}の好きなボードゲームは何？`;
        case "ko": return `${name}이/가 가장 좋아하는 보드게임은 뭐야?`;
        case "tr": return `${name}'in en sevdiği kutu oyunu hangisi?`;
        case "it": return `Qual è il gioco da tavolo preferito di ${name}?`;
        case "id": return `Apa permainan papan favorit ${name}?`;
        case "ru": return `Какая любимая настольная игра у ${name}?`;
        default: return `What's ${name}'s favorite board game?`;
      }
    }, "🎲"),
    
    new Question("s05", "hobbies", "text", lang => {
      switch (lang) {
        case "de": return "Was könnte ich stundenlang tun?";
        case "fr": return "Quelle activité je pourrais faire pendant des heures ?";
        case "es": return "¿Qué actividad podría hacer durante horas?";
        case "pt": return "Que atividade eu poderia fazer por horas?";
        case "ar": return "ما النشاط الذي يمكنني القيام به لساعات؟";
        case "ja": return "私は何時間でもできることは何？";
        case "ko": return "내가 몇 시간이고 할 수 있는 활동은 뭐야?";
        case "tr": return "Saatlerce ne yapabilirim?";
        case "it": return "Che attività potrei fare per ore?";
        case "id": return "Aktivitas apa yang bisa kulakukan berjam-jam?";
        case "ru": return "Чем я мог(ла) бы заниматься часами?";
        default: return "What activity could I do for hours?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was könnte ${name} stundenlang tun?`;
        case "fr": return `Quelle activité ${name} pourrait faire pendant des heures ?`;
        case "es": return `¿Qué actividad podría hacer ${name} durante horas?`;
        case "pt": return `Que atividade ${name} poderia fazer por horas?`;
        case "ar": return `ما النشاط الذي يمكن لـ ${name} القيام به لساعات؟`;
        case "ja": return `${name}は何時間でもできることは何？`;
        case "ko": return `${name}이/가 몇 시간이고 할 수 있는 활동은 뭐야?`;
        case "tr": return `${name} saatlerce ne yapabilir?`;
        case "it": return `Che attività potrebbe fare ${name} per ore?`;
        case "id": return `Aktivitas apa yang bisa dilakukan ${name} berjam-jam?`;
        case "ru": return `Чем ${name} мог(ла) бы заниматься часами?`;
        default: return `What activity could ${name} do for hours?`;
      }
    }, "♾️"),
  ];
  
  // RELATIONSHIP
  const relationshipQuestions = [
    new Question("r00", "relationship", "text", lang => {
      switch (lang) {
        case "de": return "Wie lange kennen wir uns schon?";
        case "fr": return "Depuis combien de temps on se connaît ?";
        case "es": return "¿Desde hace cuánto nos conocemos?";
        case "pt": return "Há quanto tempo nos conhecemos?";
        case "ar": return "منذ متى نعرف بعضنا البعض؟";
        case "ja": return "私たちは知り合ってどれくらい？";
        case "ko": return "우린 알고 지낸 지 얼마나 됐어?";
        case "tr": return "Ne zamandır tanışıyoruz?";
        case "it": return "Da quanto tempo ci conosciamo?";
        case "id": return "Sudah berapa lama kita saling kenal?";
        case "ru": return "Как давно мы знакомы?";
        default: return "How long do we know each other for?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wie lange kennt ihr euch schon?`;
        case "fr": return "Depuis combien de temps on se connaît ?";
        case "es": return "¿Desde hace cuánto nos conocemos?";
        case "pt": return "Há quanto tempo nos conhecemos?";
        case "ar": return "منذ متى تعرفان بعضكما البعض؟";
        case "ja": return "二人は知り合ってどれくらい？";
        case "ko": return "둘은 알고 지낸 지 얼마나 됐어?";
        case "tr": return "Ne zamandır tanışıyorsunuz?";
        case "it": return "Da quanto tempo vi conoscete?";
        case "id": return "Sudah berapa lama kalian saling kenal?";
        case "ru": return "Как давно вы знакомы?";
        default: return `How long do you know each other for?`;
      }
    }, "⏳"),
    
    new Question("r01", "relationship", "text", lang => {
      switch (lang) {
        case "de": return "Wo haben wir uns kennengelernt?";
        case "fr": return "Où est-ce qu’on s’est rencontrés ?";
        case "es": return "¿Dónde nos conocimos?";
        case "pt": return "Onde nos conhecemos?";
        case "ar": return "أين التقينا لأول مرة؟";
        case "ja": return "私たちはどこで初めて会ったの？";
        case "ko": return "우린 처음 어디서 만났어?";
        case "tr": return "İlk kez nerede tanıştık?";
        case "it": return "Dove ci siamo conosciuti?";
        case "id": return "Di mana kita pertama kali bertemu?";
        case "ru": return "Где мы впервые встретились?";
        default: return "Where did we first meet?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wo habt ihr euch kennengelernt?`;
        case "fr": return "Où est-ce qu’on s’est rencontrés ?";
        case "es": return "¿Dónde nos conocimos?";
        case "pt": return "Onde nos conhecemos?";
        case "ar": return "أين التقيتما لأول مرة؟";
        case "ja": return "二人はどこで初めて会ったの？";
        case "ko": return "둘은 처음 어디서 만났어?";
        case "tr": return "İlk kez nerede tanıştınız?";
        case "it": return "Dove vi siete conosciuti?";
        case "id": return "Di mana kalian pertama kali bertemu?";
        case "ru": return "Где вы впервые встретились?";
        default: return `Where did you first meet?`;
      }
    }, "📍"),
    
    new Question("r02", "relationship", "text", lang => {
      switch (lang) {
        case "de": return "Wann haben wir uns zuletzt getroffen?";
        case "fr": return "Quand est-ce qu’on s’est vus pour la dernière fois ?";
        case "es": return "¿Cuándo fue la última vez que nos vimos?";
        case "pt": return "Quando foi a última vez que nos encontramos?";
        case "ar": return "متى كانت آخر مرة التقينا فيها؟";
        case "ja": return "最後に一緒に会ったのはいつ？";
        case "ko": return "우린 마지막으로 언제 만났어?";
        case "tr": return "En son ne zaman buluştuk?";
        case "it": return "Quando ci siamo visti l’ultima volta?";
        case "id": return "Kapan terakhir kali kita hang out?";
        case "ru": return "Когда мы в последний раз тусовались вместе?";
        default: return "When's the last time we hung out?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wann habt ihr euch zuletzt getroffen?`;
        case "fr": return "Quand est-ce qu’on s’est vus pour la dernière fois ?";
        case "es": return "¿Cuándo fue la última vez que nos vimos?";
        case "pt": return "Quando foi a última vez que nos encontramos?";
        case "ar": return "متى كانت آخر مرة التقيتما فيها؟";
        case "ja": return "二人が最後に会ったのはいつ？";
        case "ko": return "둘은 마지막으로 언제 만났어?";
        case "tr": return "En son ne zaman buluştunuz?";
        case "it": return "Quando vi siete visti l’ultima volta?";
        case "id": return "Kapan terakhir kali kalian hang out?";
        case "ru": return "Когда вы в последний раз тусовались вместе?";
        default: return `When's the last time you hung out?`;
      }
    }, "🤝"),
    
    new Question("r03", "relationship", "text", lang => {
      switch (lang) {
        case "de": return "Haben wir uns schonmal gestritten?";
        case "fr": return "On s’est déjà disputés ?";
        case "es": return "¿Alguna vez hemos discutido?";
        case "pt": return "A gente já brigou alguma vez?";
        case "ar": return "هل تشاجرنا من قبل؟";
        case "ja": return "私たち、ケンカしたことある？";
        case "ko": return "우린 싸운 적 있어?";
        case "tr": return "Hiç tartıştık mı?";
        case "it": return "Abbiamo mai litigato?";
        case "id": return "Pernahkah kita bertengkar?";
        case "ru": return "Мы когда-нибудь ссорились?";
        default: return "Did we ever have an argument?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Habt ihr euch schonmal gestritten?`;
        case "fr": return "On s’est déjà disputés ?";
        case "es": return "¿Alguna vez hemos discutido?";
        case "pt": return "A gente já brigou alguma vez?";
        case "ar": return "هل تشاجرتما من قبل؟";
        case "ja": return "二人はケンカしたことある？";
        case "ko": return "둘은 싸운 적 있어?";
        case "tr": return "Hiç tartıştınız mı?";
        case "it": return "Avete mai litigato?";
        case "id": return "Pernahkah kalian bertengkar?";
        case "ru": return "Вы когда-нибудь ссорились?";
        default: return `Did you ever have an argument?`;
      }
    }, "🥊"),
    
    new Question("r04", "relationship", "text", lang => {
      switch (lang) {
        case "de": return "In wie vielen gleichen Gruppenchats sind wir beide?";
        case "fr": return "Dans combien de groupes on est ensemble ?";
        case "es": return "¿En cuántos grupos estamos juntos?";
        case "pt": return "Em quantos grupos estamos juntos?";
        case "ar": return "في كم مجموعة دردشة نحن معًا؟";
        case "ja": return "私たちは同じグループチャットにいくつ入ってる？";
        case "ko": return "우리가 같이 있는 단체 채팅방이 몇 개야?";
        case "tr": return "Birlikte olduğumuz kaç tane grup sohbeti var?";
        case "it": return "In quanti gruppi chat siamo insieme?";
        case "id": return "Ada berapa grup chat yang sama yang kita ikuti?";
        case "ru": return "В скольких общих групповых чатах мы состоим?";
        default: return "How many same group chats are we in?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `In wie vielen gleichen Gruppenchats seid ihr beide?`;
        case "fr": return "Dans combien de groupes on est ensemble ?";
        case "es": return "¿En cuántos grupos estamos juntos?";
        case "pt": return "Em quantos grupos estamos juntos?";
        case "ar": return "في كم مجموعة دردشة أنتما معًا؟";
        case "ja": return "二人は同じグループチャットにいくつ入ってる？";
        case "ko": return "둘이 같이 있는 단체 채팅방이 몇 개야?";
        case "tr": return "Birlikte olduğunuz kaç tane grup sohbeti var?";
        case "it": return "In quante chat di gruppo siete insieme?";
        case "id": return "Ada berapa grup chat yang sama yang kalian ikuti?";
        case "ru": return "В скольких общих групповых чатах вы состоите?";
        default: return `How many same group chats are you in?`;
      }
    }, "💬"),
    
    new Question("r05", "relationship", "text", lang => {
      switch (lang) {
        case "de": return "Was ist einer unserer Insider?";
        case "fr": return "C’est quoi une de nos blagues privées ?";
        case "es": return "¿Cuál es uno de nuestros chistes internos?";
        case "pt": return "Qual é uma das nossas piadas internas?";
        case "ar": return "ما هي واحدة من نكاتنا الداخلية؟";
        case "ja": return "私たちの内輪ネタは何かある？";
        case "ko": return "우리만 아는 농담 하나 뭐야?";
        case "tr": return "Aramızdaki bir iç şaka ne?";
        case "it": return "Qual è una delle nostre battute interne?";
        case "id": return "Apa salah satu lelucon internal kita?";
        case "ru": return "Какая у нас есть одна внутренняя шутка?";
        default: return "What's one inside joke we have?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist einer eurer Insider?`;
        case "fr": return "C’est quoi une de nos blagues privées ?";
        case "es": return "¿Cuál es uno de nuestros chistes internos?";
        case "pt": return "Qual é uma das nossas piadas internas?";
        case "ar": return "ما هي واحدة من نكاتكما الداخلية؟";
        case "ja": return "二人の内輪ネタは何かある？";
        case "ko": return "둘만 아는 농담 하나 뭐야?";
        case "tr": return "Aranızdaki bir iç şaka ne?";
        case "it": return "Qual è una delle vostre battute interne?";
        case "id": return "Apa salah satu lelucon internal kalian?";
        case "ru": return "Какая у вас есть одна внутренняя шутка?";
        default: return `What's one inside joke you have?`;
      }
    }, "😂"),
    
  ];
  
  // GOSSIP
  const gossipQuestions = [
    new Question("g00", "gossip", "text", lang => {
      switch (lang) {
        case "de": return "Wer ist mein Celebrity Crush?";
        case "fr": return "Qui est ma célébrité coup de cœur ?";
        case "es": return "¿Quién es mi amor platónico famoso?";
        case "pt": return "Quem é minha celebridade crush?";
        case "ar": return "من هو المشهور الذي أعجب به؟";
        case "ja": return "私の憧れの有名人は誰？";
        case "ko": return "내가 좋아하는 연예인은 누구야?";
        case "tr": return "Ünlü crush’ım kim?";
        case "it": return "Chi è la mia cotta famosa?";
        case "id": return "Siapa selebritas yang aku sukai?";
        case "ru": return "Кто мой краш среди знаменитостей?";
        default: return "Who's my celebrity crush?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wer ist ${name}s Celebrity Crush?`;
        case "fr": return `Qui est la célébrité coup de cœur de ${name} ?`;
        case "es": return `¿Quién es el amor platónico famoso de ${name}?`;
        case "pt": return `Quem é a celebridade crush de ${name}?`;
        case "ar": return `من هو المشهور الذي يُعجب به ${name}؟`;
        case "ja": return `${name}の憧れの有名人は誰？`;
        case "ko": return `${name}이/가 좋아하는 연예인은 누구야?`;
        case "tr": return `${name}'in ünlü crush’ı kim?`;
        case "it": return `Chi è la cotta famosa di ${name}?`;
        case "id": return `Siapa selebritas yang disukai ${name}?`;
        case "ru": return `Кто краш ${name} среди знаменитостей?`;
        default: return `What's ${name}'s celebrity crush?`;
      }
    }, "💕"),
    
    new Question("g01", "gossip", "text", lang => {
      switch (lang) {
        case "de": return "Was ist mein Typ?";
        case "fr": return "Quel est mon type ?";
        case "es": return "¿Cuál es mi tipo?";
        case "pt": return "Qual é o meu tipo?";
        case "ar": return "ما هو نوعي المفضل؟";
        case "ja": return "私のタイプは？";
        case "ko": return "내 취향은 뭐야?";
        case "tr": return "Benim tipim ne?";
        case "it": return "Qual è il mio tipo?";
        case "id": return "Apa tipe favoritku?";
        case "ru": return "Какой у меня типаж?";
        default: return "What's my type?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Typ?`;
        case "fr": return `Quel est le type de ${name} ?`;
        case "es": return `¿Cuál es el tipo de ${name}?`;
        case "pt": return `Qual é o tipo de ${name}?`;
        case "ar": return `ما هو نوع ${name} المفضل؟`;
        case "ja": return `${name}のタイプは？`;
        case "ko": return `${name}의 취향은 뭐야?`;
        case "tr": return `${name}'in tipi ne?`;
        case "it": return `Qual è il tipo di ${name}?`;
        case "id": return `Apa tipe favorit ${name}?`;
        case "ru": return `Какой типаж у ${name}?`;
        default: return `What's ${name}'s type?`;
      }
    }, "🔎"),
    
    new Question("g02", "gossip", "text", lang => {
      switch (lang) {
        case "de": return "Wie viele Beziehungen hatte ich schon?";
        case "fr": return "Combien de relations ai-je eues ?";
        case "es": return "¿Cuántas relaciones he tenido?";
        case "pt": return "Quantos relacionamentos eu já tive?";
        case "ar": return "كم علاقة عاطفية مررت بها؟";
        case "ja": return "私は今まで何回恋愛した？";
        case "ko": return "난 연애를 몇 번 해봤어?";
        case "tr": return "Kaç ilişkim oldu?";
        case "it": return "Quante relazioni ho avuto?";
        case "id": return "Aku sudah berapa kali menjalin hubungan?";
        case "ru": return "Сколько отношений у меня было?";
        default: return "How many relationships have I been in?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wie viele Beziehungen hatte ${name} schon?`;
        case "fr": return `Combien de relations ${name} a-t-il eues ?`;
        case "es": return `¿Cuántas relaciones ha tenido ${name}?`;
        case "pt": return `Quantos relacionamentos ${name} já teve?`;
        case "ar": return `كم علاقة عاطفية مرّ بها ${name}؟`;
        case "ja": return `${name}は今まで何回恋愛した？`;
        case "ko": return `${name}은/는 연애를 몇 번 해봤어?`;
        case "tr": return `${name}'in kaç ilişkisi oldu?`;
        case "it": return `Quante relazioni ha avuto ${name}?`;
        case "id": return `${name} sudah berapa kali menjalin hubungan?`;
        case "ru": return `Сколько отношений было у ${name}?`;
        default: return `How many relationship has ${name} been in?`;
      }
    }, "💘"),
    
    new Question("g03", "gossip", "text", lang => {
      switch (lang) {
        case "de": return "Benutzte ich eine Dating App?";
        case "fr": return "Est-ce que j’utilise une appli de rencontres ?";
        case "es": return "¿Uso alguna app de citas?";
        case "pt": return "Eu uso algum app de namoro?";
        case "ar": return "هل أستخدم تطبيق مواعدة؟";
        case "ja": return "私は出会い系アプリを使ってる？";
        case "ko": return "나는 데이팅 앱을 써?";
        case "tr": return "Bir flört uygulaması kullanıyor muyum?";
        case "it": return "Uso un’app di incontri?";
        case "id": return "Apakah aku memakai aplikasi kencan?";
        case "ru": return "Пользуюсь ли я приложением для знакомств?";
        default: return "Do I use a dating app?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Benutzt ${name} eine Dating App?`;
        case "fr": return `Est-ce que ${name} utilise une appli de rencontres ?`;
        case "es": return `¿${name} usa alguna app de citas?`;
        case "pt": return `O ${name} usa algum app de namoro?`;
        case "ar": return `هل يستخدم ${name} تطبيق مواعدة؟`;
        case "ja": return `${name}は出会い系アプリを使ってる？`;
        case "ko": return `${name}은/는 데이팅 앱을 써?`;
        case "tr": return `${name} bir flört uygulaması kullanıyor mu?`;
        case "it": return `${name} usa un’app di incontri?`;
        case "id": return `Apakah ${name} memakai aplikasi kencan?`;
        case "ru": return `Пользуется ли ${name} приложением для знакомств?`;
        default: return `Does ${name} use a dating app?`;
      }
    }, "💌"),
    
  ];
  
  // RANDOM
  const randomQuestions = [
    new Question("rn00", "random", "text", lang => {
      switch (lang) {
        case "de": return "Was würde ich zuerst mit 1 Million Euro kaufen?";
        case "fr": return "Si j'avais un million d’euros, qu’achèterais-je en premier ?";
        case "es": return "Si tuviera un millón de euros, ¿qué compraría primero?";
        case "pt": return "Se eu tivesse um milhão de euros, o que eu compraria primeiro?";
        case "ar": return "إذا كان لدي مليون يورو، ماذا سأشتري أولًا؟";
        case "ja": return "もし100万ユーロあったら、最初に何を買う？";
        case "ko": return "내가 백만 유로가 있다면, 먼저 뭘 살까?";
        case "tr": return "1 milyon avrom olsaydı, ilk ne alırdım?";
        case "it": return "Se avessi un milione di euro, cosa comprerei per primo?";
        case "id": return "Kalau aku punya satu juta euro, apa yang akan aku beli dulu?";
        case "ru": return "Если бы у меня был миллион евро, что бы я купил(а) первым делом?";
        default: return "If I had a million dollars, what would I buy first?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was würde ${name} zuerst mit 1 Million Euro kaufen?`;
        case "fr": return `Si ${name} avait un million d’euros, qu’achèterait-il/elle en premier ?`;
        case "es": return `Si ${name} tuviera un millón de euros, ¿qué compraría primero?`;
        case "pt": return `Se ${name} tivesse um milhão de euros, o que ele/ela compraria primeiro?`;
        case "ar": return `إذا كان لدى ${name} مليون يورو، ماذا سيشتري أولًا؟`;
        case "ja": return `もし${name}が100万ユーロ持っていたら、最初に何を買う？`;
        case "ko": return `${name}이/가 백만 유로가 있다면, 먼저 뭘 살까?`;
        case "tr": return `${name}'in 1 milyon avrosu olsaydı, ilk ne alırdı?`;
        case "it": return `Se ${name} avesse un milione di euro, cosa comprerebbe per primo?`;
        case "id": return `Kalau ${name} punya satu juta euro, apa yang akan ${name} beli dulu?`;
        case "ru": return `Если бы у ${name} был миллион евро, что бы ${name} купил(а) первым делом?`;
        default: return `If ${name} had a million dollars, what would ${name} buy first?`;
      }
    }, "💸"),
    
    new Question("rn01", "random", "text", lang => {
      switch (lang) {
        case "de": return "Wenn ich ein Tier wäre, welches wäre ich?";
        case "fr": return "Si j’étais un animal, lequel serais-je ?";
        case "es": return "Si fuera un animal, ¿cuál sería?";
        case "pt": return "Se eu fosse um animal, qual seria?";
        case "ar": return "لو كنتُ حيوانًا، فما الذي سأكونه؟";
        case "ja": return "もし私が動物だったら、何の動物？";
        case "ko": return "내가 동물이라면, 어떤 동물일까?";
        case "tr": return "Bir hayvan olsaydım, hangisi olurdum?";
        case "it": return "Se fossi un animale, quale sarei?";
        case "id": return "Kalau aku seekor hewan, aku akan jadi hewan apa?";
        case "ru": return "Если бы я был(а) животным, каким бы я был(а)?";
        default: return "If I would be an animal, what would I be?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wenn ${name} ein Tier wäre, welches wäre es?`;
        case "fr": return `Si ${name} était un animal, lequel serait-il/elle ?`;
        case "es": return `Si ${name} fuera un animal, ¿cuál sería?`;
        case "pt": return `Se ${name} fosse um animal, qual seria?`;
        case "ar": return `لو كان ${name} حيوانًا، فما الذي سيكونه؟`;
        case "ja": return `もし${name}が動物だったら、何の動物？`;
        case "ko": return `${name}이/가 동물이라면, 어떤 동물일까?`;
        case "tr": return `${name} bir hayvan olsaydı, hangisi olurdu?`;
        case "it": return `Se ${name} fosse un animale, quale sarebbe?`;
        case "id": return `Kalau ${name} seekor hewan, ${name} akan jadi hewan apa?`;
        case "ru": return `Если бы ${name} был(а) животным, каким бы он(она) был(а)?`;
        default: return `If ${name} would be an animal, what would it be?`;
      }
    }, "🦁"),
    
    new Question("rn02", "random", "text", lang => {
      switch (lang) {
        case "de": return "Was ist meine größte Angst?";
        case "fr": return "Quelle est ma plus grande peur ?";
        case "es": return "¿Cuál es mi mayor miedo?";
        case "pt": return "Qual é o meu maior medo?";
        case "ar": return "ما هو أكبر خوفي؟";
        case "ja": return "私の一番の怖いものは何？";
        case "ko": return "내가 가장 무서워하는 건 뭐야?";
        case "tr": return "En büyük korkum ne?";
        case "it": return "Qual è la mia paura più grande?";
        case "id": return "Apa ketakutan terbesarku?";
        case "ru": return "Какой мой самый большой страх?";
        default: return "What's my biggest fear?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s größte Angst?`;
        case "fr": return `Quelle est la plus grande peur de ${name} ?`;
        case "es": return `¿Cuál es el mayor miedo de ${name}?`;
        case "pt": return `Qual é o maior medo de ${name}?`;
        case "ar": return `ما هو أكبر خوف لدى ${name}؟`;
        case "ja": return `${name}の一番の怖いものは何？`;
        case "ko": return `${name}이/가 가장 무서워하는 건 뭐야?`;
        case "tr": return `${name}'in en büyük korkusu ne?`;
        case "it": return `Qual è la paura più grande di ${name}?`;
        case "id": return `Apa ketakutan terbesar ${name}?`;
        case "ru": return `Какой самый большой страх у ${name}?`;
        default: return `What's ${name}'s biggest fear?`;
      }
    }, "🕷️"),
    
    new Question("rn03", "random", "text", lang => {
      switch (lang) {
        case "de": return "Wenn ich eine Superkraft haben könnte, welche wäre es?";
        case "fr": return "Si je pouvais avoir un super-pouvoir, lequel serait-ce ?";
        case "es": return "Si pudiera tener un superpoder, ¿cuál sería?";
        case "pt": return "Se eu pudesse ter um superpoder, qual seria?";
        case "ar": return "إذا استطعت امتلاك قوة خارقة، فما هي؟";
        case "ja": return "もし超能力を1つ持てるなら、何がいい？";
        case "ko": return "내가 초능력을 가질 수 있다면, 어떤 능력일까?";
        case "tr": return "Bir süper gücüm olsaydı, hangisi olurdu?";
        case "it": return "Se potessi avere un superpotere, quale sarebbe?";
        case "id": return "Kalau aku bisa punya kekuatan super, itu apa?";
        case "ru": return "Если бы я мог(ла) иметь суперсилу, какая бы это была?";
        default: return "If I could have any superpower, what would it be?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wenn ${name} eine Superkraft haben könnte, welche wäre es?`;
        case "fr": return `Si ${name} pouvait avoir un super-pouvoir, lequel serait-ce ?`;
        case "es": return `Si ${name} pudiera tener un superpoder, ¿cuál sería?`;
        case "pt": return `Se ${name} pudesse ter um superpoder, qual seria?`;
        case "ar": return `إذا استطاع ${name} امتلاك قوة خارقة، فما هي؟`;
        case "ja": return `もし${name}が超能力を1つ持てるなら、何がいい？`;
        case "ko": return `${name}이/가 초능력을 가질 수 있다면, 어떤 능력일까?`;
        case "tr": return `${name} bir süper güce sahip olsaydı, hangisi olurdu?`;
        case "it": return `Se ${name} potesse avere un superpotere, quale sarebbe?`;
        case "id": return `Kalau ${name} bisa punya kekuatan super, itu apa?`;
        case "ru": return `Если бы ${name} мог(ла) иметь суперсилу, какая бы это была?`;
        default: return `If ${name} could have any superpower, what would it be?`;
      }
    }, "🦸"),
    
    new Question("rn04", "random", "text", lang => {
      switch (lang) {
        case "de": return "Wie viele Kinder möchte ich mal haben?";
        case "fr": return "Combien d’enfants voudrais-je avoir ?";
        case "es": return "¿Cuántos hijos me gustaría tener?";
        case "pt": return "Quantos filhos eu gostaria de ter?";
        case "ar": return "كم طفلًا أريد أن أنجب يومًا ما؟";
        case "ja": return "将来、子どもは何人ほしい？";
        case "ko": return "나는 나중에 아이를 몇 명 갖고 싶어?";
        case "tr": return "İleride kaç çocuk istiyorum?";
        case "it": return "Quanti figli vorrei avere un giorno?";
        case "id": return "Nanti aku ingin punya berapa anak?";
        case "ru": return "Сколько детей я хочу иметь?";
        default: return "How many children do I want to have?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wie viele Kinder will ${name} mal haben?`;
        case "fr": return `Combien d’enfants ${name} voudrait-il/elle avoir ?`;
        case "es": return `¿Cuántos hijos le gustaría tener a ${name}?`;
        case "pt": return `Quantos filhos ${name} gostaria de ter?`;
        case "ar": return `كم طفلًا يريد ${name} أن ينجب يومًا ما؟`;
        case "ja": return `${name}は将来、子どもは何人ほしい？`;
        case "ko": return `${name}은/는 나중에 아이를 몇 명 갖고 싶어?`;
        case "tr": return `${name} ileride kaç çocuk istiyor?`;
        case "it": return `Quanti figli vorrebbe avere ${name} un giorno?`;
        case "id": return `Nanti ${name} ingin punya berapa anak?`;
        case "ru": return `Сколько детей хочет иметь ${name}?`;
        default: return `How many children does ${name} want to have?`;
      }
    }, "🍼"),
    
    new Question("rn05", "random", "text", lang => {
      switch (lang) {
        case "de": return "Welches Wort benutze ich zu oft?";
        case "fr": return "Quelle est la phrase que je dis tout le temps ?";
        case "es": return "¿Qué es algo que digo todo el tiempo?";
        case "pt": return "O que é algo que eu sempre digo?";
        case "ar": return "ما الشيء الذي أقوله طوال الوقت؟";
        case "ja": return "私がいつも言ってる口ぐせは何？";
        case "ko": return "내가 늘 하는 말은 뭐야?";
        case "tr": return "Sürekli söylediğim bir şey ne?";
        case "it": return "Cosa dico sempre?";
        case "id": return "Apa sesuatu yang sering aku ucapkan?";
        case "ru": return "Что я постоянно говорю?";
        default: return "What's something I say all the time?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Welches Wort benutzt ${name} zu oft?`;
        case "fr": return `Quelle est la phrase que ${name} dit tout le temps ?`;
        case "es": return `¿Qué es algo que ${name} dice todo el tiempo?`;
        case "pt": return `O que é algo que ${name} sempre diz?`;
        case "ar": return `ما الشيء الذي يقوله ${name} طوال الوقت؟`;
        case "ja": return `${name}がいつも言ってる口ぐせは何？`;
        case "ko": return `${name}이/가 늘 하는 말은 뭐야?`;
        case "tr": return `${name}'in sürekli söylediği bir şey ne?`;
        case "it": return `Cosa dice sempre ${name}?`;
        case "id": return `Apa sesuatu yang sering ${name} ucapkan?`;
        case "ru": return `Что ${name} постоянно говорит?`;
        default: return `What's something ${name} says all the time?`;
      }
    }, "💬"),
    
  ];


// WHO OF YOU
export const woyQuestions = [
  new Question("woy00", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer braucht länger zum Antworten?"
      case "fr": return "Qui met plus de temps à répondre ?"
      case "es": return "¿Quién tarda más en responder?"
      case "pt": return "Quem demora mais para responder?"
      case "ar": return "من يستغرق وقتًا أطول للرد؟"
      case "ja": return "返信に時間がかかるのは誰？"
      case "ko": return "누가 답장을 더 늦게 해?"
      case "tr": return "Kim cevap vermekte daha uzun sürer?"
      case "it": return "Chi ci mette più tempo a rispondere?"
      case "id": return "Siapa yang lebih lama membalas?"
      case "ru": return "Кто дольше отвечает?"
      default: return "Who takes longer to reply?"
    }
  }, (name, lang) => {
    return ""
  }, "💬"),
  
  new Question("woy01", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer hat die höhere Bildschirmzeit?"
      case "fr": return "Qui a le temps d'écran le plus élevé ?"
      case "es": return "¿Quién tiene el mayor tiempo de pantalla?"
      case "pt": return "Quem tem mais tempo de tela?"
      case "ar": return "من لديه وقت شاشة أكثر؟"
      case "ja": return "スクリーンタイムが長いのは誰？"
      case "ko": return "누가 스크린 타임이 더 길어?"
      case "tr": return "Kimin ekran süresi daha yüksek?"
      case "it": return "Chi ha più tempo sullo schermo?"
      case "id": return "Siapa yang punya waktu layar lebih tinggi?"
      case "ru": return "У кого больше экранного времени?"
      default: return "Who has the higher screen time?"
    }
  }, (name, lang) => {
    return ""
  }, "📲"),
  
  new Question("woy02", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer redet mehr?"
      case "fr": return "Qui parle le plus ?"
      case "es": return "¿Quién habla más?"
      case "pt": return "Quem fala mais?"
      case "ar": return "من يتكلم أكثر؟"
      case "ja": return "一番よくしゃべるのは誰？"
      case "ko": return "누가 말을 더 많이 해?"
      case "tr": return "Kim daha çok konuşur?"
      case "it": return "Chi parla di più?"
      case "id": return "Siapa yang paling banyak bicara?"
      case "ru": return "Кто больше говорит?"
      default: return "Who talks the most?"
    }
  }, (name, lang) => {
    return ""
  }, "📢"),
  
  new Question("woy03", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer kommt öfter zu spät?"
      case "fr": return "Qui arrive en retard le plus souvent ?"
      case "es": return "¿Quién llega tarde más a menudo?"
      case "pt": return "Quem se atrasa com mais frequência?"
      case "ar": return "من يتأخر أكثر غالبًا؟"
      case "ja": return "遅刻が多いのは誰？"
      case "ko": return "누가 더 자주 늦어?"
      case "tr": return "Kim daha sık geç kalır?"
      case "it": return "Chi arriva in ritardo più spesso?"
      case "id": return "Siapa yang lebih sering terlambat?"
      case "ru": return "Кто чаще опаздывает?"
      default: return "Who's late more often?"
    }
  }, (name, lang) => {
    return ""
  }, "⏳"),
  
  new Question("woy04", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer hat mehr Bilder auf dem Handy?"
      case "fr": return "Qui a le plus de photos sur son téléphone ?"
      case "es": return "¿Quién tiene más fotos en su teléfono?"
      case "pt": return "Quem tem mais fotos no telefone?"
      case "ar": return "من لديه صور أكثر على الهاتف؟"
      case "ja": return "スマホの写真が多いのは誰？"
      case "ko": return "누가 휴대폰에 사진이 더 많아?"
      case "tr": return "Kimin telefonda daha fazla fotoğrafı var?"
      case "it": return "Chi ha più foto sul telefono?"
      case "id": return "Siapa yang punya lebih banyak foto di ponsel?"
      case "ru": return "У кого больше фотографий в телефоне?"
      default: return "Who has more photos on their phone?"
    }
  }, (name, lang) => {
    return ""
  }, "📸"),
  
  new Question("woy05", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer ist lustiger?"
      case "fr": return "Qui est le plus drôle ?"
      case "es": return "¿Quién es más divertido?"
      case "pt": return "Quem é mais engraçado?"
      case "ar": return "من الأكثر طرافة؟"
      case "ja": return "面白いのは誰？"
      case "ko": return "누가 더 웃겨?"
      case "tr": return "Kim daha komik?"
      case "it": return "Chi è più divertente?"
      case "id": return "Siapa yang lebih lucu?"
      case "ru": return "Кто смешнее?"
      default: return "Who's funnier?"
    }
  }, (name, lang) => {
    return ""
  }, "😂"),
  
  new Question("woy06", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer ist schlauer?"
      case "fr": return "Qui est le plus intelligent ?"
      case "es": return "¿Quién es más inteligente?"
      case "pt": return "Quem é mais inteligente?"
      case "ar": return "من الأذكى؟"
      case "ja": return "頭がいいのは誰？"
      case "ko": return "누가 더 똑똑해?"
      case "tr": return "Kim daha zeki?"
      case "it": return "Chi è più intelligente?"
      case "id": return "Siapa yang lebih pintar?"
      case "ru": return "Кто умнее?"
      default: return "Who's smarter?"
    }
  }, (name, lang) => {
    return ""
  }, "🧠"),
  
  new Question("woy07", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer würde eher einen Streit anfangen?"
      case "fr": return "Qui serait le plus susceptible de commencer une dispute ?"
      case "es": return "¿Quién es más propenso a iniciar una pelea?"
      case "pt": return "Quem é mais provável de começar uma briga?"
      case "ar": return "من الأرجح أن يبدأ شجارًا؟"
      case "ja": return "ケンカを始めそうなのは誰？"
      case "ko": return "누가 더 싸움을 먼저 걸 것 같아?"
      case "tr": return "Kim daha çok kavga başlatır?"
      case "it": return "Chi è più propenso a iniziare un litigio?"
      case "id": return "Siapa yang lebih mungkin memulai pertengkaran?"
      case "ru": return "Кто скорее начнёт ссору?"
      default: return "Who's more likely to start a fight?"
    }
  }, (name, lang) => {
    return ""
  }, "🧨"),
  
  new Question("woy08", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer postet mehr auf Social Media?"
      case "fr": return "Qui poste le plus sur les réseaux sociaux ?"
      case "es": return "¿Quién publica más en las redes sociales?"
      case "pt": return "Quem posta mais nas redes sociais?"
      case "ar": return "من ينشر أكثر على وسائل التواصل الاجتماعي؟"
      case "ja": return "SNSに投稿が多いのは誰？"
      case "ko": return "누가 소셜 미디어에 더 많이 올려?"
      case "tr": return "Kim sosyal medyada daha çok paylaşım yapar?"
      case "it": return "Chi posta di più sui social media?"
      case "id": return "Siapa yang lebih sering posting di media sosial?"
      case "ru": return "Кто больше публикует в соцсетях?"
      default: return "Who posts more on social media?"
    }
  }, (name, lang) => {
    return ""
  }, "📸"),
  
  new Question("woy09", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer würde ein Wettessen gewinnen?"
      case "fr": return "Qui gagnerait un concours de mangeurs ?"
      case "es": return "¿Quién ganaría un concurso de comida?"
      case "pt": return "Quem ganharia uma competição de comer?"
      case "ar": return "من سيفوز في مسابقة أكل؟"
      case "ja": return "早食い大会で勝つのは誰？"
      case "ko": return "누가 먹기 대회에서 이길까?"
      case "tr": return "Kim yemek yeme yarışmasını kazanır?"
      case "it": return "Chi vincerebbe una gara di abbuffate?"
      case "id": return "Siapa yang akan menang lomba makan?"
      case "ru": return "Кто выиграл бы конкурс по поеданию еды?"
      default: return "Who would win an eating contest?"
    }
  }, (name, lang) => {
    return ""
  }, "🍔"),
  
  new Question("woy10", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer würde eher auf einer einsamen Insel überleben?"
      case "fr": return "Qui survivrait le plus longtemps sur une île déserte ?"
      case "es": return "¿Quién es más probable que sobreviva en una isla desierta?"
      case "pt": return "Quem tem mais chances de sobreviver em uma ilha deserta?"
      case "ar": return "من الأرجح أن ينجو على جزيرة مهجورة؟"
      case "ja": return "無人島で生き残れそうなのは誰？"
      case "ko": return "누가 무인도에서 더 잘 살아남을 것 같아?"
      case "tr": return "Kim ıssız bir adada hayatta kalma olasılığı daha yüksek?"
      case "it": return "Chi ha più probabilità di sopravvivere su un’isola deserta?"
      case "id": return "Siapa yang lebih mungkin bertahan hidup di pulau terpencil?"
      case "ru": return "Кто с большей вероятностью выжил бы на необитаемом острове?"
      default: return "Who's more likely to survive on a deserted island?"
    }
  }, (name, lang) => {
    return ""
  }, "🏝️"),
  
  new Question("woy11", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer steht früher auf?"
      case "fr": return "Qui se lève le plus tôt ?"
      case "es": return "¿Quién se levanta más temprano?"
      case "pt": return "Quem acorda mais cedo?"
      case "ar": return "من يستيقظ أبكر؟"
      case "ja": return "早起きなのは誰？"
      case "ko": return "누가 더 일찍 일어나?"
      case "tr": return "Kim daha erken uyanır?"
      case "it": return "Chi si sveglia prima?"
      case "id": return "Siapa yang bangun lebih awal?"
      case "ru": return "Кто просыпается раньше?"
      default: return "Who wakes up earlier?"
    }
  }, (name, lang) => {
    return ""
  }, "⏰"),
  
  new Question("woy12", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer gibt mehr Geld für Klamotten aus?"
      case "fr": return "Qui dépense le plus d'argent en vêtements ?"
      case "es": return "¿Quién gasta más dinero en ropa?"
      case "pt": return "Quem gasta mais dinheiro com roupas?"
      case "ar": return "من ينفق مالًا أكثر على الملابس؟"
      case "ja": return "服にお金を多く使うのは誰？"
      case "ko": return "누가 옷에 돈을 더 많이 써?"
      case "tr": return "Kim kıyafetlere daha çok para harcar?"
      case "it": return "Chi spende più soldi per i vestiti?"
      case "id": return "Siapa yang menghabiskan lebih banyak uang untuk pakaian?"
      case "ru": return "Кто тратит больше денег на одежду?"
      default: return "Who spends more money on clothes?"
    }
  }, (name, lang) => {
    return ""
  }, "💰"),
  
  new Question("woy13", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer hat den schlechteren Orientierungssinn?"
      case "fr": return "Qui a le pire sens de l'orientation ?"
      case "es": return "¿Quién tiene peor sentido de la orientación?"
      case "pt": return "Quem tem pior senso de orientação?"
      case "ar": return "من لديه أسوأ إحساس بالاتجاهات؟"
      case "ja": return "方向音痴なのは誰？"
      case "ko": return "누가 길치야?"
      case "tr": return "Kimin yön duygusu daha kötü?"
      case "it": return "Chi ha il peggior senso dell’orientamento?"
      case "id": return "Siapa yang punya arah paling buruk?"
      case "ru": return "У кого хуже чувство ориентации?"
      default: return "Who has the worse sense of orientation?"
    }
  }, (name, lang) => {
    return ""
  }, "🧭"),
  
  new Question("woy14", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer von euch hat den besseren Style?"
      case "fr": return "Qui a le meilleur style ?"
      case "es": return "¿Quién tiene mejor estilo?"
      case "pt": return "Quem tem o melhor estilo?"
      case "ar": return "من لديه أسلوب أفضل في اللباس؟"
      case "ja": return "ファッションセンスがいいのは誰？"
      case "ko": return "누가 스타일이 더 좋아?"
      case "tr": return "Kimin tarzı daha iyi?"
      case "it": return "Chi ha lo stile migliore?"
      case "id": return "Siapa yang punya gaya lebih bagus?"
      case "ru": return "У кого стиль лучше?"
      default: return "Who has the better style?"
    }
  }, (name, lang) => {
    return ""
  }, "🕶️"),
  
  new Question("woy15", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer vergisst häufiger das Handy zu laden?"
      case "fr": return "Qui oublie le plus souvent de charger son téléphone ?"
      case "es": return "¿Quién olvida cargar su teléfono más a menudo?"
      case "pt": return "Quem esquece de carregar o celular com mais frequência?"
      case "ar": return "من ينسى شحن هاتفه أكثر؟"
      case "ja": return "スマホの充電をよく忘れるのは誰？"
      case "ko": return "누가 휴대폰 충전을 더 자주 까먹어?"
      case "tr": return "Kim telefonunu şarj etmeyi daha sık unutur?"
      case "it": return "Chi dimentica più spesso di caricare il telefono?"
      case "id": return "Siapa yang lebih sering lupa mengisi daya ponsel?"
      case "ru": return "Кто чаще забывает зарядить телефон?"
      default: return "Who forgets to charge their phone more often?"
    }
  }, (name, lang) => {
    return ""
  }, "🔋"),
  
  new Question("woy16", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer sagt häufiger Treffen ab?"
      case "fr": return "Qui annule le plus souvent des rendez-vous ?"
      case "es": return "¿Quién es más propenso a cancelar planes?"
      case "pt": return "Quem tem mais chances de cancelar compromissos?"
      case "ar": return "من يُلغي الخطط أكثر؟"
      case "ja": return "予定をよくキャンセルするのは誰？"
      case "ko": return "누가 약속을 더 자주 취소해?"
      case "tr": return "Kim planları daha sık iptal eder?"
      case "it": return "Chi cancella più spesso i programmi?"
      case "id": return "Siapa yang lebih sering membatalkan rencana?"
      case "ru": return "Кто чаще отменяет планы?"
      default: return "Who's more likely to cancel plans?"
    }
  }, (name, lang) => {
    return ""
  }, "❌"),
  
  new Question("woy17", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer hat schon mehr Serien geschaut?"
      case "fr": return "Qui a regardé le plus de séries sur une plateforme de streaming ?"
      case "es": return "¿Quién ha visto más series en una plataforma de streaming?"
      case "pt": return "Quem já assistiu mais séries em uma plataforma de streaming?"
      case "ar": return "من شاهد مسلسلات أكثر على منصات البث؟"
      case "ja": return "配信サービスで一番多くシリーズを見たのは誰？"
      case "ko": return "누가 스트리밍에서 시리즈를 더 많이 봤어?"
      case "tr": return "Kim bir platformda daha fazla dizi izledi?"
      case "it": return "Chi ha guardato più serie su una piattaforma di streaming?"
      case "id": return "Siapa yang sudah menonton lebih banyak serial di platform streaming?"
      case "ru": return "Кто посмотрел больше сериалов на стриминге?"
      default: return "Who has watched more shows on a streaming platform?"
    }
  }, (name, lang) => {
    return ""
  }, "🍿"),
  
  new Question("woy18", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer kann Geheimnisse schlechter für sich behalten?"
      case "fr": return "Qui est le pire pour garder des secrets ?"
      case "es": return "¿Quién es peor para guardar secretos?"
      case "pt": return "Quem é pior em guardar segredos?"
      case "ar": return "من الأسوأ في حفظ الأسرار؟"
      case "ja": return "秘密を守るのが苦手なのは誰？"
      case "ko": return "누가 비밀을 더 못 지켜?"
      case "tr": return "Kim sır saklamakta daha kötü?"
      case "it": return "Chi è peggio a mantenere i segreti?"
      case "id": return "Siapa yang paling buruk dalam menyimpan rahasia?"
      case "ru": return "Кто хуже хранит секреты?"
      default: return "Who's worse at keeping secrets?"
    }
  }, (name, lang) => {
    return ""
  }, "🤫"),
  
  new Question("woy19", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer ist dramatischer?"
      case "fr": return "Qui est le plus dramatique ?"
      case "es": return "¿Quién es más dramático?"
      case "pt": return "Quem é mais dramático?"
      case "ar": return "من الأكثر درامية؟"
      case "ja": return "よりドラマチックなのは誰？"
      case "ko": return "누가 더 드라마틱해?"
      case "tr": return "Kim daha dramatik?"
      case "it": return "Chi è più drammatico?"
      case "id": return "Siapa yang lebih dramatis?"
      case "ru": return "Кто более драматичный?"
      default: return "Who's more dramatic?"
    }
  }, (name, lang) => {
    return ""
  }, "😭"),
  
  new Question("woy20", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer ist ehrgeiziger?"
      case "fr": return "Qui est le plus compétitif ?"
      case "es": return "¿Quién es más competitivo?"
      case "pt": return "Quem é mais competitivo?"
      case "ar": return "من الأكثر طموحًا؟"
      case "ja": return "より負けず嫌いなのは誰？"
      case "ko": return "누가 더 경쟁심이 강해?"
      case "tr": return "Kim daha hırslı/rekabetçi?"
      case "it": return "Chi è più competitivo?"
      case "id": return "Siapa yang lebih kompetitif?"
      case "ru": return "Кто более конкурентный?"
      default: return "Who's more competitive?"
    }
  }, (name, lang) => {
    return ""
  }, "🏆"),
  
  new Question("woy21", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer würde eher bei einem Film weinen?"
      case "fr": return "Qui est le plus susceptible de pleurer pendant un film ?"
      case "es": return "¿Quién es más probable que llore durante una película?"
      case "pt": return "Quem tem mais chances de chorar durante um filme?"
      case "ar": return "من الأرجح أن يبكي أثناء مشاهدة فيلم؟"
      case "ja": return "映画で泣きそうなのは誰？"
      case "ko": return "누가 영화 보다가 울 것 같아?"
      case "tr": return "Kim bir film sırasında ağlama olasılığı daha yüksek?"
      case "it": return "Chi è più propenso a piangere durante un film?"
      case "id": return "Siapa yang lebih mungkin menangis saat menonton film?"
      case "ru": return "Кто скорее заплачет во время фильма?"
      default: return "Who's more likely to cry during a movie?"
    }
  }, (name, lang) => {
    return ""
  }, "🎬"),
  
  new Question("woy22", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer kann besser kochen?"
      case "fr": return "Qui cuisine le mieux ?"
      case "es": return "¿Quién cocina mejor?"
      case "pt": return "Quem cozinha melhor?"
      case "ar": return "من يطبخ بشكل أفضل؟"
      case "ja": return "料理が上手なのは誰？"
      case "ko": return "누가 요리를 더 잘해?"
      case "tr": return "Kim daha iyi yemek yapar?"
      case "it": return "Chi sa cucinare meglio?"
      case "id": return "Siapa yang lebih jago masak?"
      case "ru": return "Кто лучше готовит?"
      default: return "Who's better at cooking?"
    }
  }, (name, lang) => {
    return ""
  }, "🍳"),
  
  new Question("woy23", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer ist besser in Mathe?"
      case "fr": return "Qui est meilleur en maths ?"
      case "es": return "¿Quién es mejor en matemáticas?"
      case "pt": return "Quem é melhor em matemática?"
      case "ar": return "من الأفضل في الرياضيات؟"
      case "ja": return "数学が得意なのは誰？"
      case "ko": return "누가 수학을 더 잘해?"
      case "tr": return "Kim matematikte daha iyi?"
      case "it": return "Chi è più bravo in matematica?"
      case "id": return "Siapa yang lebih jago matematika?"
      case "ru": return "Кто лучше в математике?"
      default: return "Who's better at math?"
    }
  }, (name, lang) => {
    return ""
  }, "➕"),
  
  new Question("woy24", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer bleibt eher lange wach?"
      case "fr": return "Qui est le plus susceptible de veiller tard ?"
      case "es": return "¿Quién es más probable que se quede despierto hasta tarde?"
      case "pt": return "Quem tem mais chances de ficar acordado até tarde?"
      case "ar": return "من الأرجح أن يبقى مستيقظًا حتى وقت متأخر؟"
      case "ja": return "夜更かししがちなのは誰？"
      case "ko": return "누가 더 늦게까지 깨어 있어?"
      case "tr": return "Kim daha çok geç saatlere kadar uyanık kalır?"
      case "it": return "Chi è più propenso a restare sveglio fino a tardi?"
      case "id": return "Siapa yang lebih mungkin begadang?"
      case "ru": return "Кто скорее не ляжет спать допоздна?"
      default: return "Who's more likely to stay up late?"
    }
  }, (name, lang) => {
    return ""
  }, "🌙"),
  
  new Question("woy25", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer landet eher im Gefängnis?"
      case "fr": return "Qui est le plus susceptible de finir en prison ?"
      case "es": return "¿Quién es más probable que termine en la cárcel?"
      case "pt": return "Quem tem mais chances de acabar na prisão?"
      case "ar": return "من الأرجح أن ينتهي به الأمر في السجن؟"
      case "ja": return "刑務所に入る可能性が高いのは誰？"
      case "ko": return "누가 감옥에 갈 가능성이 더 높아?"
      case "tr": return "Kim hapse girme olasılığı daha yüksek?"
      case "it": return "Chi è più propenso a finire in prigione?"
      case "id": return "Siapa yang lebih mungkin berakhir di penjara?"
      case "ru": return "Кто скорее окажется в тюрьме?"
      default: return "Who's more likely to end up in prison?"
    }
  }, (name, lang) => {
    return ""
  }, "🚨"),
  
  new Question("woy26", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer ist besser im Gaming?"
      case "fr": return "Qui est meilleur en jeux vidéo ?"
      case "es": return "¿Quién es mejor en los videojuegos?"
      case "pt": return "Quem é melhor em jogos?"
      case "ar": return "من الأفضل في ألعاب الفيديو؟"
      case "ja": return "ゲームが上手なのは誰？"
      case "ko": return "누가 게임을 더 잘해?"
      case "tr": return "Kim oyunlarda daha iyi?"
      case "it": return "Chi è più bravo nei videogiochi?"
      case "id": return "Siapa yang lebih jago main game?"
      case "ru": return "Кто лучше играет в игры?"
      default: return "Who's better at gaming?"
    }
  }, (name, lang) => {
    return ""
  }, "🕹️"),
  
  new Question("woy27", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer ist in mehr Ländern gereist?"
      case "fr": return "Qui a voyagé dans plus de pays ?"
      case "es": return "¿Quién ha viajado a más países?"
      case "pt": return "Quem já viajou para mais países?"
      case "ar": return "من سافر إلى عدد أكبر من الدول؟"
      case "ja": return "より多くの国を旅したのは誰？"
      case "ko": return "누가 더 많은 나라를 여행했어?"
      case "tr": return "Kim daha fazla ülkeye seyahat etti?"
      case "it": return "Chi ha viaggiato in più paesi?"
      case "id": return "Siapa yang sudah bepergian ke lebih banyak negara?"
      case "ru": return "Кто побывал в большем количестве стран?"
      default: return "Who has traveled to more countries?"
    }
  }, (name, lang) => {
    return ""
  }, "🌎"),
  
  new Question("woy28", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer ist geduldiger?"
      case "fr": return "Qui est le plus patient ?"
      case "es": return "¿Quién es más paciente?"
      case "pt": return "Quem é mais paciente?"
      case "ar": return "من الأكثر صبرًا؟"
      case "ja": return "より忍耐強いのは誰？"
      case "ko": return "누가 더 인내심이 강해?"
      case "tr": return "Kim daha sabırlı?"
      case "it": return "Chi è più paziente?"
      case "id": return "Siapa yang lebih sabar?"
      case "ru": return "Кто терпеливее?"
      default: return "Who's more patient?"
    }
  }, (name, lang) => {
    return ""
  }, "⏳"),
  
  new Question("woy29", "woy", "pickUser", lang => {
    switch (lang) {
      case "de": return "Wer hatte mehr Beziehungen?"
      case "fr": return "Qui a eu le plus de relations amoureuses ?"
      case "es": return "¿Quién ha estado en más relaciones?"
      case "pt": return "Quem já teve mais relacionamentos?"
      case "ar": return "من كان لديه علاقات أكثر؟"
      case "ja": return "恋愛経験が多いのは誰？"
      case "ko": return "누가 연애를 더 많이 해봤어?"
      case "tr": return "Kimin daha çok ilişkisi oldu?"
      case "it": return "Chi ha avuto più relazioni?"
      case "id": return "Siapa yang sudah punya lebih banyak hubungan?"
      case "ru": return "У кого было больше отношений?"
      default: return "Who has been in more relationships?"
    }
  }, (name, lang) => {
    return ""
  }, "💘"),
  

]

// EMOJI TELEPATHY
export const telQuestions = [
  new Question("tel00", "tel", "emoji", lang => {
    switch (lang) {
      case "de": return "Wähle einen Tier-Emoji."
      case "fr": return "Choisis un emoji d’animal."
      case "es": return "Elige un emoji de animal."
      case "pt": return "Escolhe um emoji de animal."
      case "ar": return "اختر إيموجي لحيوان."
      case "ja": return "動物の絵文字を選んで。"
      case "ko": return "동물 이모지를 골라."
      case "tr": return "Bir hayvan emojisi seç."
      case "it": return "Scegli un’emoji di un animale."
      case "id": return "Pilih emoji hewan."
      case "ru": return "Выбери эмодзи животного."
      default: return "Pick an animal emoji."
    }
  }, (name, lang) => {
    return ""
  }, [..."🐶🐻🐱🐼🐹🐷🐮🦁"][Math.floor(Math.random() * ("🐶🐻🐱🐼🐹🐷🐮🦁".length - 1))]),
  
  new Question("tel01", "tel", "emoji", lang => {
    switch (lang) {
      case "de": return "Wähle eine Nummer zwischen 1️⃣ und 5️⃣."
      case "fr": return "Choisis un nombre entre 1️⃣ et 5️⃣."
      case "es": return "Elige un número entre 1️⃣ y 5️⃣."
      case "pt": return "Escolhe um número entre 1️⃣ e 5️⃣."
      case "ar": return "اختر رقمًا بين 1️⃣ و 5️⃣."
      case "ja": return "1️⃣〜5️⃣の数字を選んで。"
      case "ko": return "1️⃣부터 5️⃣ 사이 숫자를 골라."
      case "tr": return "1️⃣ ile 5️⃣ arasında bir sayı seç."
      case "it": return "Scegli un numero tra 1️⃣ e 5️⃣."
      case "id": return "Pilih angka antara 1️⃣ dan 5️⃣."
      case "ru": return "Выбери число от 1️⃣ до 5️⃣."
      default: return "Pick a number between 1️⃣ and 5️⃣."
    }
  }, (name, lang) => {
    return ""
  }, "#️⃣"),
  
  new Question("tel02", "tel", "emoji", lang => {
    switch (lang) {
      case "de": return "Wähle einen Obst-Emoji."
      case "fr": return "Choisis un emoji de fruit."
      case "es": return "Elige un emoji de fruta."
      case "pt": return "Escolhe um emoji de fruta."
      case "ar": return "اختر إيموجي فاكهة."
      case "ja": return "フルーツの絵文字を選んで。"
      case "ko": return "과일 이모지를 골라."
      case "tr": return "Bir meyve emojisi seç."
      case "it": return "Scegli un’emoji di frutta."
      case "id": return "Pilih emoji buah."
      case "ru": return "Выбери эмодзи фрукта."
      default: return "Pick a fruit emoji."
    }
  }, (name, lang) => {
    return ""
  }, [..."🍒🍓🍌🍎🍑🍏🥭🍍"][Math.floor(Math.random() * ("🍒🍓🍌🍎🍑🍏🥭🍍".length - 1))]),
  
  new Question("tel03", "tel", "emoji", lang => {
    switch (lang) {
      case "de": return "Wähle einen Wetter-Emoji."
      case "fr": return "Choisis un emoji de météo."
      case "es": return "Elige un emoji del clima."
      case "pt": return "Escolhe um emoji de clima."
      case "ar": return "اختر إيموجي للطقس."
      case "ja": return "天気の絵文字を選んで。"
      case "ko": return "날씨 이모지를 골라."
      case "tr": return "Bir hava durumu emojisi seç."
      case "it": return "Scegli un’emoji del meteo."
      case "id": return "Pilih emoji cuaca."
      case "ru": return "Выбери эмодзи погоды."
      default: return "Pick a weather emoji."
    }
  }, (name, lang) => {
    return ""
  }, [..."☁️🌦️⛈️⚡️🌪️🌈❄️☀️"][Math.floor(Math.random() * ("☁️🌦️⛈️⚡️🌪️🌈❄️☀️".length - 1))]),
  
  new Question("tel04", "tel", "emoji", lang => {
    switch (lang) {
      case "de": return "Wähle einen Fahrzeug-Emoji."
      case "fr": return "Choisis un emoji de véhicule."
      case "es": return "Elige un emoji de vehículo."
      case "pt": return "Escolhe um emoji de veículo."
      case "ar": return "اختر إيموجي لمركبة."
      case "ja": return "乗り物の絵文字を選んで。"
      case "ko": return "탈것 이모지를 골라."
      case "tr": return "Bir araç emojisi seç."
      case "it": return "Scegli un’emoji di un veicolo."
      case "id": return "Pilih emoji kendaraan."
      case "ru": return "Выбери эмодзи транспорта."
      default: return "Pick a vehicle emoji."
    }
  }, (name, lang) => {
    return ""
  }, [..."🚗✈️🚃🚛🚁🚲"][Math.floor(Math.random() * ("🚗✈️🚃🚛🚁🚲".length - 1))]),
  
  new Question("tel05", "tel", "emoji", lang => {
    switch (lang) {
      case "de": return "Wähle einen Sport-Emoji."
      case "fr": return "Choisis un emoji de sport."
      case "es": return "Elige un emoji de deporte."
      case "pt": return "Escolhe um emoji de esporte."
      case "ar": return "اختر إيموجي لرياضة."
      case "ja": return "スポーツの絵文字を選んで。"
      case "ko": return "스포츠 이모지를 골라."
      case "tr": return "Bir spor emojisi seç."
      case "it": return "Scegli un’emoji di sport."
      case "id": return "Pilih emoji olahraga."
      case "ru": return "Выбери спортивный эмодзи."
      default: return "Pick a sport emoji."
    }
  }, (name, lang) => {
    return ""
  }, [..."💪⚽️🎾🏓🏈🏀🛹"][Math.floor(Math.random() * ("💪⚽️🎾🏓🏈🏀🛹".length - 1))]),
  
  new Question("tel06", "tel", "emoji", lang => {
    switch (lang) {
      case "de": return "Wähle einen Pflanzen-Emoji."
      case "fr": return "Choisis un emoji de plante."
      case "es": return "Elige un emoji de planta."
      case "pt": return "Escolhe um emoji de planta."
      case "ar": return "اختر إيموجي لنبات."
      case "ja": return "植物の絵文字を選んで。"
      case "ko": return "식물 이모지를 골라."
      case "tr": return "Bir bitki emojisi seç."
      case "it": return "Scegli un’emoji di una pianta."
      case "id": return "Pilih emoji tanaman."
      case "ru": return "Выбери эмодзи растения."
      default: return "Pick a plant emoji."
    }
  }, (name, lang) => {
    return ""
  }, [..."🍀🌹🌻🌿🌴🍄🌵"][Math.floor(Math.random() * ("🍀🌹🌻🌿🌴🍄🌵".length - 1))]),
  
  new Question("tel07", "tel", "emoji", lang => {
    switch (lang) {
      case "de": return "Wähle einen Fast-Food-Emoji."
      case "fr": return "Choisis un emoji de fast-food."
      case "es": return "Elige un emoji de comida rápida."
      case "pt": return "Escolhe um emoji de fast-food."
      case "ar": return "اختر إيموجي للوجبات السريعة."
      case "ja": return "ファストフードの絵文字を選んで。"
      case "ko": return "패스트푸드 이모지를 골라."
      case "tr": return "Bir fast food emojisi seç."
      case "it": return "Scegli un’emoji di fast food."
      case "id": return "Pilih emoji makanan cepat saji."
      case "ru": return "Выбери эмодзи фастфуда."
      default: return "Pick a fast food emoji."
    }
  }, (name, lang) => {
    return ""
  }, [..."🍕🍔🌭🍟🌮"][Math.floor(Math.random() * ("🍕🍔🌭🍟🌮".length - 1))]),
  
  new Question("tel08", "tel", "emoji", lang => {
    switch (lang) {
      case "de": return "Wähle einen Musik-Emoji."
      case "fr": return "Choisis un emoji de musique."
      case "es": return "Elige un emoji de música."
      case "pt": return "Escolhe um emoji de música."
      case "ar": return "اختر إيموجي للموسيقى."
      case "ja": return "音楽の絵文字を選んで。"
      case "ko": return "음악 이모지를 골라."
      case "tr": return "Bir müzik emojisi seç."
      case "it": return "Scegli un’emoji di musica."
      case "id": return "Pilih emoji musik."
      case "ru": return "Выбери музыкальный эмодзи."
      default: return "Pick a music emoji."
    }
  }, (name, lang) => {
    return ""
  }, [..."🎤🎵🎹🎸🎺🥁"][Math.floor(Math.random() * ("🎤🎵🎹🎸🎺🥁".length - 1))]),
  
  new Question("tel09", "tel", "emoji", lang => {
    switch (lang) {
      case "de": return "Wähle einen Weltraum-Emoji."
      case "fr": return "Choisis un emoji d’espace."
      case "es": return "Elige un emoji del espacio."
      case "pt": return "Escolhe um emoji do espaço."
      case "ar": return "اختر إيموجي للفضاء."
      case "ja": return "宇宙の絵文字を選んで。"
      case "ko": return "우주 이모지를 골라."
      case "tr": return "Bir uzay emojisi seç."
      case "it": return "Scegli un’emoji dello spazio."
      case "id": return "Pilih emoji luar angkasa."
      case "ru": return "Выбери эмодзи космоса."
      default: return "Pick a space emoji."
    }
  }, (name, lang) => {
    return ""
  }, [..."🚀👽🌎🪐🛰️🔭"][Math.floor(Math.random() * ("🚀👽🌎🪐🛰️🔭".length - 1))]),
  
  new Question("tel10", "tel", "emoji", lang => {
    switch (lang) {
      case "de": return "Wähle einen Hand-Emoji."
      case "fr": return "Choisis un emoji de main."
      case "es": return "Elige un emoji de mano."
      case "pt": return "Escolhe um emoji de mão."
      case "ar": return "اختر إيموجي لليد."
      case "ja": return "手の絵文字を選んで。"
      case "ko": return "손 이모지를 골라."
      case "tr": return "Bir el emojisi seç."
      case "it": return "Scegli un’emoji della mano."
      case "id": return "Pilih emoji tangan."
      case "ru": return "Выбери эмодзи руки."
      default: return "Pick a hand emoji."
    }
  }, (name, lang) => {
    return ""
  }, [..."👊🫶👋☝️👏👍🙌"][Math.floor(Math.random() * ("👊🫶👋☝️👏👍🙌".length - 1))]),
  
  new Question("tel11", "tel", "emoji", lang => {
    switch (lang) {
      case "de": return "Wähle einen Süßigkeiten-Emoji."
      case "fr": return "Choisis un emoji de bonbon."
      case "es": return "Elige un emoji de dulces."
      case "pt": return "Escolhe um emoji de doces."
      case "ar": return "اختر إيموجي للحلويات."
      case "ja": return "お菓子の絵文字を選んで。"
      case "ko": return "사탕/디저트 이모지를 골라."
      case "tr": return "Bir tatlı emojisi seç."
      case "it": return "Scegli un’emoji di dolci."
      case "id": return "Pilih emoji permen/manisan."
      case "ru": return "Выбери эмодзи сладостей."
      default: return "Pick a sweets emoji."
    }
  }, (name, lang) => {
    return ""
  }, [..."🍬🍫🍩🍭🍪🍦"][Math.floor(Math.random() * ("🍬🍫🍩🍭🍪🍦".length - 1))]),
  
  new Question("tel12", "tel", "emoji", lang => {
    switch (lang) {
      case "de": return "Wähle einen fröhlichen Emoji."
      case "fr": return "Choisis un emoji joyeux."
      case "es": return "Elige un emoji feliz."
      case "pt": return "Escolhe um emoji feliz."
      case "ar": return "اختر إيموجي سعيدًا."
      case "ja": return "嬉しい絵文字を選んで。"
      case "ko": return "행복한 이모지를 골라."
      case "tr": return "Mutlu bir emoji seç."
      case "it": return "Scegli un’emoji felice."
      case "id": return "Pilih emoji bahagia."
      case "ru": return "Выбери весёлый эмодзи."
      default: return "Pick a happy emoji."
    }
  }, (name, lang) => {
    return ""
  }, [..."🙂🥹😂😊😜"][Math.floor(Math.random() * ("🙂🥹😂😊😜".length - 1))]),
  
  new Question("tel13", "tel", "emoji", lang => {
    switch (lang) {
      case "de": return "Wähle einen traurigen Emoji."
      case "fr": return "Choisis un emoji triste."
      case "es": return "Elige un emoji triste."
      case "pt": return "Escolhe um emoji triste."
      case "ar": return "اختر إيموجي حزينًا."
      case "ja": return "悲しい絵文字を選んで。"
      case "ko": return "슬픈 이모지를 골라."
      case "tr": return "Üzgün bir emoji seç."
      case "it": return "Scegli un’emoji triste."
      case "id": return "Pilih emoji sedih."
      case "ru": return "Выбери грустный эмодзи."
      default: return "Pick a sad emoji."
    }
  }, (name, lang) => {
    return ""
  }, [..."😭😔🤕😢☹️"][Math.floor(Math.random() * ("😭😔🤕😢☹️".length - 1))]),
  
  new Question("tel14", "tel", "emoji", lang => {
    switch (lang) {
      case "de": return "Wähle einen grünen Emoji."
      case "fr": return "Choisis un emoji vert."
      case "es": return "Elige un emoji verde."
      case "pt": return "Escolhe um emoji verde."
      case "ar": return "اختر إيموجي أخضر."
      case "ja": return "緑の絵文字を選んで。"
      case "ko": return "초록색 이모지를 골라."
      case "tr": return "Yeşil bir emoji seç."
      case "it": return "Scegli un’emoji verde."
      case "id": return "Pilih emoji hijau."
      case "ru": return "Выбери зелёный эмодзи."
      default: return "Pick a green emoji."
    }
  }, (name, lang) => {
    return ""
  }, [..."✅🐢🍀🤢🥑"][Math.floor(Math.random() * ("✅🐢🍀🤢🥑".length - 1))]),
  
  new Question("tel15", "tel", "emoji", lang => {
    switch (lang) {
      case "de": return "Wähle einen blauen Emoji."
      case "fr": return "Choisis un emoji bleu."
      case "es": return "Elige un emoji azul."
      case "pt": return "Escolhe um emoji azul."
      case "ar": return "اختر إيموجي أزرق."
      case "ja": return "青い絵文字を選んで。"
      case "ko": return "파란색 이모지를 골라."
      case "tr": return "Mavi bir emoji seç."
      case "it": return "Scegli un’emoji blu."
      case "id": return "Pilih emoji biru."
      case "ru": return "Выбери синий эмодзи."
      default: return "Pick a blue emoji."
    }
  }, (name, lang) => {
    return ""
  }, [..."🥶🧢🦋💙🐳"][Math.floor(Math.random() * ("🥶🧢🦋💙🐳".length - 1))]),
  
  new Question("tel16", "tel", "emoji", lang => {
    switch (lang) {
      case "de": return "Wähle einen roten Emoji."
      case "fr": return "Choisis un emoji rouge."
      case "es": return "Elige un emoji rojo."
      case "pt": return "Escolhe um emoji vermelho."
      case "ar": return "اختر إيموجي أحمر."
      case "ja": return "赤い絵文字を選んで。"
      case "ko": return "빨간색 이모지를 골라."
      case "tr": return "Kırmızı bir emoji seç."
      case "it": return "Scegli un’emoji rossa."
      case "id": return "Pilih emoji merah."
      case "ru": return "Выбери красный эмодзи."
      default: return "Pick a red emoji."
    }
  }, (name, lang) => {
    return ""
  }, [..."❤️🌹🎈📍🚨🥊"][Math.floor(Math.random() * ("❤️🌹🎈📍🚨🥊".length - 1))]),
  
]


 export const allQuestions = [
    ...basicQuestions,
    ...favoriteQuestions,
    ...digitalQuestions,
    ...hobbyQuestions,
    ...relationshipQuestions,
    ...gossipQuestions,
    ...randomQuestions,
  ];

// NEW (not selectable yet, only used to resolve ids of quizzes created on iOS)
export const newQuestions = [
    new Question("n04", "favorites", "text", lang => {
      switch (lang) {
        case "de": return "Was ist mein Lieblingssong?";
        case "fr": return "Quelle est ma chanson préférée ?";
        case "es": return "¿Cuál es mi canción favorita?";
        case "pt": return "Qual é a minha música favorita?";
        case "ar": return "ما هي أغنيتي المفضلة؟";
        case "ja": return "私の好きな曲は何ですか？";
        case "ko": return "내가 가장 좋아하는 노래는 뭐예요?";
        case "tr": return "En sevdiğim şarkı ne?";
        case "it": return "Qual è la mia canzone preferita?";
        case "id": return "Apa lagu favorit saya?";
        case "ru": return "Какая моя любимая песня?";
        default: return "What's my favorite song?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Lieblingssong?`;
        case "fr": return `Quelle est la chanson préférée de ${name} ?`;
        case "es": return `¿Cuál es la canción favorita de ${name}?`;
        case "pt": return `Qual é a música favorita de ${name}?`;
        case "ar": return `ما هي الأغنية المفضلة لدى ${name}؟`;
        case "ja": return `${name}の好きな曲は何ですか？`;
        case "ko": return `${name}이/가 가장 좋아하는 노래는 뭐예요?`;
        case "tr": return `${name}’nin en sevdiği şarkı ne?`;
        case "it": return `Qual è la canzone preferita di ${name}?`;
        case "id": return `Apa lagu favorit ${name}?`;
        case "ru": return `Какая любимая песня у ${name}?`;
        default: return `What's ${name}'s favorite song?`;
      }
    }, "🎵"),
    new Question("n00", "basic", "text", lang => {
      switch (lang) {
        case "de": return "Was ist mein Sternzeichen?";
        case "fr": return "Quel est mon signe astrologique ?";
        case "es": return "¿Cuál es mi signo del zodiaco?";
        case "pt": return "Qual é o meu signo?";
        case "ar": return "ما هو برجي؟";
        case "ja": return "私の星座は何ですか？";
        case "ko": return "내 별자리는 뭐예요?";
        case "tr": return "Burcum ne?";
        case "it": return "Qual è il mio segno zodiacale?";
        case "id": return "Apa zodiak saya?";
        case "ru": return "Какой у меня знак зодиака?";
        default: return "What's my zodiac sign?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Sternzeichen?`;
        case "fr": return `Quel est le signe astrologique de ${name} ?`;
        case "es": return `¿Cuál es el signo del zodiaco de ${name}?`;
        case "pt": return `Qual é o signo de ${name}?`;
        case "ar": return `ما هو برج ${name}؟`;
        case "ja": return `${name}の星座は何ですか？`;
        case "ko": return `${name}의 별자리는 뭐예요?`;
        case "tr": return `${name}’nin burcu ne?`;
        case "it": return `Qual è il segno zodiacale di ${name}?`;
        case "id": return `Apa zodiak ${name}?`;
        case "ru": return `Какой знак зодиака у ${name}?`;
        default: return `What's ${name}'s zodiac sign?`;
      }
    }, "♈️"),
    new Question("n01", "favorites", "text", lang => {
      switch (lang) {
        case "de": return "Was ist meine Lieblingsjahreszeit?";
        case "fr": return "Quelle est ma saison préférée ?";
        case "es": return "¿Cuál es mi estación favorita?";
        case "pt": return "Qual é a minha estação do ano favorita?";
        case "ar": return "ما هو فصلي المفضل؟";
        case "ja": return "私の好きな季節は何ですか？";
        case "ko": return "내가 좋아하는 계절은 무엇인가요?";
        case "tr": return "En sevdiğim mevsim hangisi?";
        case "it": return "Qual è la mia stagione preferita?";
        case "id": return "Apa musim favorit saya?";
        case "ru": return "Какое моё любимое время года?";
        default: return "What's my favorite season?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Lieblingsjahreszeit?`;
        case "fr": return `Quelle est la saison préférée de ${name} ?`;
        case "es": return `¿Cuál es la estación favorita de ${name}?`;
        case "pt": return `Qual é a estação do ano favorita de ${name}?`;
        case "ar": return `ما هو الفصل المفضل لدى ${name}؟`;
        case "ja": return `${name}の好きな季節は何ですか？`;
        case "ko": return `${name}이/가 좋아하는 계절은 무엇인가요?`;
        case "tr": return `${name}ʼnin en sevdiği mevsim hangisi?`;
        case "it": return `Qual è la stagione preferita di ${name}?`;
        case "id": return `Apa musim favorit ${name}?`;
        case "ru": return `Какое любимое время года у ${name}?`;
        default: return `What's ${name}'s favorite season?`;
      }
    }, "🍂"),
    new Question("n05", "favorites", "text", lang => {
      switch (lang) {
        case "de": return "Was ist meine Lieblingsmodemarke?";
        case "fr": return "Quelle est ma marque de vêtements préférée ?";
        case "es": return "¿Cuál es mi marca de ropa favorita?";
        case "pt": return "Qual é a minha marca de roupa favorita?";
        case "ar": return "ما هي ماركة الملابس المفضلة لدي؟";
        case "ja": return "私の好きな服のブランドは何ですか？";
        case "ko": return "내가 가장 좋아하는 옷 브랜드는 뭐예요?";
        case "tr": return "En sevdiğim giyim markası ne?";
        case "it": return "Qual è il mio marchio di abbigliamento preferito?";
        case "id": return "Apa merek pakaian favorit saya?";
        case "ru": return "Какой мой любимый бренд одежды?";
        default: return "What's my favorite clothing brand?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Lieblingsmodemarke?`;
        case "fr": return `Quelle est la marque de vêtements préférée de ${name} ?`;
        case "es": return `¿Cuál es la marca de ropa favorita de ${name}?`;
        case "pt": return `Qual é a marca de roupa favorita de ${name}?`;
        case "ar": return `ما هي ماركة الملابس المفضلة لدى ${name}؟`;
        case "ja": return `${name}の好きな服のブランドは何ですか？`;
        case "ko": return `${name}이/가 가장 좋아하는 옷 브랜드는 뭐예요?`;
        case "tr": return `${name}’nin en sevdiği giyim markası ne?`;
        case "it": return `Qual è il marchio di abbigliamento preferito di ${name}?`;
        case "id": return `Apa merek pakaian favorit ${name}?`;
        case "ru": return `Какой любимый бренд одежды у ${name}?`;
        default: return `What's ${name}'s favorite clothing brand?`;
      }
    }, "👕"),
    new Question("n06", "hobbies", "text", lang => {
      switch (lang) {
        case "de": return "Was ist meine Lieblingssportart?";
        case "fr": return "Quel est mon sport préféré ?";
        case "es": return "¿Cuál es mi deporte favorito?";
        case "pt": return "Qual é o meu esporte favorito?";
        case "ar": return "ما هي رياضتي المفضلة؟";
        case "ja": return "私の好きなスポーツは何ですか？";
        case "ko": return "내가 가장 좋아하는 스포츠는 뭐예요?";
        case "tr": return "En sevdiğim spor ne?";
        case "it": return "Qual è il mio sport preferito?";
        case "id": return "Apa olahraga favorit saya?";
        case "ru": return "Какой мой любимый вид спорта?";
        default: return "What's my favorite sport?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Lieblingssportart?`;
        case "fr": return `Quel est le sport préféré de ${name} ?`;
        case "es": return `¿Cuál es el deporte favorito de ${name}?`;
        case "pt": return `Qual é o esporte favorito de ${name}?`;
        case "ar": return `ما هي الرياضة المفضلة لدى ${name}؟`;
        case "ja": return `${name}の好きなスポーツは何ですか？`;
        case "ko": return `${name}이/가 가장 좋아하는 스포츠는 뭐예요?`;
        case "tr": return `${name}’nin en sevdiği spor ne?`;
        case "it": return `Qual è lo sport preferito di ${name}?`;
        case "id": return `Apa olahraga favorit ${name}?`;
        case "ru": return `Какой любимый вид спорта у ${name}?`;
        default: return `What's ${name}'s favorite sport?`;
      }
    }, "⚽️"),
    new Question("n07", "basic", "text", lang => {
      switch (lang) {
        case "de": return "Wie heißt meine Mama?";
        case "fr": return "Comment s'appelle ma mère ?";
        case "es": return "¿Cómo se llama mi mamá?";
        case "pt": return "Qual é o nome da minha mãe?";
        case "ar": return "ما اسم أمي؟";
        case "ja": return "私のお母さんの名前は何ですか？";
        case "ko": return "우리 엄마 이름은 뭐예요?";
        case "tr": return "Annemin adı ne?";
        case "it": return "Come si chiama mia mamma?";
        case "id": return "Siapa nama ibu saya?";
        case "ru": return "Как зовут мою маму?";
        default: return "What's my mom's name?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wie heißt ${name}s Mama?`;
        case "fr": return `Comment s'appelle la mère de ${name} ?`;
        case "es": return `¿Cómo se llama la mamá de ${name}?`;
        case "pt": return `Qual é o nome da mãe de ${name}?`;
        case "ar": return `ما اسم أم ${name}؟`;
        case "ja": return `${name}のお母さんの名前は何ですか？`;
        case "ko": return `${name}의 엄마 이름은 뭐예요?`;
        case "tr": return `${name}’nin annesinin adı ne?`;
        case "it": return `Come si chiama la mamma di ${name}?`;
        case "id": return `Siapa nama ibu ${name}?`;
        case "ru": return `Как зовут маму ${name}?`;
        default: return `What's ${name}'s mom's name?`;
      }
    }, "👩"),
    new Question("n08", "hobbies", "text", lang => {
      switch (lang) {
        case "de": return "Was ist mein Traumreiseziel?";
        case "fr": return "Quelle est ma destination de voyage de rêve ?";
        case "es": return "¿Cuál es mi destino de viaje soñado?";
        case "pt": return "Qual é o meu destino de viagem dos sonhos?";
        case "ar": return "ما هي وجهة السفر التي أحلم بها؟";
        case "ja": return "私が一番行ってみたい旅行先はどこですか？";
        case "ko": return "내가 꿈꾸는 여행지는 어디예요?";
        case "tr": return "Hayalimdeki seyahat yeri neresi?";
        case "it": return "Qual è la mia meta di viaggio dei sogni?";
        case "id": return "Apa destinasi liburan impian saya?";
        case "ru": return "Куда я мечтаю отправиться в путешествие?";
        default: return "What's my dream travel destination?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Traumreiseziel?`;
        case "fr": return `Quelle est la destination de voyage de rêve de ${name} ?`;
        case "es": return `¿Cuál es el destino de viaje soñado de ${name}?`;
        case "pt": return `Qual é o destino de viagem dos sonhos de ${name}?`;
        case "ar": return `ما هي وجهة السفر التي يحلم بها ${name}؟`;
        case "ja": return `${name}が一番行ってみたい旅行先はどこですか？`;
        case "ko": return `${name}이/가 꿈꾸는 여행지는 어디예요?`;
        case "tr": return `${name}’nin hayalindeki seyahat yeri neresi?`;
        case "it": return `Qual è la meta di viaggio dei sogni di ${name}?`;
        case "id": return `Apa destinasi liburan impian ${name}?`;
        case "ru": return `Куда ${name} мечтает отправиться в путешествие?`;
        default: return `What's ${name}'s dream travel destination?`;
      }
    }, "✈️"),
    new Question("n09", "digital", "text", lang => {
      switch (lang) {
        case "de": return "Wie sieht meine Handyhülle aus?";
        case "fr": return "À quoi ressemble ma coque de téléphone ?";
        case "es": return "¿Cómo es la funda de mi móvil?";
        case "pt": return "Como é a capinha do meu celular?";
        case "ar": return "كيف يبدو غطاء هاتفي؟";
        case "ja": return "私のスマホケースはどんな見た目ですか？";
        case "ko": return "내 폰 케이스는 어떻게 생겼어요?";
        case "tr": return "Telefon kılıfım neye benziyor?";
        case "it": return "Com'è la cover del mio telefono?";
        case "id": return "Seperti apa casing HP saya?";
        case "ru": return "Как выглядит мой чехол для телефона?";
        default: return "What does my phone case look like?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Wie sieht ${name}s Handyhülle aus?`;
        case "fr": return `À quoi ressemble la coque de téléphone de ${name} ?`;
        case "es": return `¿Cómo es la funda del móvil de ${name}?`;
        case "pt": return `Como é a capinha do celular de ${name}?`;
        case "ar": return `كيف يبدو غطاء هاتف ${name}؟`;
        case "ja": return `${name}のスマホケースはどんな見た目ですか？`;
        case "ko": return `${name}의 폰 케이스는 어떻게 생겼어요?`;
        case "tr": return `${name}’nin telefon kılıfı neye benziyor?`;
        case "it": return `Com'è la cover del telefono di ${name}?`;
        case "id": return `Seperti apa casing HP ${name}?`;
        case "ru": return `Как выглядит чехол для телефона у ${name}?`;
        default: return `What does ${name}'s phone case look like?`;
      }
    }, "📱"),
    new Question("n10", "favorites", "text", lang => {
      switch (lang) {
        case "de": return "Was ist meine Lieblingszahl?";
        case "fr": return "Quel est mon nombre préféré ?";
        case "es": return "¿Cuál es mi número favorito?";
        case "pt": return "Qual é o meu número favorito?";
        case "ar": return "ما هو رقمي المفضل؟";
        case "ja": return "私の好きな数字は何ですか？";
        case "ko": return "내가 가장 좋아하는 숫자는 뭐예요?";
        case "tr": return "En sevdiğim sayı kaç?";
        case "it": return "Qual è il mio numero preferito?";
        case "id": return "Berapa angka favorit saya?";
        case "ru": return "Какое моё любимое число?";
        default: return "What's my favorite number?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Lieblingszahl?`;
        case "fr": return `Quel est le nombre préféré de ${name} ?`;
        case "es": return `¿Cuál es el número favorito de ${name}?`;
        case "pt": return `Qual é o número favorito de ${name}?`;
        case "ar": return `ما هو الرقم المفضل لدى ${name}؟`;
        case "ja": return `${name}の好きな数字は何ですか？`;
        case "ko": return `${name}이/가 가장 좋아하는 숫자는 뭐예요?`;
        case "tr": return `${name}’nin en sevdiği sayı kaç?`;
        case "it": return `Qual è il numero preferito di ${name}?`;
        case "id": return `Berapa angka favorit ${name}?`;
        case "ru": return `Какое любимое число у ${name}?`;
        default: return `What's ${name}'s favorite number?`;
      }
    }, "🔢"),
    new Question("n11", "basic", "text", lang => {
      switch (lang) {
        case "de": return "Was ist mein Spitzname?";
        case "fr": return "Quel est mon surnom ?";
        case "es": return "¿Cuál es mi apodo?";
        case "pt": return "Qual é o meu apelido?";
        case "ar": return "ما هو لقبي؟";
        case "ja": return "私のあだ名は何ですか？";
        case "ko": return "내 별명은 뭐예요?";
        case "tr": return "Lakabım ne?";
        case "it": return "Qual è il mio soprannome?";
        case "id": return "Apa nama panggilan saya?";
        case "ru": return "Какое у меня прозвище?";
        default: return "What's my nickname?";
      }
    }, (name, lang) => {
      switch (lang) {
        case "de": return `Was ist ${name}s Spitzname?`;
        case "fr": return `Quel est le surnom de ${name} ?`;
        case "es": return `¿Cuál es el apodo de ${name}?`;
        case "pt": return `Qual é o apelido de ${name}?`;
        case "ar": return `ما هو لقب ${name}؟`;
        case "ja": return `${name}のあだ名は何ですか？`;
        case "ko": return `${name}의 별명은 뭐예요?`;
        case "tr": return `${name}’nin lakabı ne?`;
        case "it": return `Qual è il soprannome di ${name}?`;
        case "id": return `Apa nama panggilan ${name}?`;
        case "ru": return `Какое прозвище у ${name}?`;
        default: return `What's ${name}'s nickname?`;
      }
    }, "🏷️"),
  ];



  // EMOJI TELEPATHY
export const couQuestions = [
  new Question("cou00", "cou", "text", lang => {
    switch (lang) {
      case "ar": return "متى بدأنا علاقتنا؟"
      case "fr": return "Quand nous sommes-nous mis ensemble ?"
      case "de": return "Wann sind wir zusammengekommen?"
      case "id": return "Kapan kita mulai bersama?"
      case "it": return "Quando ci siamo messi insieme?"
      case "ja": return "私たちはいつ付き合い始めた？"
      case "ko": return "우리는 언제 사귀기 시작했어?"
      case "pt": return "Quando começamos a namorar?"
      case "ru": return "Когда мы начали встречаться?"
      case "es": return "¿Cuándo empezamos a salir juntos?"
      case "tr": return "Ne zaman birlikte olmaya başladık?"
      default: return "When did we get together?"
    }
  }, (name, lang) => {
    return ""
  }, "⌛️"),
  new Question("cou01", "cou", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من قال \"أحبك\" أولاً؟"
      case "fr": return "Qui a dit « Je t’aime » en premier ?"
      case "de": return "Wer hat zuerst 'Ich liebe dich' gesagt?"
      case "id": return "Siapa yang bilang \"Aku cinta kamu\" duluan?"
      case "it": return "Chi ha detto \"Ti amo\" per primo?"
      case "ja": return "先に「愛してる」って言ったのはどっち？"
      case "ko": return "먼저 \"사랑해\"라고 말한 사람은 누구야?"
      case "pt": return "Quem disse \"eu te amo\" primeiro?"
      case "ru": return "Кто первым сказал(а) «Я тебя люблю»?"
      case "es": return "¿Quién dijo \"te quiero\" primero?"
      case "tr": return "İlk \"Seni seviyorum\" diyen kimdi?"
      default: return "Who said 'I love you' first?"
    }
  }, (name, lang) => {
    return ""
  }, "💌"),
  new Question("cou02", "cou", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من كان مهتمًا أولاً؟"
      case "fr": return "Qui a été intéressé en premier ?"
      case "de": return "Wer war zuerst interessiert?"
      case "id": return "Siapa yang tertarik duluan?"
      case "it": return "Chi si è interessato per primo?"
      case "ja": return "先に興味を持ったのはどっち？"
      case "ko": return "먼저 관심 가진 사람은 누구야?"
      case "pt": return "Quem se interessou primeiro?"
      case "ru": return "Кто заинтересовался первым?"
      case "es": return "¿Quién se interesó primero?"
      case "tr": return "İlk kim ilgilendi?"
      default: return "Who was interested first?"
    }
  }, (name, lang) => {
    return ""
  }, "😍"),
  new Question("cou03", "cou", "text", lang => {
    switch (lang) {
      case "ar": return "ماذا فعلنا في موعدنا الأول؟"
      case "fr": return "Qu’est-ce qu’on a fait à notre premier rendez-vous ?"
      case "de": return "Was haben wir auf unserem ersten Date gemacht?"
      case "id": return "Apa yang kita lakukan di kencan pertama kita?"
      case "it": return "Cosa abbiamo fatto al nostro primo appuntamento?"
      case "ja": return "初デートで何した？"
      case "ko": return "우리 첫 데이트 때 뭐 했어?"
      case "pt": return "O que fizemos no nosso primeiro encontro?"
      case "ru": return "Что мы делали на нашем первом свидании?"
      case "es": return "¿Qué hicimos en nuestra primera cita?"
      case "tr": return "İlk buluşmamızda ne yaptık?"
      default: return "What did we do on our first date?"
    }
  }, (name, lang) => {
    return ""
  }, "1️⃣"),
  new Question("cou04", "cou", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من الأكثر غيرة؟"
      case "fr": return "Qui est le plus jaloux ?"
      case "de": return "Wer ist eifersüchtiger?"
      case "id": return "Siapa yang lebih cemburuan?"
      case "it": return "Chi è più geloso?"
      case "ja": return "嫉妬深いのはどっち？"
      case "ko": return "누가 더 질투가 많아?"
      case "pt": return "Quem é mais ciumento(a)?"
      case "ru": return "Кто более ревнивый(ая)?"
      case "es": return "¿Quién es más celoso(a)?"
      case "tr": return "Kim daha kıskanç?"
      default: return "Who is more jealous?"
    }
  }, (name, lang) => {
    return ""
  }, "🗯️"),
  new Question("cou05", "cou", "text", lang => {
    switch (lang) {
      case "ar": return "عمّ نتشاجر أكثر شيء؟"
      case "fr": return "À propos de quoi se dispute-t-on le plus ?"
      case "de": return "Was ist unser häufigstes Streitthema?"
      case "id": return "Kita paling sering berdebat soal apa?"
      case "it": return "Su cosa litighiamo più spesso?"
      case "ja": return "私たちが一番よくケンカするのは何？"
      case "ko": return "우리가 가장 자주 싸우는 건 뭐야?"
      case "pt": return "Sobre o que a gente mais briga?"
      case "ru": return "Из-за чего мы чаще всего спорим?"
      case "es": return "¿Por qué discutimos más a menudo?"
      case "tr": return "En çok ne hakkında tartışıyoruz?"
      default: return "What do we argue most about?"
    }
  }, (name, lang) => {
    return ""
  }, "💥"),
  new Question("cou06", "cou", "text", lang => {
    return ""
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `ما هي لغة الحب لدى ${name}؟`
      case "fr": return `Quel est le langage de l’amour de ${name} ?`
      case "de": return `Was ist ${name}s Love Language?`
      case "id": return `Apa love language ${name}?`
      case "it": return `Qual è il linguaggio dell’amore di ${name}?`
      case "ja": return `${name}のラブランゲージは何？`
      case "ko": return `${name}의 러브 랭귀지는 뭐야?`
      case "pt": return `Qual é a linguagem do amor do(a) ${name}?`
      case "ru": return `Какой язык любви у ${name}?`
      case "es": return `¿Cuál es el lenguaje del amor de ${name}?`
      case "tr": return `${name}’in sevgi dili ne?`
      default: return `What's ${name}'s love language?`
    }
  }, "💝"),
  new Question("cou07", "cou", "text", lang => {
    return ""
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `كم عدد الأطفال الذين يريد ${name} إنجابهم؟`
      case "fr": return `Combien d’enfants ${name} veut-il/elle ?`
      case "de": return `Wie viele Kinder möchte ${name} haben?`
      case "id": return `${name} mau punya berapa anak?`
      case "it": return `Quanti figli vuole ${name}?`
      case "ja": return `${name}は子どもが何人ほしい？`
      case "ko": return `${name}은(는) 아이를 몇 명 원해?`
      case "pt": return `Quantos filhos ${name} quer?`
      case "ru": return `Сколько детей хочет ${name}?`
      case "es": return `¿Cuántos hijos quiere ${name}?`
      case "tr": return `${name} kaç çocuk istiyor?`
      default: return `How many kids does ${name} want?`
    }
  }, "🍼"),
  new Question("cou08", "cou", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من الأكثر تعلقًا؟"
      case "fr": return "Qui est le plus collant ?"
      case "de": return "Wer ist anhänglicher?"
      case "id": return "Siapa yang lebih manja?"
      case "it": return "Chi è più appiccicoso?"
      case "ja": return "依存しがちなのはどっち？"
      case "ko": return "누가 더 집착하는 편이야?"
      case "pt": return "Quem é mais grudado(a)?"
      case "ru": return "Кто более навязчивый(ая)?"
      case "es": return "¿Quién es más pegajoso(a)?"
      case "tr": return "Kim daha yapışkan?"
      default: return "Who is more clingy?"
    }
  }, (name, lang) => {
    return ""
  }, "🧲"),
  new Question("cou09", "cou", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من الأكثر رومانسية؟"
      case "fr": return "Qui est le plus romantique ?"
      case "de": return "Wer ist romantischer?"
      case "id": return "Siapa yang lebih romantis?"
      case "it": return "Chi è più romantico?"
      case "ja": return "よりロマンチックなのはどっち？"
      case "ko": return "누가 더 로맨틱해?"
      case "pt": return "Quem é mais romântico(a)?"
      case "ru": return "Кто романтичнее?"
      case "es": return "¿Quién es más romántico(a)?"
      case "tr": return "Kim daha romantik?"
      default: return "Who is more romantic?"
    }
  }, (name, lang) => {
    return ""
  }, "💕"),
  new Question("cou10", "cou", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من يرسل رسالة أولاً في الصباح?";
      case "fr": return "Qui envoie le premier message le matin ?";
      case "de": return "Wer schreibt morgens zuerst?";
      case "id": return "Siapa yang chat duluan di pagi hari?";
      case "it": return "Chi scrive per primo al mattino?";
      case "ja": return "朝、先にメッセージするのはどっち？";
      case "ko": return "아침에 먼저 문자하는 사람은 누구야?";
      case "pt": return "Quem manda mensagem primeiro de manhã?";
      case "ru": return "Кто первым пишет утром?";
      case "es": return "¿Quién escribe primero por la mañana?";
      case "tr": return "Sabah ilk mesajı kim atar?";
      default: return "Who texts first in the morning?";
    }
  }, (name, lang) => {
    return "";
  }, "💬"),
  new Question("cou11", "cou", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من يخطط للمواعيد أكثر؟";
      case "fr": return "Qui planifie des rendez-vous le plus souvent ?";
      case "de": return "Wer plant öfter Dates?";
      case "id": return "Siapa yang lebih sering merencanakan kencan?";
      case "it": return "Chi organizza più spesso gli appuntamenti?";
      case "ja": return "デートの計画をよく立てるのはどっち？";
      case "ko": return "누가 데이트를 더 자주 계획해?";
      case "pt": return "Quem planeja encontros com mais frequência?";
      case "ru": return "Кто чаще планирует свидания?";
      case "es": return "¿Quién planea más a menudo las citas?";
      case "tr": return "Kim daha sık buluşma planlar?";
      default: return "Who plans dates more often?";
    }
  }, (name, lang) => {
    return "";
  }, "📅"),
  new Question("cou12", "cou", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من يحتاج إلى اهتمام أكثر؟";
      case "fr": return "Qui a besoin de plus d’attention ?";
      case "de": return "Wer braucht mehr Aufmerksamkeit?";
      case "id": return "Siapa yang butuh lebih banyak perhatian?";
      case "it": return "Chi ha bisogno di più attenzioni?";
      case "ja": return "より構ってほしいのはどっち？";
      case "ko": return "누가 더 관심이 필요해?";
      case "pt": return "Quem precisa de mais atenção?";
      case "ru": return "Кому нужно больше внимания?";
      case "es": return "¿Quién necesita más atención?";
      case "tr": return "Kim daha çok ilgi ister?";
      default: return "Who needs more attention?";
    }
  }, (name, lang) => {
    return "";
  }, "🚨"),
  new Question("cou13", "cou", "text", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `ما الذي يجده ${name} أكثر جاذبية فيك؟`;
      case "fr": return `Qu’est-ce que ${name} trouve le plus attirant chez toi ?`;
      case "de": return `Was findet ${name} am attraktivsten an dir?`;
      case "id": return `Apa yang paling ${name} anggap menarik dari kamu?`;
      case "it": return `Cosa trova ${name} più attraente di te?`;
      case "ja": return `${name}があなたの一番魅力的だと思うところは？`;
      case "ko": return `${name}이(가) 너에게서 가장 매력적이라고 생각하는 건 뭐야?`;
      case "pt": return `O que ${name} acha mais atraente em você?`;
      case "ru": return `Что ${name} считает в тебе самым привлекательным?`;
      case "es": return `¿Qué es lo que ${name} encuentra más atractivo de ti?`;
      case "tr": return `${name} sende en çekici bulduğu şey ne?`;
      default: return `What does ${name} find most attractive about you?`;
    }
  }, "🥰"),
  new Question("cou14", "cou", "text", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `ما أكبر علامة حمراء لدى ${name}؟`;
      case "fr": return `Quel est le plus gros red flag de ${name} ?`;
      case "de": return `Was ist ${name}s größte Red Flag?`;
      case "id": return `Apa red flag terbesar ${name}?`;
      case "it": return `Qual è la più grande red flag di ${name}?`;
      case "ja": return `${name}の最大のレッドフラッグは？`;
      case "ko": return `${name}의 가장 큰 레드 플래그는 뭐야?`;
      case "pt": return `Qual é a maior red flag do(a) ${name}?`;
      case "ru": return `Какой самый большой ред-флаг у ${name}?`;
      case "es": return `¿Cuál es la mayor red flag de ${name}?`;
      case "tr": return `${name}’in en büyük red flag’i ne?`;
      default: return `What's ${name}'s biggest red flag?`;
    }
  }, "🚩"),
  new Question("cou15", "cou", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من يقدم مجاملات أكثر؟"
      case "fr": return "Qui fait le plus de compliments ?"
      case "de": return "Wer macht mehr Komplimente?"
      case "id": return "Siapa yang lebih sering memberi pujian?"
      case "it": return "Chi fa più complimenti?"
      case "ja": return "褒めるのが多いのはどっち？"
      case "ko": return "누가 더 칭찬을 많이 해?"
      case "pt": return "Quem faz mais elogios?"
      case "ru": return "Кто делает больше комплиментов?"
      case "es": return "¿Quién hace más cumplidos?"
      case "tr": return "Kim daha çok iltifat eder?"
      default: return "Who compliments more?"
    }
  }, (name, lang) => {
    return ""
  }, "💌"),
  new Question("cou16", "cou", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من الأفضل في اختيار الهدايا؟"
      case "fr": return "Qui est le/la meilleur(e) pour offrir des cadeaux ?"
      case "de": return "Wer macht die besseren Geschenke?"
      case "id": return "Siapa yang lebih jago memberi hadiah?"
      case "it": return "Chi è più bravo a fare regali?"
      case "ja": return "プレゼント選びが上手なのはどっち？"
      case "ko": return "선물 고르는 게 더 잘하는 사람은 누구야?"
      case "pt": return "Quem é melhor em dar presentes?"
      case "ru": return "Кто лучше дарит подарки?"
      case "es": return "¿Quién es mejor dando regalos?"
      case "tr": return "Hediye seçmede kim daha iyi?"
      default: return "Who's better at gift giving?"
    }
  }, (name, lang) => {
    return ""
  }, "🎁"),
  new Question("cou17", "cou", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من ينام أولاً؟"
      case "fr": return "Qui s’endort en premier ?"
      case "de": return "Wer schläft zuerst ein?"
      case "id": return "Siapa yang tidur duluan?"
      case "it": return "Chi si addormenta per primo?"
      case "ja": return "先に寝落ちするのはどっち？"
      case "ko": return "누가 먼저 잠들어?"
      case "pt": return "Quem dorme primeiro?"
      case "ru": return "Кто засыпает первым?"
      case "es": return "¿Quién se duerme primero?"
      case "tr": return "İlk kim uykuya dalar?"
      default: return "Who falls asleep first?"
    }
  }, (name, lang) => {
    return ""
  }, "🛏️"),
  new Question("cou18", "cou", "text", lang => {
    switch (lang) {
      case "ar": return "أين التقينا لأول مرة؟"
      case "fr": return "Où nous sommes-nous rencontrés pour la première fois ?"
      case "de": return "Wo haben wir uns zuerst gesehen?"
      case "id": return "Di mana kita pertama kali bertemu?"
      case "it": return "Dove ci siamo incontrati per la prima volta?"
      case "ja": return "私たちはどこで初めて出会った？"
      case "ko": return "우리가 처음 만난 곳은 어디야?"
      case "pt": return "Onde nos conhecemos pela primeira vez?"
      case "ru": return "Где мы впервые встретились?"
      case "es": return "¿Dónde nos conocimos por primera vez?"
      case "tr": return "İlk nerede tanıştık?"
      default: return "Where did we first meet?"
    }
  }, (name, lang) => {
    return ""
  }, "📍"),
  new Question("cou19", "cou", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من يعتذر أولاً بعد الشجار؟"
      case "fr": return "Qui s’excuse en premier après une dispute ?"
      case "de": return "Wer entschuldigt sich zuerst nach einem Streit?"
      case "id": return "Siapa yang minta maaf duluan setelah bertengkar?"
      case "it": return "Chi si scusa per primo dopo un litigio?"
      case "ja": return "ケンカの後、先に謝るのはどっち？"
      case "ko": return "싸운 뒤에 먼저 사과하는 사람은 누구야?"
      case "pt": return "Quem pede desculpas primeiro depois de uma briga?"
      case "ru": return "Кто первым извиняется после ссоры?"
      case "es": return "¿Quién se disculpa primero después de una pelea?"
      case "tr": return "Tartışmadan sonra ilk kim özür diler?"
      default: return "Who apologizes first after a fight?"
    }
  }, (name, lang) => {
    return ""
  }, "❤️‍🩹"),
]

// THIS OR THAT
export const totQuestions = [
  new Question("tot00", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل يفضّل ${name} المراسلة أم الاتصال؟`;
      case "fr": return `${name} préfère écrire des messages ou appeler ?`;
      case "de": return `Mag ${name} lieber schreiben oder telefonieren?`;
      case "id": return `Apakah ${name} lebih suka chat atau menelepon?`;
      case "it": return `${name} preferisce messaggiare o chiamare?`;
      case "ja": return `${name}はメッセージ派？それとも通話派？`;
      case "ko": return `${name}은(는) 문자하는 걸 더 좋아해, 아니면 전화하는 걸 더 좋아해?`;
      case "pt": return `${name} prefere mandar mensagem ou ligar?`;
      case "ru": return `${name} предпочитает переписываться или звонить?`;
      case "es": return `¿${name} prefiere escribir mensajes o llamar?`;
      case "tr": return `${name} mesajlaşmayı mı yoksa aramayı mı tercih eder?`;
      default: return `Does ${name} prefer texting or calling?`;
    }
  }, ["💬", "📞"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["💬 مراسلة", "📞 اتصال"];
      case "fr": return ["💬 Messages", "📞 Appels"];
      case "de": return ["💬 Schreiben", "📞 Telefonieren"];
      case "id": return ["💬 Chat", "📞 Telepon"];
      case "it": return ["💬 Messaggiare", "📞 Chiamare"];
      case "ja": return ["💬 メッセージ", "📞 通話"];
      case "ko": return ["💬 문자", "📞 전화"];
      case "pt": return ["💬 Mensagens", "📞 Ligações"];
      case "ru": return ["💬 Сообщения", "📞 Звонки"];
      case "es": return ["💬 Mensajes", "📞 Llamadas"];
      case "tr": return ["💬 Mesajlaşma", "📞 Arama"];
      default: return ["💬 Texting", "📞 Calling"];
    }
  }),
  new Question("tot01", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل ${name} يفضّل القطط أم الكلاب؟`;
      case "fr": return `${name} préfère les chats ou les chiens ?`;
      case "de": return `Mag ${name} lieber Katzen oder Hunde?`;
      case "id": return `${name} lebih suka kucing atau anjing?`;
      case "it": return `${name} preferisce i gatti o i cani?`;
      case "ja": return `${name}は猫派？犬派？`;
      case "ko": return `${name}은(는) 고양이파야, 강아지파야?`;
      case "pt": return `${name} prefere gatos ou cachorros?`;
      case "ru": return `${name} больше любит кошек или собак?`;
      case "es": return `¿A ${name} le gustan más los gatos o los perros?`;
      case "tr": return `${name} kedileri mi köpekleri mi daha çok sever?`;
      default: return `Is ${name} a cat or a dog person?`;
    }
  }, ["🐱", "🐶"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["🐱 قطط", "🐶 كلاب"];
      case "fr": return ["🐱 Chats", "🐶 Chiens"];
      case "de": return ["🐱 Katzen", "🐶 Hunde"];
      case "id": return ["🐱 Kucing", "🐶 Anjing"];
      case "it": return ["🐱 Gatti", "🐶 Cani"];
      case "ja": return ["🐱 猫", "🐶 犬"];
      case "ko": return ["🐱 고양이", "🐶 강아지"];
      case "pt": return ["🐱 Gatos", "🐶 Cachorros"];
      case "ru": return ["🐱 Кошки", "🐶 Собаки"];
      case "es": return ["🐱 Gatos", "🐶 Perros"];
      case "tr": return ["🐱 Kediler", "🐶 Köpekler"];
      default: return ["🐱 Cats", "🐶 Dogs"];
    }
  }),
  new Question("tot02", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل يستخدم ${name} الوضع الفاتح أم الداكن؟`;
      case "fr": return `${name} utilise le mode clair ou le mode sombre ?`;
      case "de": return `Benutzt ${name} Light oder Dark Mode?`;
      case "id": return `${name} pakai mode terang atau gelap?`;
      case "it": return `${name} usa la modalità chiara o scura?`;
      case "ja": return `${name}はライトモード？ダークモード？`;
      case "ko": return `${name}은(는) 라이트 모드야, 다크 모드야?`;
      case "pt": return `${name} usa modo claro ou escuro?`;
      case "ru": return `${name} использует светлую или тёмную тему?`;
      case "es": return `¿${name} usa modo claro u oscuro?`;
      case "tr": return `${name} açık modu mu koyu modu mu kullanıyor?`;
      default: return `Does ${name} use light or dark mode?`;
    }
  }, ["☀️", "🌙"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["☀️ فاتح", "🌙 داكن"];
      case "fr": return ["☀️ Clair", "🌙 Sombre"];
      case "de": return ["☀️ Light", "🌙 Dark"];
      case "id": return ["☀️ Terang", "🌙 Gelap"];
      case "it": return ["☀️ Chiaro", "🌙 Scuro"];
      case "ja": return ["☀️ ライト", "🌙 ダーク"];
      case "ko": return ["☀️ 라이트", "🌙 다크"];
      case "pt": return ["☀️ Claro", "🌙 Escuro"];
      case "ru": return ["☀️ Светлая", "🌙 Тёмная"];
      case "es": return ["☀️ Claro", "🌙 Oscuro"];
      case "tr": return ["☀️ Açık", "🌙 Koyu"];
      default: return ["☀️ Light", "🌙 Dark"];
    }
  }),
  new Question("tot03", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل ${name} مُبكّر الاستيقاظ أم ساهر الليل؟`;
      case "fr": return `${name} est plutôt lève-tôt ou oiseau de nuit ?`;
      case "de": return `Ist ${name} eher Frühaufsteher oder Nachteule?`;
      case "id": return `${name} tipe orang pagi atau begadang?`;
      case "it": return `${name} è mattiniero o nottambulo?`;
      case "ja": return `${name}は早起き派？夜更かし派？`;
      case "ko": return `${name}은(는) 아침형이야, 올빼미형이야?`;
      case "pt": return `${name} é mais madrugador(a) ou coruja?`;
      case "ru": return `${name} скорее жаворонок или сова?`;
      case "es": return `¿${name} es más madrugador(a) o noctámbulo(a)?`;
      case "tr": return `${name} daha çok sabahçı mı yoksa gece kuşu mu?`;
      default: return `Is ${name} an early bird or a night owl?`;
    }
  }, ["🌅", "🌙"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["🌅 مبكّر", "🌙 ساهر"];
      case "fr": return ["🌅 Lève-tôt", "🌙 Oiseau de nuit"];
      case "de": return ["🌅 Frühaufsteher", "🌙 Nachteule"];
      case "id": return ["🌅 Orang Pagi", "🌙 Night Owl"];
      case "it": return ["🌅 Mattiniero", "🌙 Nottambulo"];
      case "ja": return ["🌅 早起き", "🌙 夜更かし"];
      case "ko": return ["🌅 아침형", "🌙 올빼미형"];
      case "pt": return ["🌅 Madrugador(a)", "🌙 Coruja"];
      case "ru": return ["🌅 Жаворонок", "🌙 Сова"];
      case "es": return ["🌅 Madrugador(a)", "🌙 Noctámbulo(a)"];
      case "tr": return ["🌅 Sabahçı", "🌙 Gece kuşu"];
      default: return ["🌅 Early Bird", "🌙 Night Owl"];
    }
  }),
  new Question("tot04", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل يفضّل ${name} الصيف أم الشتاء؟`;
      case "fr": return `${name} préfère l’été ou l’hiver ?`;
      case "de": return `Mag ${name} lieber Sommer oder Winter?`;
      case "id": return `${name} lebih suka musim panas atau musim dingin?`;
      case "it": return `${name} preferisce l’estate o l’inverno?`;
      case "ja": return `${name}は夏派？冬派？`;
      case "ko": return `${name}은(는) 여름을 더 좋아해, 겨울을 더 좋아해?`;
      case "pt": return `${name} prefere verão ou inverno?`;
      case "ru": return `${name} больше любит лето или зиму?`;
      case "es": return `¿${name} prefiere el verano o el invierno?`;
      case "tr": return `${name} yazı mı kışı mı daha çok sever?`;
      default: return `Does ${name} prefer summer or winter?`;
    }
  }, ["☀️", "❄️"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["☀️ صيف", "❄️ شتاء"];
      case "fr": return ["☀️ Été", "❄️ Hiver"];
      case "de": return ["☀️ Sommer", "❄️ Winter"];
      case "id": return ["☀️ Musim Panas", "❄️ Musim Dingin"];
      case "it": return ["☀️ Estate", "❄️ Inverno"];
      case "ja": return ["☀️ 夏", "❄️ 冬"];
      case "ko": return ["☀️ 여름", "❄️ 겨울"];
      case "pt": return ["☀️ Verão", "❄️ Inverno"];
      case "ru": return ["☀️ Лето", "❄️ Зима"];
      case "es": return ["☀️ Verano", "❄️ Invierno"];
      case "tr": return ["☀️ Yaz", "❄️ Kış"];
      default: return ["☀️ Summer", "❄️ Winter"];
    }
  }),
  new Question("tot05", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل يفضّل ${name} الأفلام أم المسلسلات؟`;
      case "fr": return `${name} préfère les films ou les séries ?`;
      case "de": return `Schaut ${name} lieber Filme oder Serien?`;
      case "id": return `${name} lebih suka film atau serial TV?`;
      case "it": return `${name} preferisce film o serie TV?`;
      case "ja": return `${name}は映画派？ドラマ・シリーズ派？`;
      case "ko": return `${name}은(는) 영화가 좋아, 드라마/시리즈가 좋아?`;
      case "pt": return `${name} prefere filmes ou séries?`;
      case "ru": return `${name} предпочитает фильмы или сериалы?`;
      case "es": return `¿${name} prefiere películas o series?`;
      case "tr": return `${name} film mi dizi mi tercih eder?`;
      default: return `Does ${name} prefer movies or TV shows?`;
    }
  }, ["🎬", "📺"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["🎬 أفلام", "📺 مسلسلات"];
      case "fr": return ["🎬 Films", "📺 Séries"];
      case "de": return ["🎬 Filme", "📺 Serien"];
      case "id": return ["🎬 Film", "📺 Serial"];
      case "it": return ["🎬 Film", "📺 Serie TV"];
      case "ja": return ["🎬 映画", "📺 シリーズ"];
      case "ko": return ["🎬 영화", "📺 TV 쇼"];
      case "pt": return ["🎬 Filmes", "📺 Séries"];
      case "ru": return ["🎬 Фильмы", "📺 Сериалы"];
      case "es": return ["🎬 Películas", "📺 Series"];
      case "tr": return ["🎬 Filmler", "📺 Diziler"];
      default: return ["🎬 Movies", "📺 TV Shows"];
    }
  }),
  new Question("tot06", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل يفضّل ${name} الحلو أم المالح؟`;
      case "fr": return `${name} préfère le sucré ou le salé ?`;
      case "de": return `Mag ${name} lieber süß oder salzig?`;
      case "id": return `${name} lebih suka manis atau asin?`;
      case "it": return `${name} preferisce dolce o salato?`;
      case "ja": return `${name}は甘い派？しょっぱい派？`;
      case "ko": return `${name}은(는) 단 걸 좋아해, 짠 걸 좋아해?`;
      case "pt": return `${name} prefere doce ou salgado?`;
      case "ru": return `${name} предпочитает сладкое или солёное?`;
      case "es": return `¿${name} prefiere dulce o salado?`;
      case "tr": return `${name} tatlı mı tuzlu mu tercih eder?`;
      default: return `Does ${name} prefer sweet or salty?`;
    }
  }, ["🍫", "🧂"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["🍫 حلو", "🧂 مالح"];
      case "fr": return ["🍫 Sucré", "🧂 Salé"];
      case "de": return ["🍫 Süß", "🧂 Salzig"];
      case "id": return ["🍫 Manis", "🧂 Asin"];
      case "it": return ["🍫 Dolce", "🧂 Salato"];
      case "ja": return ["🍫 甘い", "🧂 しょっぱい"];
      case "ko": return ["🍫 달콤", "🧂 짭짤"];
      case "pt": return ["🍫 Doce", "🧂 Salgado"];
      case "ru": return ["🍫 Сладкое", "🧂 Солёное"];
      case "es": return ["🍫 Dulce", "🧂 Salado"];
      case "tr": return ["🍫 Tatlı", "🧂 Tuzlu"];
      default: return ["🍫 Sweet", "🧂 Salty"];
    }
  }),
  new Question("tot07", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل يفضّل ${name} الخروج للاحتفال أم البقاء في المنزل؟`;
      case "fr": return `${name} préfère sortir faire la fête ou rester à la maison ?`;
      case "de": return `Geht ${name} lieber feiern oder bleibt zuhause?`;
      case "id": return `${name} lebih suka pergi party atau di rumah saja?`;
      case "it": return `${name} preferisce uscire a far festa o restare a casa?`;
      case "ja": return `${name}は外で遊ぶ派？それとも家でまったり派？`;
      case "ko": return `${name}은(는) 나가서 놀고 싶어, 아니면 집에 있고 싶어?`;
      case "pt": return `${name} prefere sair pra curtir ou ficar em casa?`;
      case "ru": return `${name} скорее пойдёт тусоваться или останется дома?`;
      case "es": return `¿${name} prefiere salir de fiesta o quedarse en casa?`;
      case "tr": return `${name} dışarı çıkıp eğlenmeyi mi yoksa evde kalmayı mı tercih eder?`;
      default: return `Would ${name} rather go out partying or stay in?`;
    }
  }, ["🎉", "🏠"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["🎉 حفلة", "🏠 البقاء في المنزل"];
      case "fr": return ["🎉 Faire la fête", "🏠 Rester à la maison"];
      case "de": return ["🎉 Feiern", "🏠 Zuhause bleiben"];
      case "id": return ["🎉 Party", "🏠 Di Rumah"];
      case "it": return ["🎉 Festa", "🏠 Restare a casa"];
      case "ja": return ["🎉 外出", "🏠 おうち"];
      case "ko": return ["🎉 나가기", "🏠 집에 있기"];
      case "pt": return ["🎉 Sair", "🏠 Ficar em casa"];
      case "ru": return ["🎉 Выйти", "🏠 Остаться дома"];
      case "es": return ["🎉 Salir", "🏠 Quedarse en casa"];
      case "tr": return ["🎉 Dışarı çıkmak", "🏠 Evde kalmak"];
      default: return ["🎉 Go Out", "🏠 Stay In"];
    }
  }),
  new Question("tot08", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل ${name} أكثر عفوية أم يخطط لكل شيء؟`;
      case "fr": return `${name} est plutôt spontané(e) ou plutôt planificateur/trice ?`;
      case "de": return `Ist ${name} eher spontan oder plant alles?`;
      case "id": return `${name} lebih spontan atau suka merencanakan semuanya?`;
      case "it": return `${name} è più spontaneo(a) o pianifica tutto?`;
      case "ja": return `${name}は直感派？計画派？`;
      case "ko": return `${name}은(는) 즉흥적인 편이야, 계획하는 편이야?`;
      case "pt": return `${name} é mais espontâneo(a) ou planejador(a)?`;
      case "ru": return `${name} более спонтанный(ая) или всё планирует?`;
      case "es": return `¿${name} es más espontáneo(a) o planificador(a)?`;
      case "tr": return `${name} daha çok spontane mi yoksa planlı mı?`;
      default: return `Is ${name} more spontaneous or a planner?`;
    }
  }, ["🎲", "📅"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["🎲 عفوي", "📅 مُخطِّط"];
      case "fr": return ["🎲 Spontané(e)", "📅 Planificateur(trice)"];
      case "de": return ["🎲 Spontan", "📅 Plant alles"];
      case "id": return ["🎲 Spontan", "📅 Planner"];
      case "it": return ["🎲 Spontaneo(a)", "📅 Pianificatore"];
      case "ja": return ["🎲 直感派", "📅 計画派"];
      case "ko": return ["🎲 즉흥", "📅 계획형"];
      case "pt": return ["🎲 Espontâneo(a)", "📅 Planejador(a)"];
      case "ru": return ["🎲 Спонтанный(ая)", "📅 Планировщик"];
      case "es": return ["🎲 Espontáneo(a)", "📅 Planificador(a)"];
      case "tr": return ["🎲 Spontane", "📅 Planlı"];
      default: return ["🎲 Spontaneous", "📅 Planner"];
    }
  }),
  new Question("tot09", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل يفضّل ${name} الشاطئ أم الجبال؟`;
      case "fr": return `${name} préfère la plage ou la montagne ?`;
      case "de": return `Mag ${name} lieber Strand oder Berge?`;
      case "id": return `${name} lebih suka pantai atau pegunungan?`;
      case "it": return `${name} preferisce la spiaggia o la montagna?`;
      case "ja": return `${name}は海派？山派？`;
      case "ko": return `${name}은(는) 바다가 좋아, 산이 좋아?`;
      case "pt": return `${name} prefere praia ou montanha?`;
      case "ru": return `${name} предпочитает пляж или горы?`;
      case "es": return `¿${name} prefiere la playa o la montaña?`;
      case "tr": return `${name} sahili mi yoksa dağları mı tercih eder?`;
      default: return `Does ${name} prefer the beach or the mountains?`;
    }
  }, ["🏖️", "🏔️"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["🏖️ شاطئ", "🏔️ جبال"];
      case "fr": return ["🏖️ Plage", "🏔️ Montagne"];
      case "de": return ["🏖️ Strand", "🏔️ Berge"];
      case "id": return ["🏖️ Pantai", "🏔️ Pegunungan"];
      case "it": return ["🏖️ Spiaggia", "🏔️ Montagna"];
      case "ja": return ["🏖️ 海", "🏔️ 山"];
      case "ko": return ["🏖️ 바다", "🏔️ 산"];
      case "pt": return ["🏖️ Praia", "🏔️ Montanhas"];
      case "ru": return ["🏖️ Пляж", "🏔️ Горы"];
      case "es": return ["🏖️ Playa", "🏔️ Montañas"];
      case "tr": return ["🏖️ Sahil", "🏔️ Dağlar"];
      default: return ["🏖️ Beach", "🏔️ Mountains"];
    }
  }),
  new Question("tot10", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل يفضّل ${name} تيك توك أم إنستغرام؟`;
      case "fr": return `${name} préfère TikTok ou Instagram ?`;
      case "de": return `Mag ${name} lieber TikTok oder Instagram?`;
      case "id": return `${name} lebih suka TikTok atau Instagram?`;
      case "it": return `${name} preferisce TikTok o Instagram?`;
      case "ja": return `${name}はTikTokとInstagramどっちが好き？`;
      case "ko": return `${name}은(는) 틱톡이 좋아, 인스타그램이 좋아?`;
      case "pt": return `${name} prefere TikTok ou Instagram?`;
      case "ru": return `${name} больше любит TikTok или Instagram?`;
      case "es": return `¿${name} prefiere TikTok o Instagram?`;
      case "tr": return `${name} TikTok’u mu yoksa Instagram’ı mı tercih eder?`;
      default: return `Does ${name} prefer TikTok or Instagram?`;
    }
  }, ["📱", "📸"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["📱 تيك توك", "📸 إنستغرام"];
      case "fr": return ["📱 TikTok", "📸 Instagram"];
      case "de": return ["📱 TikTok", "📸 Instagram"];
      case "id": return ["📱 TikTok", "📸 Instagram"];
      case "it": return ["📱 TikTok", "📸 Instagram"];
      case "ja": return ["📱 TikTok", "📸 Instagram"];
      case "ko": return ["📱 TikTok", "📸 Instagram"];
      case "pt": return ["📱 TikTok", "📸 Instagram"];
      case "ru": return ["📱 TikTok", "📸 Instagram"];
      case "es": return ["📱 TikTok", "📸 Instagram"];
      case "tr": return ["📱 TikTok", "📸 Instagram"];
      default: return ["📱 TikTok", "📸 Instagram"];
    }
  }),
  new Question("tot11", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل ${name} انطوائي أكثر أم اجتماعي؟`;
      case "fr": return `${name} est plutôt introverti(e) ou extraverti(e) ?`;
      case "de": return `Ist ${name} eher introvertiert oder extrovertiert?`;
      case "id": return `${name} lebih introvert atau ekstrovert?`;
      case "it": return `${name} è più introverso(a) o estroverso(a)?`;
      case "ja": return `${name}は内向的？外向的？`;
      case "ko": return `${name}은(는) 내향적이야, 외향적이야?`;
      case "pt": return `${name} é mais introvertido(a) ou extrovertido(a)?`;
      case "ru": return `${name} скорее интроверт или экстраверт?`;
      case "es": return `¿${name} es más introvertido(a) o extrovertido(a)?`;
      case "tr": return `${name} daha çok içe dönük mü dışa dönük mü?`;
      default: return `Is ${name} more introverted or extroverted?`;
    }
  }, ["🤫", "🎤"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["🤫 انطوائي", "🎤 اجتماعي"];
      case "fr": return ["🤫 Introverti(e)", "🎤 Extraverti(e)"];
      case "de": return ["🤫 Introvertiert", "🎤 Extrovertiert"];
      case "id": return ["🤫 Introvert", "🎤 Ekstrovert"];
      case "it": return ["🤫 Introverso", "🎤 Estroverso"];
      case "ja": return ["🤫 内向的", "🎤 外向的"];
      case "ko": return ["🤫 내향적", "🎤 외향적"];
      case "pt": return ["🤫 Introvertido(a)", "🎤 Extrovertido(a)"];
      case "ru": return ["🤫 Интроверт", "🎤 Экстраверт"];
      case "es": return ["🤫 Introvertido(a)", "🎤 Extrovertido(a)"];
      case "tr": return ["🤫 İçe dönük", "🎤 Dışa dönük"];
      default: return ["🤫 Introverted", "🎤 Extroverted"];
    }
  }),
  new Question("tot12", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل يفضّل ${name} الموسيقى أم البودكاست؟`;
      case "fr": return `${name} préfère la musique ou les podcasts ?`;
      case "de": return `Mag ${name} Musik oder Podcasts lieber?`;
      case "id": return `${name} lebih suka musik atau podcast?`;
      case "it": return `${name} preferisce la musica o i podcast?`;
      case "ja": return `${name}は音楽派？ポッドキャスト派？`;
      case "ko": return `${name}은(는) 음악이 좋아, 팟캐스트가 좋아?`;
      case "pt": return `${name} prefere música ou podcasts?`;
      case "ru": return `${name} предпочитает музыку или подкасты?`;
      case "es": return `¿${name} prefiere música o podcasts?`;
      case "tr": return `${name} müziği mi podcastleri mi tercih eder?`;
      default: return `Does ${name} prefer music or podcasts?`;
    }
  }, ["🎶", "🎙️"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["🎶 موسيقى", "🎙️ بودكاست"];
      case "fr": return ["🎶 Musique", "🎙️ Podcasts"];
      case "de": return ["🎶 Musik", "🎙️ Podcasts"];
      case "id": return ["🎶 Musik", "🎙️ Podcast"];
      case "it": return ["🎶 Musica", "🎙️ Podcast"];
      case "ja": return ["🎶 音楽", "🎙️ ポッドキャスト"];
      case "ko": return ["🎶 음악", "🎙️ 팟캐스트"];
      case "pt": return ["🎶 Música", "🎙️ Podcasts"];
      case "ru": return ["🎶 Музыка", "🎙️ Подкасты"];
      case "es": return ["🎶 Música", "🎙️ Podcasts"];
      case "tr": return ["🎶 Müzik", "🎙️ Podcast"];
      default: return ["🎶 Music", "🎙️ Podcasts"];
    }
  }),
  new Question("tot13", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل يفضّل ${name} أندرويد أم آيفون؟`;
      case "fr": return `${name} préfère Android ou iPhone ?`;
      case "de": return `Mag ${name} Android oder iPhone lieber?`;
      case "id": return `${name} lebih suka Android atau iPhone?`;
      case "it": return `${name} preferisce Android o iPhone?`;
      case "ja": return `${name}はAndroid派？iPhone派？`;
      case "ko": return `${name}은(는) 안드로이드가 좋아, 아이폰이 좋아?`;
      case "pt": return `${name} prefere Android ou iPhone?`;
      case "ru": return `${name} предпочитает Android или iPhone?`;
      case "es": return `¿${name} prefiere Android o iPhone?`;
      case "tr": return `${name} Android mi iPhone mu tercih eder?`;
      default: return `Does ${name} prefer Android or iPhone?`;
    }
  }, ["🤖", "🍎"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["🤖 أندرويد", "🍎 آيفون"];
      case "fr": return ["🤖 Android", "🍎 iPhone"];
      case "de": return ["🤖 Android", "🍎 iPhone"];
      case "id": return ["🤖 Android", "🍎 iPhone"];
      case "it": return ["🤖 Android", "🍎 iPhone"];
      case "ja": return ["🤖 Android", "🍎 iPhone"];
      case "ko": return ["🤖 Android", "🍎 iPhone"];
      case "pt": return ["🤖 Android", "🍎 iPhone"];
      case "ru": return ["🤖 Android", "🍎 iPhone"];
      case "es": return ["🤖 Android", "🍎 iPhone"];
      case "tr": return ["🤖 Android", "🍎 iPhone"];
      default: return ["🤖 Android", "🍎 iPhone"];
    }
  }),
  new Question("tot14", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل يفضّل ${name} نتفليكس أم يوتيوب؟`;
      case "fr": return `${name} préfère Netflix ou YouTube ?`;
      case "de": return `Benutzt ${name} eher Netflix oder YouTube?`;
      case "id": return `${name} lebih suka Netflix atau YouTube?`;
      case "it": return `${name} preferisce Netflix o YouTube?`;
      case "ja": return `${name}はNetflix派？YouTube派？`;
      case "ko": return `${name}은(는) 넷플릭스가 좋아, 유튜브가 좋아?`;
      case "pt": return `${name} prefere Netflix ou YouTube?`;
      case "ru": return `${name} предпочитает Netflix или YouTube?`;
      case "es": return `¿${name} prefiere Netflix o YouTube?`;
      case "tr": return `${name} Netflix’i mi yoksa YouTube’u mu tercih eder?`;
      default: return `Does ${name} prefer Netflix or YouTube?`;
    }
  }, ["🎬", "▶️"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["🎬 نتفليكس", "▶️ يوتيوب"];
      case "fr": return ["🎬 Netflix", "▶️ YouTube"];
      case "de": return ["🎬 Netflix", "▶️ YouTube"];
      case "id": return ["🎬 Netflix", "▶️ YouTube"];
      case "it": return ["🎬 Netflix", "▶️ YouTube"];
      case "ja": return ["🎬 Netflix", "▶️ YouTube"];
      case "ko": return ["🎬 Netflix", "▶️ YouTube"];
      case "pt": return ["🎬 Netflix", "▶️ YouTube"];
      case "ru": return ["🎬 Netflix", "▶️ YouTube"];
      case "es": return ["🎬 Netflix", "▶️ YouTube"];
      case "tr": return ["🎬 Netflix", "▶️ YouTube"];
      default: return ["🎬 Netflix", "▶️ YouTube"];
    }
  }),
  new Question("tot15", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل يفضّل ${name} الماء أم المشروبات الغازية؟`;
      case "fr": return `${name} préfère l’eau ou les sodas ?`;
      case "de": return `Mag ${name} lieber Wasser oder Softdrinks?`;
      case "id": return `${name} lebih suka air putih atau minuman bersoda?`;
      case "it": return `${name} preferisce l’acqua o le bibite?`;
      case "ja": return `${name}は水派？ソフトドリンク派？`;
      case "ko": return `${name}은(는) 물이 좋아, 탄산음료가 좋아?`;
      case "pt": return `${name} prefere água ou refrigerantes?`;
      case "ru": return `${name} предпочитает воду или газировку?`;
      case "es": return `¿${name} prefiere agua o refrescos?`;
      case "tr": return `${name} suyu mu yoksa gazlı içecekleri mi tercih eder?`;
      default: return `Does ${name} prefer water or soft drinks?`;
    }
  }, ["💧", "🥤"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["💧 ماء", "🥤 مشروبات غازية"];
      case "fr": return ["💧 Eau", "🥤 Sodas"];
      case "de": return ["💧 Wasser", "🥤 Softdrinks"];
      case "id": return ["💧 Air", "🥤 Soft Drink"];
      case "it": return ["💧 Acqua", "🥤 Bibite"];
      case "ja": return ["💧 水", "🥤 ソフトドリンク"];
      case "ko": return ["💧 물", "🥤 탄산음료"];
      case "pt": return ["💧 Água", "🥤 Refrigerantes"];
      case "ru": return ["💧 Вода", "🥤 Газировка"];
      case "es": return ["💧 Agua", "🥤 Refrescos"];
      case "tr": return ["💧 Su", "🥤 Gazlı içecekler"];
      default: return ["💧 Water", "🥤 Soft Drinks"];
    }
  }),
  new Question("tot16", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل ${name} صبور أم غير صبور؟`;
      case "fr": return `${name} est plutôt patient(e) ou impatient(e) ?`;
      case "de": return `Ist ${name} eher geduldig oder ungeduldig?`;
      case "id": return `${name} lebih sabar atau tidak sabaran?`;
      case "it": return `${name} è più paziente o impaziente?`;
      case "ja": return `${name}は我慢強い？せっかち？`;
      case "ko": return `${name}은(는) 인내심이 있어, 성급해?`;
      case "pt": return `${name} é mais paciente ou impaciente?`;
      case "ru": return `${name} скорее терпеливый(ая) или нетерпеливый(ая)?`;
      case "es": return `¿${name} es más paciente o impaciente?`;
      case "tr": return `${name} daha çok sabırlı mı sabırsız mı?`;
      default: return `Is ${name} rather patient or impatient?`;
    }
  }, ["⌛️", "💣"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["⌛️ صبور", "💣 غير صبور"];
      case "fr": return ["⌛️ Patient(e)", "💣 Impatient(e)"];
      case "de": return ["⌛️ Geduldig", "💣 Ungeduldig"];
      case "id": return ["⌛️ Sabar", "💣 Tidak sabar"];
      case "it": return ["⌛️ Paziente", "💣 Impaziente"];
      case "ja": return ["⌛️ 我慢強い", "💣 せっかち"];
      case "ko": return ["⌛️ 인내심", "💣 성급함"];
      case "pt": return ["⌛️ Paciente", "💣 Impaciente"];
      case "ru": return ["⌛️ Терпеливый(ая)", "💣 Нетерпеливый(ая)"];
      case "es": return ["⌛️ Paciente", "💣 Impaciente"];
      case "tr": return ["⌛️ Sabırlı", "💣 Sabırsız"];
      default: return ["⌛️ Patient", "💣 Impatient"];
    }
  }),
  new Question("tot17", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل ${name} عاطفي أكثر أم عقلاني؟`;
      case "fr": return `${name} est plutôt émotionnel(le) ou rationnel(le) ?`;
      case "de": return `Ist ${name} eher emotional oder rational?`;
      case "id": return `${name} lebih emosional atau rasional?`;
      case "it": return `${name} è più emotivo(a) o razionale?`;
      case "ja": return `${name}は感情派？理性派？`;
      case "ko": return `${name}은(는) 감정적인 편이야, 이성적인 편이야?`;
      case "pt": return `${name} é mais emocional ou racional?`;
      case "ru": return `${name} скорее эмоциональный(ая) или рациональный(ая)?`;
      case "es": return `¿${name} es más emocional o racional?`;
      case "tr": return `${name} daha çok duygusal mı mantıklı mı?`;
      default: return `Is ${name} rather emotional or rational?`;
    }
  }, ["🔥", "🧊"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["🔥 عاطفي", "🧊 عقلاني"];
      case "fr": return ["🔥 Émotionnel(le)", "🧊 Rationnel(le)"];
      case "de": return ["🔥 Emotional", "🧊 Rational"];
      case "id": return ["🔥 Emosional", "🧊 Rasional"];
      case "it": return ["🔥 Emotivo", "🧊 Razionale"];
      case "ja": return ["🔥 感情派", "🧊 理性派"];
      case "ko": return ["🔥 감정적", "🧊 이성적"];
      case "pt": return ["🔥 Emocional", "🧊 Racional"];
      case "ru": return ["🔥 Эмоциональный(ая)", "🧊 Рациональный(ая)"];
      case "es": return ["🔥 Emocional", "🧊 Racional"];
      case "tr": return ["🔥 Duygusal", "🧊 Mantıklı"];
      default: return ["🔥 Emotional", "🧊 Rational"];
    }
  }),
  new Question("tot18", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل ${name} هادئ أكثر أم مليء بالطاقة؟`;
      case "fr": return `${name} est plutôt calme ou énergique ?`;
      case "de": return `Ist ${name} eher ruhig oder energisch?`;
      case "id": return `${name} lebih kalem atau energik?`;
      case "it": return `${name} è più calmo(a) o energico(a)?`;
      case "ja": return `${name}は落ち着いてる？それとも元気いっぱい？`;
      case "ko": return `${name}은(는) 차분한 편이야, 에너지가 넘쳐?`;
      case "pt": return `${name} é mais calmo(a) ou enérgico(a)?`;
      case "ru": return `${name} скорее спокойный(ая) или энергичный(aya)?`;
      case "es": return `¿${name} es más tranquilo(a) o enérgico(a)?`;
      case "tr": return `${name} daha çok sakin mi enerjik mi?`;
      default: return `Is ${name} rather calm or energetic?`;
    }
  }, ["👀", "⚡️"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["👀 هادئ", "⚡️ نشيط"];
      case "fr": return ["👀 Calme", "⚡️ Énergique"];
      case "de": return ["👀 Ruhig", "⚡️ Energisch"];
      case "id": return ["👀 Kalem", "⚡️ Energik"];
      case "it": return ["👀 Calmo", "⚡️ Energico"];
      case "ja": return ["👀 落ち着いてる", "⚡️ 元気"];
      case "ko": return ["👀 차분함", "⚡️ 에너제틱"];
      case "pt": return ["👀 Calmo(a)", "⚡️ Enérgico(a)"];
      case "ru": return ["👀 Спокойный(ая)", "⚡️ Энергичный(ая)"];
      case "es": return ["👀 Tranquilo(a)", "⚡️ Enérgico(a)"];
      case "tr": return ["👀 Sakin", "⚡️ Enerjik"];
      default: return ["👀 Calm", "⚡️ Energetic"];
    }
  }),
  new Question("tot19", "tot", "thisOrThat", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `هل ${name} منظّم أم فوضوي؟`;
      case "fr": return `${name} est plutôt ordonné(e) ou en bazar ?`;
      case "de": return `Ist ${name} eher ordentlich oder unordentlich?`;
      case "id": return `${name} lebih rapi atau berantakan?`;
      case "it": return `${name} è più ordinato(a) o disordinato(a)?`;
      case "ja": return `${name}はきれい好き？それとも散らかしがち？`;
      case "ko": return `${name}은(는) 깔끔한 편이야, 어질러진 편이야?`;
      case "pt": return `${name} é mais organizado(a) ou bagunceiro(a)?`;
      case "ru": return `${name} скорее аккуратный(ая) или неряшливый(ая)?`;
      case "es": return `¿${name} es más ordenado(a) o desordenado(a)?`;
      case "tr": return `${name} daha çok düzenli mi dağınık mı?`;
      default: return `Is ${name} rather tidy or messy?`;
    }
  }, ["✨", "🧨"][Math.floor(Math.random() * 2)], lang => {
    switch (lang) {
      case "ar": return ["✨ منظّم", "🧨 فوضوي"];
      case "fr": return ["✨ Ordonné(e)", "🧨 En bazar"];
      case "de": return ["✨ Ordentlich", "🧨 Unordentlich"];
      case "id": return ["✨ Rapi", "🧨 Berantakan"];
      case "it": return ["✨ Ordinato", "🧨 Disordinato"];
      case "ja": return ["✨ きれい好き", "🧨 散らかしがち"];
      case "ko": return ["✨ 깔끔", "🧨 지저분"];
      case "pt": return ["✨ Organizado(a)", "🧨 Bagunceiro(a)"];
      case "ru": return ["✨ Аккуратный(ая)", "🧨 Неряшливый(ая)"];
      case "es": return ["✨ Ordenado(a)", "🧨 Desordenado(a)"];
      case "tr": return ["✨ Düzenli", "🧨 Dağınık"];
      default: return ["✨ Tidy", "🧨 Messy"];
    }
  }),
]


// SIBLINGS
export const sibQuestions = [
  new Question("sib00", "sib", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من هو المفضّل عند أمي؟";
      case "fr": return "Qui est le/la préféré(e) de maman ?";
      case "de": return "Wer ist Mamas Liebling?";
      case "id": return "Siapa anak favorit mama?";
      case "it": return "Chi è il preferito/la preferita di mamma?";
      case "ja": return "ママのお気に入りは誰？";
      case "ko": return "엄마가 제일 좋아하는 사람은 누구야?";
      case "pt": return "Quem é o(a) favorito(a) da mamãe?";
      case "ru": return "Кто мамин любимчик?";
      case "es": return "¿Quién es el/la favorito(a) de mamá?";
      case "tr": return "Annenin favorisi kim?";
      default: return "Who is mom's favorite?";
    }
  }, (name, lang) => {
    return "";
  }, "🩷"),
  new Question("sib01", "sib", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من هو المفضّل عند أبي؟";
      case "fr": return "Qui est le/la préféré(e) de papa ?";
      case "de": return "Wer ist Papas Liebling?";
      case "id": return "Siapa anak favorit papa?";
      case "it": return "Chi è il preferito/la preferita di papà?";
      case "ja": return "パパのお気に入りは誰？";
      case "ko": return "아빠가 제일 좋아하는 사람은 누구야?";
      case "pt": return "Quem é o(a) favorito(a) do papai?";
      case "ru": return "Кто папин любимчик?";
      case "es": return "¿Quién es el/la favorito(a) de papá?";
      case "tr": return "Babanın favorisi kim?";
      default: return "Who is dad's favorite?";
    }
  }, (name, lang) => {
    return "";
  }, "💙"),
  new Question("sib02", "sib", "text", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `ما كانت لعبة ${name} المفضلة؟`;
      case "fr": return `Quel était le jouet préféré de ${name} ?`;
      case "de": return `Was war ${name}s Lieblingsspielzeug?`;
      case "id": return `Apa mainan favorit ${name}?`;
      case "it": return `Qual era il giocattolo preferito di ${name}?`;
      case "ja": return `${name}の一番好きなおもちゃは何だった？`;
      case "ko": return `${name}이(가) 제일 좋아하던 장난감은 뭐였어?`;
      case "pt": return `Qual era o brinquedo favorito do(a) ${name}?`;
      case "ru": return `Какая была любимая игрушка у ${name}?`;
      case "es": return `¿Cuál era el juguete favorito de ${name}?`;
      case "tr": return `${name}’in en sevdiği oyuncak neydi?`;
      default: return `What was ${name}'s favorite toy?`;
    }
  }, "🧸"),
  new Question("sib03", "sib", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من كان يتورّط في المشاكل أكثر؟";
      case "fr": return "Qui avait le plus d’ennuis ?";
      case "de": return "Wer hat mehr Ärger gemacht?";
      case "id": return "Siapa yang lebih sering kena masalah?";
      case "it": return "Chi finiva nei guai più spesso?";
      case "ja": return "よく怒られてたのはどっち？";
      case "ko": return "누가 더 자주 혼났어?";
      case "pt": return "Quem se metia mais em encrenca?";
      case "ru": return "Кто чаще попадал(а) в неприятности?";
      case "es": return "¿Quién se metía en problemas más a menudo?";
      case "tr": return "Kim daha çok başını belaya sokardı?";
      default: return "Who got in trouble more?";
    }
  }, (name, lang) => {
    return "";
  }, "💥"),
  new Question("sib04", "sib", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من الأكثر حمايةً؟";
      case "fr": return "Qui est le plus protecteur ?";
      case "de": return "Wer ist mehr beschützerisch?";
      case "id": return "Siapa yang lebih protektif?";
      case "it": return "Chi è più protettivo?";
      case "ja": return "より守ってくれるのはどっち？";
      case "ko": return "누가 더 보호 본능이 강해?";
      case "pt": return "Quem é mais protetor(a)?";
      case "ru": return "Кто более заботливый/защитнический?";
      case "es": return "¿Quién es más protector(a)?";
      case "tr": return "Kim daha korumacı?";
      default: return "Who's more protective?";
    }
  }, (name, lang) => {
    return "";
  }, "🛡️"),
  new Question("sib05", "sib", "text", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `ما كان كرتون ${name} المفضل؟`;
      case "fr": return `Quel était le dessin animé préféré de ${name} ?`;
      case "de": return `Was war ${name}s Lieblingscartoon?`;
      case "id": return `Kartun favorit ${name} apa?`;
      case "it": return `Qual era il cartone animato preferito di ${name}?`;
      case "ja": return `${name}の好きだったアニメは？`;
      case "ko": return `${name}이(가) 제일 좋아하던 만화는 뭐였어?`;
      case "pt": return `Qual era o desenho animado favorito do(a) ${name}?`;
      case "ru": return `Какой был любимый мультфильм у ${name}?`;
      case "es": return `¿Cuál era la caricatura favorita de ${name}?`;
      case "tr": return `${name}’in en sevdiği çizgi film hangisiydi?`;
      default: return `What was ${name}'s favorite cartoon?`;
    }
  }, "📺"),
  new Question("sib06", "sib", "text", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `ما هو طعام ${name} المفضل من طبخ أمي؟`;
      case "fr": return `Quel est le plat préféré de ${name} de maman ?`;
      case "de": return `Was ist ${name}s Lieblingsessen von Mama?`;
      case "id": return `Apa makanan favorit ${name} masakan mama?`;
      case "it": return `Qual è il piatto preferito di ${name} cucinato da mamma?`;
      case "ja": return `ママの料理で${name}の一番好きなものは？`;
      case "ko": return `엄마가 해준 음식 중 ${name}이(가) 제일 좋아하는 건 뭐야?`;
      case "pt": return `Qual é a comida favorita do(a) ${name} feita pela mamãe?`;
      case "ru": return `Какое любимое блюдо у ${name}, которое готовит мама?`;
      case "es": return `¿Cuál es la comida favorita de ${name} de mamá?`;
      case "tr": return `Annemin yaptığı ${name}’in en sevdiği yemek ne?`;
      default: return `What's ${name}'s favorite food from mom?`;
    }
  }, "🍝"),
  new Question("sib07", "sib", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من يسرق ملابس الآخر أكثر؟";
      case "fr": return "Qui vole le plus souvent les vêtements de l’autre ?";
      case "de": return "Wer klaut öfter die Klamotten vom anderen?";
      case "id": return "Siapa yang lebih sering pinjam baju saudaranya?";
      case "it": return "Chi ruba più spesso i vestiti dell’altro?";
      case "ja": return "相手の服をよく借りる（盗む）のはどっち？";
      case "ko": return "누가 더 자주 서로의 옷을 훔쳐 입어?";
      case "pt": return "Quem pega as roupas do outro mais vezes?";
      case "ru": return "Кто чаще таскает одежду у другого?";
      case "es": return "¿Quién roba la ropa del otro más a menudo?";
      case "tr": return "Kim diğerinin kıyafetlerini daha sık alır?";
      default: return "Who steals the other's clothes more often?";
    }
  }, (name, lang) => {
    return "";
  }, "👕"),
  new Question("sib08", "sib", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من يُحدث ضجيجًا أكثر في المنزل؟";
      case "fr": return "Qui fait le plus de bruit à la maison ?";
      case "de": return "Wer match mehr Lärm zuhause?";
      case "id": return "Siapa yang lebih berisik di rumah?";
      case "it": return "Chi fa più rumore a casa?";
      case "ja": return "家でよりうるさいのはどっち？";
      case "ko": return "집에서 누가 더 시끄러워?";
      case "pt": return "Quem faz mais barulho em casa?";
      case "ru": return "Кто шумит дома больше?";
      case "es": return "¿Quién hace más ruido en casa?";
      case "tr": return "Evde kim daha çok gürültü yapar?";
      default: return "Who makes more noise at home?";
    }
  }, (name, lang) => {
    return "";
  }, "📢"),
  new Question("sib09", "sib", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من كان يفلت من كل شيء دائمًا؟";
      case "fr": return "Qui s’en sortait toujours avec tout ?";
      case "de": return "Wer ist immer mit allem davon gekommen?";
      case "id": return "Siapa yang selalu lolos dari semuanya?";
      case "it": return "Chi se la cavava sempre con tutto?";
      case "ja": return "いつも何でも許されてたのはどっち？";
      case "ko": return "누가 항상 뭐든 다 넘어갔어?";
      case "pt": return "Quem sempre se safava de tudo?";
      case "ru": return "Кто всегда выходил(а) сухим(ой) из воды?";
      case "es": return "¿Quién siempre se salía con la suya?";
      case "tr": return "Kim her şeyden hep paçayı sıyırırdı?";
      default: return "Who got away with everything?";
    }
  }, (name, lang) => {
    return "";
  }, "🚪"),
  new Question("sib10", "sib", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من الأفضل في ألعاب الطاولة؟";
      case "fr": return "Qui est le/la meilleur(e) aux jeux de société ?";
      case "de": return "Wer ist besser bei Gesellschaftsspielen?";
      case "id": return "Siapa yang lebih jago main board game?";
      case "it": return "Chi è più bravo(a) ai giochi da tavolo?";
      case "ja": return "ボードゲームが強いのはどっち？";
      case "ko": return "보드게임을 더 잘하는 사람은 누구야?";
      case "pt": return "Quem é melhor em jogos de tabuleiro?";
      case "ru": return "Кто лучше играет в настольные игры?";
      case "es": return "¿Quién es mejor en los juegos de mesa?";
      case "tr": return "Kim kutu oyunlarında daha iyi?";
      default: return "Who's better at board games?";
    }
  }, (name, lang) => {
    return "";
  }, "🎲"),
  new Question("sib11", "sib", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من يحب التجمعات العائلية أكثر؟";
      case "fr": return "Qui aime le plus les événements familiaux ?";
      case "de": return "Wer mag Familienfeiern lieber?";
      case "id": return "Siapa yang lebih suka acara keluarga?";
      case "it": return "Chi ama di più gli eventi di famiglia?";
      case "ja": return "家族の集まりが好きなのはどっち？";
      case "ko": return "가족 모임을 더 좋아하는 사람은 누구야?";
      case "pt": return "Quem gosta mais de eventos de família?";
      case "ru": return "Кому больше нравятся семейные мероприятия?";
      case "es": return "¿A quién le gustan más los eventos familiares?";
      case "tr": return "Aile etkinliklerini kim daha çok sever?";
      default: return "Who likes family events more?";
    }
  }, (name, lang) => {
    return "";
  }, "🥳"),
  new Question("sib12", "sib", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من الأكثر فوضوية؟";
      case "fr": return "Qui est le/la plus en désordre ?";
      case "de": return "Wer ist unordentlicher?";
      case "id": return "Siapa yang lebih berantakan?";
      case "it": return "Chi è più disordinato(a)?";
      case "ja": return "散らかしてるのはどっち？";
      case "ko": return "누가 더 지저분해?";
      case "pt": return "Quem é mais bagunceiro(a)?";
      case "ru": return "Кто более неряшливый(ая)?";
      case "es": return "¿Quién es más desordenado(a)?";
      case "tr": return "Kim daha dağınık?";
      default: return "Who's messier?";
    }
  }, (name, lang) => {
    return "";
  }, "🧽"),
  new Question("sib13", "sib", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من يقلّد الآخر أكثر؟";
      case "fr": return "Qui copie l’autre le plus ?";
      case "de": return "Wer macht dem anderen alles nach?";
      case "id": return "Siapa yang lebih sering meniru yang lain?";
      case "it": return "Chi copia di più l’altro?";
      case "ja": return "相手の真似をよくするのはどっち？";
      case "ko": return "누가 더 자주 상대를 따라 해?";
      case "pt": return "Quem copia mais o outro?";
      case "ru": return "Кто больше копирует другого?";
      case "es": return "¿Quién copia más al otro?";
      case "tr": return "Kim diğerini daha çok taklit eder?";
      default: return "Who copies the other one more?";
    }
  }, (name, lang) => {
    return "";
  }, "🔁"),
  new Question("sib14", "sib", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من الأكثر إزعاجًا؟";
      case "fr": return "Qui est le/la plus agaçant(e) ?";
      case "de": return "Wer ist nerviger?";
      case "id": return "Siapa yang lebih menyebalkan?";
      case "it": return "Chi è più fastidioso(a)?";
      case "ja": return "よりうざいのはどっち？";
      case "ko": return "누가 더 짜증나?";
      case "pt": return "Quem é mais irritante?";
      case "ru": return "Кто более раздражающий?";
      case "es": return "¿Quién es más molesto(a)?";
      case "tr": return "Kim daha sinir bozucu?";
      default: return "Who's more annoying?";
    }
  }, (name, lang) => {
    return "";
  }, "🚨"),
  new Question("sib15", "sib", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من كان يأكل طعام الآخر أكثر؟";
      case "fr": return "Qui mangeait le plus souvent la nourriture de l’autre ?";
      case "de": return "Wer hat öfter das Essen vom anderen gegessen?";
      case "id": return "Siapa yang lebih sering makan makanan saudaranya?";
      case "it": return "Chi mangiava più spesso il cibo dell’altro?";
      case "ja": return "相手のごはんをよく食べてたのはどっち？";
      case "ko": return "누가 더 자주 상대 음식을 먹었어?";
      case "pt": return "Quem comia a comida do outro com mais frequência?";
      case "ru": return "Кто чаще ел(а) еду другого?";
      case "es": return "¿Quién se comía la comida del otro más a menudo?";
      case "tr": return "Kim daha sık diğerinin yemeğini yedi?";
      default: return "Who ate the other one's food more often?";
    }
  }, (name, lang) => {
    return "";
  }, "🍫"),
  new Question("sib16", "sib", "pickUser", lang => {
    switch (lang) {
      case "ar": return "ممن كان يُؤخذ هاتفه أكثر؟";
      case "fr": return "À qui confisquait-on le téléphone le plus souvent ?";
      case "de": return "Wem wurde häufiger das Handy weggenommen?";
      case "id": return "Siapa yang lebih sering disita HP-nya?";
      case "it": return "A chi veniva tolto il telefono più spesso?";
      case "ja": return "スマホをよく没収されてたのはどっち？";
      case "ko": return "누가 더 자주 휴대폰을 뺏겼어?";
      case "pt": return "De quem o celular era tirado com mais frequência?";
      case "ru": return "У кого чаще забирали телефон?";
      case "es": return "¿A quién le quitaban el teléfono más a menudo?";
      case "tr": return "Kimin telefonu daha sık elinden alınırdı?";
      default: return "Who got their phone taken away more often?";
    }
  }, (name, lang) => {
    return "";
  }, "📱"),
  new Question("sib17", "sib", "text", lang => {
    return "";
  }, (name, lang) => {
    switch (lang) {
      case "ar": return `من كان أفضل صديق لـ${name} في الطفولة؟`;
      case "fr": return `Qui était le/la meilleur(e) ami(e) de ${name} en grandissant ?`;
      case "de": return `Wer war ${name}s bester Freund in der Kindheit?`;
      case "id": return `Siapa sahabat ${name} saat kecil?`;
      case "it": return `Chi era il/la migliore amico(a) di ${name} da piccolo(a)?`;
      case "ja": return `${name}の子どもの頃の親友は誰だった？`;
      case "ko": return `${name}이(가) 어렸을 때 베프는 누구였어?`;
      case "pt": return `Quem foi o(a) melhor amigo(a) do(a) ${name} na infância?`;
      case "ru": return `Кто был лучшим другом ${name} в детстве?`;
      case "es": return `¿Quién fue el/la mejor amigo(a) de ${name} en la infancia?`;
      case "tr": return `${name} çocukken en yakın arkadaşı kimdi?`;
      default: return `Who was ${name}'s best friend growing up?`;
    }
  }, "🔗"),
  new Question("sib18", "sib", "pickUser", lang => {
    switch (lang) {
      case "ar": return "مع من كان والدانا أكثر صرامة؟";
      case "fr": return "Avec qui nos parents étaient-ils plus stricts ?";
      case "de": return "Mit wem waren unsere Eltern strenger?";
      case "id": return "Orang tua kita lebih galak ke siapa?";
      case "it": return "Con chi erano più severi i nostri genitori?";
      case "ja": return "両親が厳しかったのはどっち？";
      case "ko": return "부모님이 더 엄격했던 사람은 누구야?";
      case "pt": return "Com quem nossos pais eram mais rígidos?";
      case "ru": return "С кем наши родители были строже?";
      case "es": return "¿Con quién eran más estrictos nuestros padres?";
      case "tr": return "Ailemiz kime daha katıydı?";
      default: return "Who were our parents stricter with?";
    }
  }, (name, lang) => {
    return "";
  }, "‼"),
  new Question("sib19", "sib", "pickUser", lang => {
    switch (lang) {
      case "ar": return "من الأرجح أن ينسى عيد ميلاد الآخر؟";
      case "fr": return "Qui risque le plus d’oublier l’anniversaire de l’autre ?";
      case "de": return "Wer würde eher den Geburtstag des anderen vergessen?";
      case "id": return "Siapa yang lebih mungkin lupa ulang tahun saudaranya?";
      case "it": return "Chi è più probabile che dimentichi il compleanno dell’altro?";
      case "ja": return "相手の誕生日を忘れそうなのはどっち？";
      case "ko": return "누가 더 상대 생일을 잊을 것 같아?";
      case "pt": return "Quem tem mais chance de esquecer o aniversário do outro?";
      case "ru": return "Кто скорее забудет день рождения другого?";
      case "es": return "¿Quién es más probable que olvide el cumpleaños del otro?";
      case "tr": return "Kim diğerinin doğum gününü unutmaya daha yatkın?";
      default: return "Who's more likely to forget the others birthday?";
    }
  }, (name, lang) => {
    return "";
  }, "🎈"),
]